// form
"undefined" == typeof Shopify && (Shopify = {}),
    (window.form = window.form || {}),
    (form.cacheSelectors = function () {
        form.cache = {
            $html: $("html"),
            $body: $("body"),
            $recoverPasswordLink: $("#RecoverPassword"),
            $hideRecoverPasswordLink: $("#HideRecoverPasswordLink"),
            $recoverPasswordForm: $("#RecoverPasswordForm"),
            $customerLoginForm: $("#CustomerLoginForm"),
            $passwordResetSuccess: $("#ResetSuccess"),
        };
    }),
    (form.init = function () {
        form.cacheSelectors(), form.loginForms();
    }),
    (form.getHash = function () {
        return window.location.hash;
    }),
    (form.updateHash = function (a) {
        (window.location.hash = "#" + a),
            $("#" + a)
                .attr("tabindex", -1)
                .focus();
    }),
    (form.loginForms = function () {
        function a() {
            form.cache.$recoverPasswordForm.show(), form.cache.$customerLoginForm.hide();
        }
        function b() {
            form.cache.$recoverPasswordForm.hide(), form.cache.$customerLoginForm.show();
        }
        form.cache.$recoverPasswordLink.on("click", function (b) {
            b.preventDefault(), a();
        }),
            form.cache.$hideRecoverPasswordLink.on("click", function (a) {
                a.preventDefault(), b();
            }),
            "#recover" == form.getHash() && a();
    }),
    (form.resetPasswordSuccess = function () {
        form.cache.$passwordResetSuccess.show();
    }),
    $(form.init);
// easing
(function (e) {
    e.easing["jswing"] = e.easing["swing"];
    e.extend(e.easing, {
        def: "easeOutQuad",
        swing: function (t, n, r, i, s) {
            return e.easing[e.easing.def](t, n, r, i, s);
        },
        easeInQuad: function (e, t, n, r, i) {
            return r * (t /= i) * t + n;
        },
        easeOutQuad: function (e, t, n, r, i) {
            return -r * (t /= i) * (t - 2) + n;
        },
        easeInOutQuad: function (e, t, n, r, i) {
            if ((t /= i / 2) < 1) return (r / 2) * t * t + n;
            return (-r / 2) * (--t * (t - 2) - 1) + n;
        },
        easeInCubic: function (e, t, n, r, i) {
            return r * (t /= i) * t * t + n;
        },
        easeOutCubic: function (e, t, n, r, i) {
            return r * ((t = t / i - 1) * t * t + 1) + n;
        },
        easeInOutCubic: function (e, t, n, r, i) {
            if ((t /= i / 2) < 1) return (r / 2) * t * t * t + n;
            return (r / 2) * ((t -= 2) * t * t + 2) + n;
        },
        easeInQuart: function (e, t, n, r, i) {
            return r * (t /= i) * t * t * t + n;
        },
        easeOutQuart: function (e, t, n, r, i) {
            return -r * ((t = t / i - 1) * t * t * t - 1) + n;
        },
        easeInOutQuart: function (e, t, n, r, i) {
            if ((t /= i / 2) < 1) return (r / 2) * t * t * t * t + n;
            return (-r / 2) * ((t -= 2) * t * t * t - 2) + n;
        },
        easeInQuint: function (e, t, n, r, i) {
            return r * (t /= i) * t * t * t * t + n;
        },
        easeOutQuint: function (e, t, n, r, i) {
            return r * ((t = t / i - 1) * t * t * t * t + 1) + n;
        },
        easeInOutQuint: function (e, t, n, r, i) {
            if ((t /= i / 2) < 1) return (r / 2) * t * t * t * t * t + n;
            return (r / 2) * ((t -= 2) * t * t * t * t + 2) + n;
        },
        easeInSine: function (e, t, n, r, i) {
            return -r * Math.cos((t / i) * (Math.PI / 2)) + r + n;
        },
        easeOutSine: function (e, t, n, r, i) {
            return r * Math.sin((t / i) * (Math.PI / 2)) + n;
        },
        easeInOutSine: function (e, t, n, r, i) {
            return (-r / 2) * (Math.cos((Math.PI * t) / i) - 1) + n;
        },
        easeInExpo: function (e, t, n, r, i) {
            return t == 0 ? n : r * Math.pow(2, 10 * (t / i - 1)) + n;
        },
        easeOutExpo: function (e, t, n, r, i) {
            return t == i ? n + r : r * (-Math.pow(2, (-10 * t) / i) + 1) + n;
        },
        easeInOutExpo: function (e, t, n, r, i) {
            if (t == 0) return n;
            if (t == i) return n + r;
            if ((t /= i / 2) < 1) return (r / 2) * Math.pow(2, 10 * (t - 1)) + n;
            return (r / 2) * (-Math.pow(2, -10 * --t) + 2) + n;
        },
        easeInCirc: function (e, t, n, r, i) {
            return -r * (Math.sqrt(1 - (t /= i) * t) - 1) + n;
        },
        easeOutCirc: function (e, t, n, r, i) {
            return r * Math.sqrt(1 - (t = t / i - 1) * t) + n;
        },
        easeInOutCirc: function (e, t, n, r, i) {
            if ((t /= i / 2) < 1) return (-r / 2) * (Math.sqrt(1 - t * t) - 1) + n;
            return (r / 2) * (Math.sqrt(1 - (t -= 2) * t) + 1) + n;
        },
        easeInElastic: function (e, t, n, r, i) {
            var s = 1.70158;
            var o = 0;
            var u = r;
            if (t == 0) return n;
            if ((t /= i) == 1) return n + r;
            if (!o) o = i * 0.3;
            if (u < Math.abs(r)) {
                u = r;
                var s = o / 4;
            } else var s = (o / (2 * Math.PI)) * Math.asin(r / u);
            return -(u * Math.pow(2, 10 * (t -= 1)) * Math.sin(((t * i - s) * 2 * Math.PI) / o)) + n;
        },
        easeOutElastic: function (e, t, n, r, i) {
            var s = 1.70158;
            var o = 0;
            var u = r;
            if (t == 0) return n;
            if ((t /= i) == 1) return n + r;
            if (!o) o = i * 0.3;
            if (u < Math.abs(r)) {
                u = r;
                var s = o / 4;
            } else var s = (o / (2 * Math.PI)) * Math.asin(r / u);
            return u * Math.pow(2, -10 * t) * Math.sin(((t * i - s) * 2 * Math.PI) / o) + r + n;
        },
        easeInOutElastic: function (e, t, n, r, i) {
            var s = 1.70158;
            var o = 0;
            var u = r;
            if (t == 0) return n;
            if ((t /= i / 2) == 2) return n + r;
            if (!o) o = i * 0.3 * 1.5;
            if (u < Math.abs(r)) {
                u = r;
                var s = o / 4;
            } else var s = (o / (2 * Math.PI)) * Math.asin(r / u);
            if (t < 1) return -0.5 * u * Math.pow(2, 10 * (t -= 1)) * Math.sin(((t * i - s) * 2 * Math.PI) / o) + n;
            return u * Math.pow(2, -10 * (t -= 1)) * Math.sin(((t * i - s) * 2 * Math.PI) / o) * 0.5 + r + n;
        },
        easeInBack: function (e, t, n, r, i, s) {
            if (s == undefined) s = 1.70158;
            return r * (t /= i) * t * ((s + 1) * t - s) + n;
        },
        easeOutBack: function (e, t, n, r, i, s) {
            if (s == undefined) s = 1.70158;
            return r * ((t = t / i - 1) * t * ((s + 1) * t + s) + 1) + n;
        },
        easeInOutBack: function (e, t, n, r, i, s) {
            if (s == undefined) s = 1.70158;
            if ((t /= i / 2) < 1) return (r / 2) * t * t * (((s *= 1.525) + 1) * t - s) + n;
            return (r / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + n;
        },
        easeInBounce: function (t, n, r, i, s) {
            return i - e.easing.easeOutBounce(t, s - n, 0, i, s) + r;
        },
        easeOutBounce: function (e, t, n, r, i) {
            if ((t /= i) < 1 / 2.75) {
                return r * 7.5625 * t * t + n;
            } else if (t < 2 / 2.75) {
                return r * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + n;
            } else if (t < 2.5 / 2.75) {
                return r * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + n;
            } else {
                return r * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + n;
            }
        },
        easeInOutBounce: function (t, n, r, i, s) {
            if (n < s / 2) return e.easing.easeInBounce(t, n * 2, 0, i, s) * 0.5 + r;
            return e.easing.easeOutBounce(t, n * 2 - s, 0, i, s) * 0.5 + i * 0.5 + r;
        },
    });
    e.fn.extend({
        scrollToMe: function () {
            var t = jQuery(this).offset().top - 100;
            e("html,body").animate({ scrollTop: t }, 500);
        },
    });
})(jQuery);
/*imagesLoaded PACKAGED v4.1.4 * MIT License */
!(function (e, t) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.EvEmitter = t());
})("undefined" != typeof window ? window : this, function () {
    function e() {}
    var t = e.prototype;
    return (
        (t.on = function (e, t) {
            if (e && t) {
                var i = (this._events = this._events || {}),
                    n = (i[e] = i[e] || []);
                return n.indexOf(t) == -1 && n.push(t), this;
            }
        }),
        (t.once = function (e, t) {
            if (e && t) {
                this.on(e, t);
                var i = (this._onceEvents = this._onceEvents || {}),
                    n = (i[e] = i[e] || {});
                return (n[t] = !0), this;
            }
        }),
        (t.off = function (e, t) {
            var i = this._events && this._events[e];
            if (i && i.length) {
                var n = i.indexOf(t);
                return n != -1 && i.splice(n, 1), this;
            }
        }),
        (t.emitEvent = function (e, t) {
            var i = this._events && this._events[e];
            if (i && i.length) {
                (i = i.slice(0)), (t = t || []);
                for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
                    var r = i[o],
                        s = n && n[r];
                    s && (this.off(e, r), delete n[r]), r.apply(this, t);
                }
                return this;
            }
        }),
        (t.allOff = function () {
            delete this._events, delete this._onceEvents;
        }),
        e
    );
}),
    (function (e, t) {
        "use strict";
        "function" == typeof define && define.amd
            ? define(["ev-emitter/ev-emitter"], function (i) {
                  return t(e, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(e, require("ev-emitter")))
            : (e.imagesLoaded = t(e, e.EvEmitter));
    })("undefined" != typeof window ? window : this, function (e, t) {
        function i(e, t) {
            for (var i in t) e[i] = t[i];
            return e;
        }
        function n(e) {
            if (Array.isArray(e)) return e;
            var t = "object" == typeof e && "number" == typeof e.length;
            return t ? d.call(e) : [e];
        }
        function o(e, t, r) {
            if (!(this instanceof o)) return new o(e, t, r);
            var s = e;
            return (
                "string" == typeof e && (s = document.querySelectorAll(e)),
                s
                    ? ((this.elements = n(s)),
                      (this.options = i({}, this.options)),
                      "function" == typeof t ? (r = t) : i(this.options, t),
                      r && this.on("always", r),
                      this.getImages(),
                      h && (this.jqDeferred = new h.Deferred()),
                      void setTimeout(this.check.bind(this)))
                    : void a.error("Bad element for imagesLoaded " + (s || e))
            );
        }
        function r(e) {
            this.img = e;
        }
        function s(e, t) {
            (this.url = e), (this.element = t), (this.img = new Image());
        }
        var h = e.jQuery,
            a = e.console,
            d = Array.prototype.slice;
        (o.prototype = Object.create(t.prototype)),
            (o.prototype.options = {}),
            (o.prototype.getImages = function () {
                (this.images = []), this.elements.forEach(this.addElementImages, this);
            }),
            (o.prototype.addElementImages = function (e) {
                "IMG" == e.nodeName && this.addImage(e), this.options.background === !0 && this.addElementBackgroundImages(e);
                var t = e.nodeType;
                if (t && u[t]) {
                    for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
                        var o = i[n];
                        this.addImage(o);
                    }
                    if ("string" == typeof this.options.background) {
                        var r = e.querySelectorAll(this.options.background);
                        for (n = 0; n < r.length; n++) {
                            var s = r[n];
                            this.addElementBackgroundImages(s);
                        }
                    }
                }
            });
        var u = { 1: !0, 9: !0, 11: !0 };
        return (
            (o.prototype.addElementBackgroundImages = function (e) {
                var t = getComputedStyle(e);
                if (t)
                    for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n; ) {
                        var o = n && n[2];
                        o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
                    }
            }),
            (o.prototype.addImage = function (e) {
                var t = new r(e);
                this.images.push(t);
            }),
            (o.prototype.addBackground = function (e, t) {
                var i = new s(e, t);
                this.images.push(i);
            }),
            (o.prototype.check = function () {
                function e(e, i, n) {
                    setTimeout(function () {
                        t.progress(e, i, n);
                    });
                }
                var t = this;
                return (
                    (this.progressedCount = 0),
                    (this.hasAnyBroken = !1),
                    this.images.length
                        ? void this.images.forEach(function (t) {
                              t.once("progress", e), t.check();
                          })
                        : void this.complete()
                );
            }),
            (o.prototype.progress = function (e, t, i) {
                this.progressedCount++,
                    (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
                    this.emitEvent("progress", [this, e, t]),
                    this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e),
                    this.progressedCount == this.images.length && this.complete(),
                    this.options.debug && a && a.log("progress: " + i, e, t);
            }),
            (o.prototype.complete = function () {
                var e = this.hasAnyBroken ? "fail" : "done";
                if (((this.isComplete = !0), this.emitEvent(e, [this]), this.emitEvent("always", [this]), this.jqDeferred)) {
                    var t = this.hasAnyBroken ? "reject" : "resolve";
                    this.jqDeferred[t](this);
                }
            }),
            (r.prototype = Object.create(t.prototype)),
            (r.prototype.check = function () {
                var e = this.getIsImageComplete();
                return e
                    ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                    : ((this.proxyImage = new Image()),
                      this.proxyImage.addEventListener("load", this),
                      this.proxyImage.addEventListener("error", this),
                      this.img.addEventListener("load", this),
                      this.img.addEventListener("error", this),
                      void (this.proxyImage.src = this.img.src));
            }),
            (r.prototype.getIsImageComplete = function () {
                return this.img.complete && this.img.naturalWidth;
            }),
            (r.prototype.confirm = function (e, t) {
                (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
            }),
            (r.prototype.handleEvent = function (e) {
                var t = "on" + e.type;
                this[t] && this[t](e);
            }),
            (r.prototype.onload = function () {
                this.confirm(!0, "onload"), this.unbindEvents();
            }),
            (r.prototype.onerror = function () {
                this.confirm(!1, "onerror"), this.unbindEvents();
            }),
            (r.prototype.unbindEvents = function () {
                this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (s.prototype = Object.create(r.prototype)),
            (s.prototype.check = function () {
                this.img.addEventListener("load", this), this.img.addEventListener("error", this), (this.img.src = this.url);
                var e = this.getIsImageComplete();
                e && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
            }),
            (s.prototype.unbindEvents = function () {
                this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
            }),
            (s.prototype.confirm = function (e, t) {
                (this.isLoaded = e), this.emitEvent("progress", [this, this.element, t]);
            }),
            (o.makeJQueryPlugin = function (t) {
                (t = t || e.jQuery),
                    t &&
                        ((h = t),
                        (h.fn.imagesLoaded = function (e, t) {
                            var i = new o(this, e, t);
                            return i.jqDeferred.promise(h(this));
                        }));
            }),
            o.makeJQueryPlugin(),
            o
        );
    });
// Packery PACKAGED
!(function (a) {
    function b() {}
    function c(a) {
        function c(b) {
            b.prototype.option ||
                (b.prototype.option = function (b) {
                    a.isPlainObject(b) && (this.options = a.extend(!0, this.options, b));
                });
        }
        function e(b, c) {
            a.fn[b] = function (e) {
                if ("string" == typeof e) {
                    for (var g = d.call(arguments, 1), h = 0, i = this.length; i > h; h++) {
                        var j = this[h],
                            k = a.data(j, b);
                        if (k)
                            if (a.isFunction(k[e]) && "_" !== e.charAt(0)) {
                                var l = k[e].apply(k, g);
                                if (void 0 !== l) return l;
                            } else f("no such method '" + e + "' for " + b + " instance");
                        else f("cannot call methods on " + b + " prior to initialization; attempted to call '" + e + "'");
                    }
                    return this;
                }
                return this.each(function () {
                    var d = a.data(this, b);
                    d ? (d.option(e), d._init()) : ((d = new c(this, e)), a.data(this, b, d));
                });
            };
        }
        if (a) {
            var f =
                "undefined" == typeof console
                    ? b
                    : function (a) {
                          console.error(a);
                      };
            return (
                (a.bridget = function (a, b) {
                    c(b), e(a, b);
                }),
                a.bridget
            );
        }
    }
    var d = Array.prototype.slice;
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery.bridget", ["jquery"], c) : c("object" == typeof exports ? require("jquery") : a.jQuery);
})(window),
    (function (a) {
        function b(a) {
            return new RegExp("(^|\\s+)" + a + "(\\s+|$)");
        }
        function c(a, b) {
            var c = d(a, b) ? f : e;
            c(a, b);
        }
        var d, e, f;
        "classList" in document.documentElement
            ? ((d = function (a, b) {
                  return a.classList.contains(b);
              }),
              (e = function (a, b) {
                  a.classList.add(b);
              }),
              (f = function (a, b) {
                  a.classList.remove(b);
              }))
            : ((d = function (a, c) {
                  return b(c).test(a.className);
              }),
              (e = function (a, b) {
                  d(a, b) || (a.className = a.className + " " + b);
              }),
              (f = function (a, c) {
                  a.className = a.className.replace(b(c), " ");
              }));
        var g = { hasClass: d, addClass: e, removeClass: f, toggleClass: c, has: d, add: e, remove: f, toggle: c };
        "function" == typeof define && define.amd ? define("classie/classie", g) : "object" == typeof exports ? (module.exports = g) : (a.classie = g);
    })(window),
    (function (a) {
        function b(a) {
            if (a) {
                if ("string" == typeof d[a]) return a;
                a = a.charAt(0).toUpperCase() + a.slice(1);
                for (var b, e = 0, f = c.length; f > e; e++) if (((b = c[e] + a), "string" == typeof d[b])) return b;
            }
        }
        var c = "Webkit Moz ms Ms O".split(" "),
            d = document.documentElement.style;
        "function" == typeof define && define.amd
            ? define("get-style-property/get-style-property", [], function () {
                  return b;
              })
            : "object" == typeof exports
            ? (module.exports = b)
            : (a.getStyleProperty = b);
    })(window),
    (function (a, b) {
        function c(a) {
            var b = parseFloat(a),
                c = -1 === a.indexOf("%") && !isNaN(b);
            return c && b;
        }
        function d() {}
        function e() {
            for (var a = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, b = 0, c = h.length; c > b; b++) {
                var d = h[b];
                a[d] = 0;
            }
            return a;
        }
        function f(b) {
            function d() {
                if (!m) {
                    m = !0;
                    var d = a.getComputedStyle;
                    if (
                        ((j = (function () {
                            var a = d
                                ? function (a) {
                                      return d(a, null);
                                  }
                                : function (a) {
                                      return a.currentStyle;
                                  };
                            return function (b) {
                                var c = a(b);
                                return c || g("Style returned " + c + ". Are you running this code in a hidden iframe on Firefox? See http://bit.ly/getsizebug1"), c;
                            };
                        })()),
                        (k = b("boxSizing")))
                    ) {
                        var e = document.createElement("div");
                        (e.style.width = "200px"), (e.style.padding = "1px 2px 3px 4px"), (e.style.borderStyle = "solid"), (e.style.borderWidth = "1px 2px 3px 4px"), (e.style[k] = "border-box");
                        var f = document.body || document.documentElement;
                        f.appendChild(e);
                        var h = j(e);
                        (l = 200 === c(h.width)), f.removeChild(e);
                    }
                }
            }
            function f(a) {
                if ((d(), "string" == typeof a && (a = document.querySelector(a)), a && "object" == typeof a && a.nodeType)) {
                    var b = j(a);
                    if ("none" === b.display) return e();
                    var f = {};
                    (f.width = a.offsetWidth), (f.height = a.offsetHeight);
                    for (var g = (f.isBorderBox = !(!k || !b[k] || "border-box" !== b[k])), m = 0, n = h.length; n > m; m++) {
                        var o = h[m],
                            p = b[o];
                        p = i(a, p);
                        var q = parseFloat(p);
                        f[o] = isNaN(q) ? 0 : q;
                    }
                    var r = f.paddingLeft + f.paddingRight,
                        s = f.paddingTop + f.paddingBottom,
                        t = f.marginLeft + f.marginRight,
                        u = f.marginTop + f.marginBottom,
                        v = f.borderLeftWidth + f.borderRightWidth,
                        w = f.borderTopWidth + f.borderBottomWidth,
                        x = g && l,
                        y = c(b.width);
                    y !== !1 && (f.width = y + (x ? 0 : r + v));
                    var z = c(b.height);
                    return z !== !1 && (f.height = z + (x ? 0 : s + w)), (f.innerWidth = f.width - (r + v)), (f.innerHeight = f.height - (s + w)), (f.outerWidth = f.width + t), (f.outerHeight = f.height + u), f;
                }
            }
            function i(b, c) {
                if (a.getComputedStyle || -1 === c.indexOf("%")) return c;
                var d = b.style,
                    e = d.left,
                    f = b.runtimeStyle,
                    g = f && f.left;
                return g && (f.left = b.currentStyle.left), (d.left = c), (c = d.pixelLeft), (d.left = e), g && (f.left = g), c;
            }
            var j,
                k,
                l,
                m = !1;
            return f;
        }
        var g =
                "undefined" == typeof console
                    ? d
                    : function (a) {
                          console.error(a);
                      },
            h = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
        "function" == typeof define && define.amd
            ? define("get-size/get-size", ["get-style-property/get-style-property"], f)
            : "object" == typeof exports
            ? (module.exports = f(require("desandro-get-style-property")))
            : (a.getSize = f(a.getStyleProperty));
    })(window),
    (function (a) {
        function b(b) {
            var c = a.event;
            return (c.target = c.target || c.srcElement || b), c;
        }
        var c = document.documentElement,
            d = function () {};
        c.addEventListener
            ? (d = function (a, b, c) {
                  a.addEventListener(b, c, !1);
              })
            : c.attachEvent &&
              (d = function (a, c, d) {
                  (a[c + d] = d.handleEvent
                      ? function () {
                            var c = b(a);
                            d.handleEvent.call(d, c);
                        }
                      : function () {
                            var c = b(a);
                            d.call(a, c);
                        }),
                      a.attachEvent("on" + c, a[c + d]);
              });
        var e = function () {};
        c.removeEventListener
            ? (e = function (a, b, c) {
                  a.removeEventListener(b, c, !1);
              })
            : c.detachEvent &&
              (e = function (a, b, c) {
                  a.detachEvent("on" + b, a[b + c]);
                  try {
                      delete a[b + c];
                  } catch (d) {
                      a[b + c] = void 0;
                  }
              });
        var f = { bind: d, unbind: e };
        "function" == typeof define && define.amd ? define("eventie/eventie", f) : "object" == typeof exports ? (module.exports = f) : (a.eventie = f);
    })(window),
    function () {
        function a() {}
        function b(a, b) {
            for (var c = a.length; c--; ) if (a[c].listener === b) return c;
            return -1;
        }
        function c(a) {
            return function () {
                return this[a].apply(this, arguments);
            };
        }
        var d = a.prototype,
            e = this,
            f = e.EventEmitter;
        (d.getListeners = function (a) {
            var b,
                c,
                d = this._getEvents();
            if (a instanceof RegExp) {
                b = {};
                for (c in d) d.hasOwnProperty(c) && a.test(c) && (b[c] = d[c]);
            } else b = d[a] || (d[a] = []);
            return b;
        }),
            (d.flattenListeners = function (a) {
                var b,
                    c = [];
                for (b = 0; b < a.length; b += 1) c.push(a[b].listener);
                return c;
            }),
            (d.getListenersAsObject = function (a) {
                var b,
                    c = this.getListeners(a);
                return c instanceof Array && ((b = {}), (b[a] = c)), b || c;
            }),
            (d.addListener = function (a, c) {
                var d,
                    e = this.getListenersAsObject(a),
                    f = "object" == typeof c;
                for (d in e) e.hasOwnProperty(d) && -1 === b(e[d], c) && e[d].push(f ? c : { listener: c, once: !1 });
                return this;
            }),
            (d.on = c("addListener")),
            (d.addOnceListener = function (a, b) {
                return this.addListener(a, { listener: b, once: !0 });
            }),
            (d.once = c("addOnceListener")),
            (d.defineEvent = function (a) {
                return this.getListeners(a), this;
            }),
            (d.defineEvents = function (a) {
                for (var b = 0; b < a.length; b += 1) this.defineEvent(a[b]);
                return this;
            }),
            (d.removeListener = function (a, c) {
                var d,
                    e,
                    f = this.getListenersAsObject(a);
                for (e in f) f.hasOwnProperty(e) && ((d = b(f[e], c)), -1 !== d && f[e].splice(d, 1));
                return this;
            }),
            (d.off = c("removeListener")),
            (d.addListeners = function (a, b) {
                return this.manipulateListeners(!1, a, b);
            }),
            (d.removeListeners = function (a, b) {
                return this.manipulateListeners(!0, a, b);
            }),
            (d.manipulateListeners = function (a, b, c) {
                var d,
                    e,
                    f = a ? this.removeListener : this.addListener,
                    g = a ? this.removeListeners : this.addListeners;
                if ("object" != typeof b || b instanceof RegExp) for (d = c.length; d--; ) f.call(this, b, c[d]);
                else for (d in b) b.hasOwnProperty(d) && (e = b[d]) && ("function" == typeof e ? f.call(this, d, e) : g.call(this, d, e));
                return this;
            }),
            (d.removeEvent = function (a) {
                var b,
                    c = typeof a,
                    d = this._getEvents();
                if ("string" === c) delete d[a];
                else if (a instanceof RegExp) for (b in d) d.hasOwnProperty(b) && a.test(b) && delete d[b];
                else delete this._events;
                return this;
            }),
            (d.removeAllListeners = c("removeEvent")),
            (d.emitEvent = function (a, b) {
                var c,
                    d,
                    e,
                    f,
                    g = this.getListenersAsObject(a);
                for (e in g)
                    if (g.hasOwnProperty(e))
                        for (d = g[e].length; d--; ) (c = g[e][d]), c.once === !0 && this.removeListener(a, c.listener), (f = c.listener.apply(this, b || [])), f === this._getOnceReturnValue() && this.removeListener(a, c.listener);
                return this;
            }),
            (d.trigger = c("emitEvent")),
            (d.emit = function (a) {
                var b = Array.prototype.slice.call(arguments, 1);
                return this.emitEvent(a, b);
            }),
            (d.setOnceReturnValue = function (a) {
                return (this._onceReturnValue = a), this;
            }),
            (d._getOnceReturnValue = function () {
                return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0;
            }),
            (d._getEvents = function () {
                return this._events || (this._events = {});
            }),
            (a.noConflict = function () {
                return (e.EventEmitter = f), a;
            }),
            "function" == typeof define && define.amd
                ? define("eventEmitter/EventEmitter", [], function () {
                      return a;
                  })
                : "object" == typeof module && module.exports
                ? (module.exports = a)
                : (e.EventEmitter = a);
    }.call(this),
    (function (a) {
        function b(a) {
            "function" == typeof a && (b.isReady ? a() : g.push(a));
        }
        function c(a) {
            var c = "readystatechange" === a.type && "complete" !== f.readyState;
            b.isReady || c || d();
        }
        function d() {
            b.isReady = !0;
            for (var a = 0, c = g.length; c > a; a++) {
                var d = g[a];
                d();
            }
        }
        function e(e) {
            return "complete" === f.readyState ? d() : (e.bind(f, "DOMContentLoaded", c), e.bind(f, "readystatechange", c), e.bind(a, "load", c)), b;
        }
        var f = a.document,
            g = [];
        (b.isReady = !1), "function" == typeof define && define.amd ? define("doc-ready/doc-ready", ["eventie/eventie"], e) : "object" == typeof exports ? (module.exports = e(require("eventie"))) : (a.docReady = e(a.eventie));
    })(window),
    (function (a) {
        function b(a, b) {
            return a[g](b);
        }
        function c(a) {
            if (!a.parentNode) {
                var b = document.createDocumentFragment();
                b.appendChild(a);
            }
        }
        function d(a, b) {
            c(a);
            for (var d = a.parentNode.querySelectorAll(b), e = 0, f = d.length; f > e; e++) if (d[e] === a) return !0;
            return !1;
        }
        function e(a, d) {
            return c(a), b(a, d);
        }
        var f,
            g = (function () {
                if (a.matches) return "matches";
                if (a.matchesSelector) return "matchesSelector";
                for (var b = ["webkit", "moz", "ms", "o"], c = 0, d = b.length; d > c; c++) {
                    var e = b[c],
                        f = e + "MatchesSelector";
                    if (a[f]) return f;
                }
            })();
        if (g) {
            var h = document.createElement("div"),
                i = b(h, "div");
            f = i ? b : e;
        } else f = d;
        "function" == typeof define && define.amd
            ? define("matches-selector/matches-selector", [], function () {
                  return f;
              })
            : "object" == typeof exports
            ? (module.exports = f)
            : (window.matchesSelector = f);
    })(Element.prototype),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["doc-ready/doc-ready", "matches-selector/matches-selector"], function (c, d) {
                  return b(a, c, d);
              })
            : "object" == typeof exports
            ? (module.exports = b(a, require("doc-ready"), require("desandro-matches-selector")))
            : (a.fizzyUIUtils = b(a, a.docReady, a.matchesSelector));
    })(window, function (a, b, c) {
        var d = {};
        (d.extend = function (a, b) {
            for (var c in b) a[c] = b[c];
            return a;
        }),
            (d.modulo = function (a, b) {
                return ((a % b) + b) % b;
            });
        var e = Object.prototype.toString;
        (d.isArray = function (a) {
            return "[object Array]" == e.call(a);
        }),
            (d.makeArray = function (a) {
                var b = [];
                if (d.isArray(a)) b = a;
                else if (a && "number" == typeof a.length) for (var c = 0, e = a.length; e > c; c++) b.push(a[c]);
                else b.push(a);
                return b;
            }),
            (d.indexOf = Array.prototype.indexOf
                ? function (a, b) {
                      return a.indexOf(b);
                  }
                : function (a, b) {
                      for (var c = 0, d = a.length; d > c; c++) if (a[c] === b) return c;
                      return -1;
                  }),
            (d.removeFrom = function (a, b) {
                var c = d.indexOf(a, b);
                -1 != c && a.splice(c, 1);
            }),
            (d.isElement =
                "function" == typeof HTMLElement || "object" == typeof HTMLElement
                    ? function (a) {
                          return a instanceof HTMLElement;
                      }
                    : function (a) {
                          return a && "object" == typeof a && 1 == a.nodeType && "string" == typeof a.nodeName;
                      }),
            (d.setText = (function () {
                function a(a, c) {
                    (b = b || (void 0 !== document.documentElement.textContent ? "textContent" : "innerText")), (a[b] = c);
                }
                var b;
                return a;
            })()),
            (d.getParent = function (a, b) {
                for (; a != document.body; ) if (((a = a.parentNode), c(a, b))) return a;
            }),
            (d.getQueryElement = function (a) {
                return "string" == typeof a ? document.querySelector(a) : a;
            }),
            (d.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (d.filterFindElements = function (a, b) {
                a = d.makeArray(a);
                for (var e = [], f = 0, g = a.length; g > f; f++) {
                    var h = a[f];
                    if (d.isElement(h))
                        if (b) {
                            c(h, b) && e.push(h);
                            for (var i = h.querySelectorAll(b), j = 0, k = i.length; k > j; j++) e.push(i[j]);
                        } else e.push(h);
                }
                return e;
            }),
            (d.debounceMethod = function (a, b, c) {
                var d = a.prototype[b],
                    e = b + "Timeout";
                a.prototype[b] = function () {
                    var a = this[e];
                    a && clearTimeout(a);
                    var b = arguments,
                        f = this;
                    this[e] = setTimeout(function () {
                        d.apply(f, b), delete f[e];
                    }, c || 100);
                };
            }),
            (d.toDashed = function (a) {
                return a
                    .replace(/(.)([A-Z])/g, function (a, b, c) {
                        return b + "-" + c;
                    })
                    .toLowerCase();
            });
        var f = a.console;
        return (
            (d.htmlInit = function (c, e) {
                b(function () {
                    for (var b = d.toDashed(e), g = document.querySelectorAll(".js-" + b), h = "data-" + b + "-options", i = 0, j = g.length; j > i; i++) {
                        var k,
                            l = g[i],
                            m = l.getAttribute(h);
                        try {
                            k = m && JSON.parse(m);
                        } catch (n) {
                            f && f.error("Error parsing " + h + " on " + l.nodeName.toLowerCase() + (l.id ? "#" + l.id : "") + ": " + n);
                            continue;
                        }
                        var o = new c(l, k),
                            p = a.jQuery;
                        p && p.data(l, e, o);
                    }
                });
            }),
            d
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("outlayer/item", ["eventEmitter/EventEmitter", "get-size/get-size", "get-style-property/get-style-property", "fizzy-ui-utils/utils"], function (c, d, e, f) {
                  return b(a, c, d, e, f);
              })
            : "object" == typeof exports
            ? (module.exports = b(a, require("wolfy87-eventemitter"), require("get-size"), require("desandro-get-style-property"), require("fizzy-ui-utils")))
            : ((a.Outlayer = {}), (a.Outlayer.Item = b(a, a.EventEmitter, a.getSize, a.getStyleProperty, a.fizzyUIUtils)));
    })(window, function (a, b, c, d, e) {
        function f(a) {
            for (var b in a) return !1;
            return (b = null), !0;
        }
        function g(a, b) {
            a && ((this.element = a), (this.layout = b), (this.position = { x: 0, y: 0 }), this._create());
        }
        function h(a) {
            return a.replace(/([A-Z])/g, function (a) {
                return "-" + a.toLowerCase();
            });
        }
        var i = a.getComputedStyle,
            j = i
                ? function (a) {
                      return i(a, null);
                  }
                : function (a) {
                      return a.currentStyle;
                  },
            k = d("transition"),
            l = d("transform"),
            m = k && l,
            n = !!d("perspective"),
            o = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "otransitionend", transition: "transitionend" }[k],
            p = ["transform", "transition", "transitionDuration", "transitionProperty"],
            q = (function () {
                for (var a = {}, b = 0, c = p.length; c > b; b++) {
                    var e = p[b],
                        f = d(e);
                    f && f !== e && (a[e] = f);
                }
                return a;
            })();
        e.extend(g.prototype, b.prototype),
            (g.prototype._create = function () {
                (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }), this.css({ position: "absolute" });
            }),
            (g.prototype.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (g.prototype.getSize = function () {
                this.size = c(this.element);
            }),
            (g.prototype.css = function (a) {
                var b = this.element.style;
                for (var c in a) {
                    var d = q[c] || c;
                    b[d] = a[c];
                }
            }),
            (g.prototype.getPosition = function () {
                var a = j(this.element),
                    b = this.layout.options,
                    c = b.isOriginLeft,
                    d = b.isOriginTop,
                    e = a[c ? "left" : "right"],
                    f = a[d ? "top" : "bottom"],
                    g = this.layout.size,
                    h = -1 != e.indexOf("%") ? (parseFloat(e) / 100) * g.width : parseInt(e, 10),
                    i = -1 != f.indexOf("%") ? (parseFloat(f) / 100) * g.height : parseInt(f, 10);
                (h = isNaN(h) ? 0 : h), (i = isNaN(i) ? 0 : i), (h -= c ? g.paddingLeft : g.paddingRight), (i -= d ? g.paddingTop : g.paddingBottom), (this.position.x = h), (this.position.y = i);
            }),
            (g.prototype.layoutPosition = function () {
                var a = this.layout.size,
                    b = this.layout.options,
                    c = {},
                    d = b.isOriginLeft ? "paddingLeft" : "paddingRight",
                    e = b.isOriginLeft ? "left" : "right",
                    f = b.isOriginLeft ? "right" : "left",
                    g = this.position.x + a[d];
                (c[e] = this.getXValue(g)), (c[f] = "");
                var h = b.isOriginTop ? "paddingTop" : "paddingBottom",
                    i = b.isOriginTop ? "top" : "bottom",
                    j = b.isOriginTop ? "bottom" : "top",
                    k = this.position.y + a[h];
                (c[i] = this.getYValue(k)), (c[j] = ""), this.css(c), this.emitEvent("layout", [this]);
            }),
            (g.prototype.getXValue = function (a) {
                var b = this.layout.options;
                return b.percentPosition && !b.isHorizontal ? (a / this.layout.size.width) * 100 + "%" : a + "px";
            }),
            (g.prototype.getYValue = function (a) {
                var b = this.layout.options;
                return b.percentPosition && b.isHorizontal ? (a / this.layout.size.height) * 100 + "%" : a + "px";
            }),
            (g.prototype._transitionTo = function (a, b) {
                this.getPosition();
                var c = this.position.x,
                    d = this.position.y,
                    e = parseInt(a, 10),
                    f = parseInt(b, 10),
                    g = e === this.position.x && f === this.position.y;
                if ((this.setPosition(a, b), g && !this.isTransitioning)) return void this.layoutPosition();
                var h = a - c,
                    i = b - d,
                    j = {};
                (j.transform = this.getTranslate(h, i)), this.transition({ to: j, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: !0 });
            }),
            (g.prototype.getTranslate = function (a, b) {
                var c = this.layout.options;
                return (a = c.isOriginLeft ? a : -a), (b = c.isOriginTop ? b : -b), n ? "translate3d(" + a + "px, " + b + "px, 0)" : "translate(" + a + "px, " + b + "px)";
            }),
            (g.prototype.goTo = function (a, b) {
                this.setPosition(a, b), this.layoutPosition();
            }),
            (g.prototype.moveTo = m ? g.prototype._transitionTo : g.prototype.goTo),
            (g.prototype.setPosition = function (a, b) {
                (this.position.x = parseInt(a, 10)), (this.position.y = parseInt(b, 10));
            }),
            (g.prototype._nonTransition = function (a) {
                this.css(a.to), a.isCleaning && this._removeStyles(a.to);
                for (var b in a.onTransitionEnd) a.onTransitionEnd[b].call(this);
            }),
            (g.prototype._transition = function (a) {
                if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(a);
                var b = this._transn;
                for (var c in a.onTransitionEnd) b.onEnd[c] = a.onTransitionEnd[c];
                for (c in a.to) (b.ingProperties[c] = !0), a.isCleaning && (b.clean[c] = !0);
                if (a.from) {
                    this.css(a.from);
                    var d = this.element.offsetHeight;
                    d = null;
                }
                this.enableTransition(a.to), this.css(a.to), (this.isTransitioning = !0);
            });
        var r = "opacity," + h(q.transform || "transform");
        (g.prototype.enableTransition = function () {
            this.isTransitioning || (this.css({ transitionProperty: r, transitionDuration: this.layout.options.transitionDuration }), this.element.addEventListener(o, this, !1));
        }),
            (g.prototype.transition = g.prototype[k ? "_transition" : "_nonTransition"]),
            (g.prototype.onwebkitTransitionEnd = function (a) {
                this.ontransitionend(a);
            }),
            (g.prototype.onotransitionend = function (a) {
                this.ontransitionend(a);
            });
        var s = { "-webkit-transform": "transform", "-moz-transform": "transform", "-o-transform": "transform" };
        (g.prototype.ontransitionend = function (a) {
            if (a.target === this.element) {
                var b = this._transn,
                    c = s[a.propertyName] || a.propertyName;
                if ((delete b.ingProperties[c], f(b.ingProperties) && this.disableTransition(), c in b.clean && ((this.element.style[a.propertyName] = ""), delete b.clean[c]), c in b.onEnd)) {
                    var d = b.onEnd[c];
                    d.call(this), delete b.onEnd[c];
                }
                this.emitEvent("transitionEnd", [this]);
            }
        }),
            (g.prototype.disableTransition = function () {
                this.removeTransitionStyles(), this.element.removeEventListener(o, this, !1), (this.isTransitioning = !1);
            }),
            (g.prototype._removeStyles = function (a) {
                var b = {};
                for (var c in a) b[c] = "";
                this.css(b);
            });
        var t = { transitionProperty: "", transitionDuration: "" };
        return (
            (g.prototype.removeTransitionStyles = function () {
                this.css(t);
            }),
            (g.prototype.removeElem = function () {
                this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]);
            }),
            (g.prototype.remove = function () {
                if (!k || !parseFloat(this.layout.options.transitionDuration)) return void this.removeElem();
                var a = this;
                this.once("transitionEnd", function () {
                    a.removeElem();
                }),
                    this.hide();
            }),
            (g.prototype.reveal = function () {
                delete this.isHidden, this.css({ display: "" });
                var a = this.layout.options,
                    b = {},
                    c = this.getHideRevealTransitionEndProperty("visibleStyle");
                (b[c] = this.onRevealTransitionEnd), this.transition({ from: a.hiddenStyle, to: a.visibleStyle, isCleaning: !0, onTransitionEnd: b });
            }),
            (g.prototype.onRevealTransitionEnd = function () {
                this.isHidden || this.emitEvent("reveal");
            }),
            (g.prototype.getHideRevealTransitionEndProperty = function (a) {
                var b = this.layout.options[a];
                if (b.opacity) return "opacity";
                for (var c in b) return c;
            }),
            (g.prototype.hide = function () {
                (this.isHidden = !0), this.css({ display: "" });
                var a = this.layout.options,
                    b = {},
                    c = this.getHideRevealTransitionEndProperty("hiddenStyle");
                (b[c] = this.onHideTransitionEnd), this.transition({ from: a.visibleStyle, to: a.hiddenStyle, isCleaning: !0, onTransitionEnd: b });
            }),
            (g.prototype.onHideTransitionEnd = function () {
                this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
            }),
            (g.prototype.destroy = function () {
                this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
            }),
            g
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("outlayer/outlayer", ["eventie/eventie", "eventEmitter/EventEmitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (c, d, e, f, g) {
                  return b(a, c, d, e, f, g);
              })
            : "object" == typeof exports
            ? (module.exports = b(a, require("eventie"), require("wolfy87-eventemitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")))
            : (a.Outlayer = b(a, a.eventie, a.EventEmitter, a.getSize, a.fizzyUIUtils, a.Outlayer.Item));
    })(window, function (a, b, c, d, e, f) {
        function g(a, b) {
            var c = e.getQueryElement(a);
            if (!c) return void (h && h.error("Bad element for " + this.constructor.namespace + ": " + (c || a)));
            (this.element = c), i && (this.$element = i(this.element)), (this.options = e.extend({}, this.constructor.defaults)), this.option(b);
            var d = ++k;
            (this.element.outlayerGUID = d), (l[d] = this), this._create(), this.options.isInitLayout && this.layout();
        }
        var h = a.console,
            i = a.jQuery,
            j = function () {},
            k = 0,
            l = {};
        return (
            (g.namespace = "outlayer"),
            (g.Item = f),
            (g.defaults = {
                containerStyle: { position: "relative" },
                isInitLayout: !0,
                isOriginLeft: !0,
                isOriginTop: !0,
                isResizeBound: !0,
                isResizingContainer: !0,
                transitionDuration: "0.4s",
                hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
                visibleStyle: { opacity: 1, transform: "scale(1)" },
            }),
            e.extend(g.prototype, c.prototype),
            (g.prototype.option = function (a) {
                e.extend(this.options, a);
            }),
            (g.prototype._create = function () {
                this.reloadItems(), (this.stamps = []), this.stamp(this.options.stamp), e.extend(this.element.style, this.options.containerStyle), this.options.isResizeBound && this.bindResize();
            }),
            (g.prototype.reloadItems = function () {
                this.items = this._itemize(this.element.children);
            }),
            (g.prototype._itemize = function (a) {
                for (var b = this._filterFindItemElements(a), c = this.constructor.Item, d = [], e = 0, f = b.length; f > e; e++) {
                    var g = b[e],
                        h = new c(g, this);
                    d.push(h);
                }
                return d;
            }),
            (g.prototype._filterFindItemElements = function (a) {
                return e.filterFindElements(a, this.options.itemSelector);
            }),
            (g.prototype.getItemElements = function () {
                for (var a = [], b = 0, c = this.items.length; c > b; b++) a.push(this.items[b].element);
                return a;
            }),
            (g.prototype.layout = function () {
                this._resetLayout(), this._manageStamps();
                var a = void 0 !== this.options.isLayoutInstant ? this.options.isLayoutInstant : !this._isLayoutInited;
                this.layoutItems(this.items, a), (this._isLayoutInited = !0);
            }),
            (g.prototype._init = g.prototype.layout),
            (g.prototype._resetLayout = function () {
                this.getSize();
            }),
            (g.prototype.getSize = function () {
                this.size = d(this.element);
            }),
            (g.prototype._getMeasurement = function (a, b) {
                var c,
                    f = this.options[a];
                f ? ("string" == typeof f ? (c = this.element.querySelector(f)) : e.isElement(f) && (c = f), (this[a] = c ? d(c)[b] : f)) : (this[a] = 0);
            }),
            (g.prototype.layoutItems = function (a, b) {
                (a = this._getItemsForLayout(a)), this._layoutItems(a, b), this._postLayout();
            }),
            (g.prototype._getItemsForLayout = function (a) {
                for (var b = [], c = 0, d = a.length; d > c; c++) {
                    var e = a[c];
                    e.isIgnored || b.push(e);
                }
                return b;
            }),
            (g.prototype._layoutItems = function (a, b) {
                if ((this._emitCompleteOnItems("layout", a), a && a.length)) {
                    for (var c = [], d = 0, e = a.length; e > d; d++) {
                        var f = a[d],
                            g = this._getItemLayoutPosition(f);
                        (g.item = f), (g.isInstant = b || f.isLayoutInstant), c.push(g);
                    }
                    this._processLayoutQueue(c);
                }
            }),
            (g.prototype._getItemLayoutPosition = function () {
                return { x: 0, y: 0 };
            }),
            (g.prototype._processLayoutQueue = function (a) {
                for (var b = 0, c = a.length; c > b; b++) {
                    var d = a[b];
                    this._positionItem(d.item, d.x, d.y, d.isInstant);
                }
            }),
            (g.prototype._positionItem = function (a, b, c, d) {
                d ? a.goTo(b, c) : a.moveTo(b, c);
            }),
            (g.prototype._postLayout = function () {
                this.resizeContainer();
            }),
            (g.prototype.resizeContainer = function () {
                if (this.options.isResizingContainer) {
                    var a = this._getContainerSize();
                    a && (this._setContainerMeasure(a.width, !0), this._setContainerMeasure(a.height, !1));
                }
            }),
            (g.prototype._getContainerSize = j),
            (g.prototype._setContainerMeasure = function (a, b) {
                if (void 0 !== a) {
                    var c = this.size;
                    c.isBorderBox && (a += b ? c.paddingLeft + c.paddingRight + c.borderLeftWidth + c.borderRightWidth : c.paddingBottom + c.paddingTop + c.borderTopWidth + c.borderBottomWidth),
                        (a = Math.max(a, 0)),
                        (this.element.style[b ? "width" : "height"] = a + "px");
                }
            }),
            (g.prototype._emitCompleteOnItems = function (a, b) {
                function c() {
                    e.dispatchEvent(a + "Complete", null, [b]);
                }
                function d() {
                    g++, g === f && c();
                }
                var e = this,
                    f = b.length;
                if (!b || !f) return void c();
                for (var g = 0, h = 0, i = b.length; i > h; h++) {
                    var j = b[h];
                    j.once(a, d);
                }
            }),
            (g.prototype.dispatchEvent = function (a, b, c) {
                var d = b ? [b].concat(c) : c;
                if ((this.emitEvent(a, d), i))
                    if (((this.$element = this.$element || i(this.element)), b)) {
                        var e = i.Event(b);
                        (e.type = a), this.$element.trigger(e, c);
                    } else this.$element.trigger(a, c);
            }),
            (g.prototype.ignore = function (a) {
                var b = this.getItem(a);
                b && (b.isIgnored = !0);
            }),
            (g.prototype.unignore = function (a) {
                var b = this.getItem(a);
                b && delete b.isIgnored;
            }),
            (g.prototype.stamp = function (a) {
                if ((a = this._find(a))) {
                    this.stamps = this.stamps.concat(a);
                    for (var b = 0, c = a.length; c > b; b++) {
                        var d = a[b];
                        this.ignore(d);
                    }
                }
            }),
            (g.prototype.unstamp = function (a) {
                if ((a = this._find(a)))
                    for (var b = 0, c = a.length; c > b; b++) {
                        var d = a[b];
                        e.removeFrom(this.stamps, d), this.unignore(d);
                    }
            }),
            (g.prototype._find = function (a) {
                return a ? ("string" == typeof a && (a = this.element.querySelectorAll(a)), (a = e.makeArray(a))) : void 0;
            }),
            (g.prototype._manageStamps = function () {
                if (this.stamps && this.stamps.length) {
                    this._getBoundingRect();
                    for (var a = 0, b = this.stamps.length; b > a; a++) {
                        var c = this.stamps[a];
                        this._manageStamp(c);
                    }
                }
            }),
            (g.prototype._getBoundingRect = function () {
                var a = this.element.getBoundingClientRect(),
                    b = this.size;
                this._boundingRect = {
                    left: a.left + b.paddingLeft + b.borderLeftWidth,
                    top: a.top + b.paddingTop + b.borderTopWidth,
                    right: a.right - (b.paddingRight + b.borderRightWidth),
                    bottom: a.bottom - (b.paddingBottom + b.borderBottomWidth),
                };
            }),
            (g.prototype._manageStamp = j),
            (g.prototype._getElementOffset = function (a) {
                var b = a.getBoundingClientRect(),
                    c = this._boundingRect,
                    e = d(a),
                    f = { left: b.left - c.left - e.marginLeft, top: b.top - c.top - e.marginTop, right: c.right - b.right - e.marginRight, bottom: c.bottom - b.bottom - e.marginBottom };
                return f;
            }),
            (g.prototype.handleEvent = function (a) {
                var b = "on" + a.type;
                this[b] && this[b](a);
            }),
            (g.prototype.bindResize = function () {
                this.isResizeBound || (b.bind(a, "resize", this), (this.isResizeBound = !0));
            }),
            (g.prototype.unbindResize = function () {
                this.isResizeBound && b.unbind(a, "resize", this), (this.isResizeBound = !1);
            }),
            (g.prototype.onresize = function () {
                function a() {
                    b.resize(), delete b.resizeTimeout;
                }
                this.resizeTimeout && clearTimeout(this.resizeTimeout);
                var b = this;
                this.resizeTimeout = setTimeout(a, 100);
            }),
            (g.prototype.resize = function () {
                this.isResizeBound && this.needsResizeLayout() && this.layout();
            }),
            (g.prototype.needsResizeLayout = function () {
                var a = d(this.element),
                    b = this.size && a;
                return b && a.innerWidth !== this.size.innerWidth;
            }),
            (g.prototype.addItems = function (a) {
                var b = this._itemize(a);
                return b.length && (this.items = this.items.concat(b)), b;
            }),
            (g.prototype.appended = function (a) {
                var b = this.addItems(a);
                b.length && (this.layoutItems(b, !0), this.reveal(b));
            }),
            (g.prototype.prepended = function (a) {
                var b = this._itemize(a);
                if (b.length) {
                    var c = this.items.slice(0);
                    (this.items = b.concat(c)), this._resetLayout(), this._manageStamps(), this.layoutItems(b, !0), this.reveal(b), this.layoutItems(c);
                }
            }),
            (g.prototype.reveal = function (a) {
                this._emitCompleteOnItems("reveal", a);
                for (var b = a && a.length, c = 0; b && b > c; c++) {
                    var d = a[c];
                    d.reveal();
                }
            }),
            (g.prototype.hide = function (a) {
                this._emitCompleteOnItems("hide", a);
                for (var b = a && a.length, c = 0; b && b > c; c++) {
                    var d = a[c];
                    d.hide();
                }
            }),
            (g.prototype.revealItemElements = function (a) {
                var b = this.getItems(a);
                this.reveal(b);
            }),
            (g.prototype.hideItemElements = function (a) {
                var b = this.getItems(a);
                this.hide(b);
            }),
            (g.prototype.getItem = function (a) {
                for (var b = 0, c = this.items.length; c > b; b++) {
                    var d = this.items[b];
                    if (d.element === a) return d;
                }
            }),
            (g.prototype.getItems = function (a) {
                a = e.makeArray(a);
                for (var b = [], c = 0, d = a.length; d > c; c++) {
                    var f = a[c],
                        g = this.getItem(f);
                    g && b.push(g);
                }
                return b;
            }),
            (g.prototype.remove = function (a) {
                var b = this.getItems(a);
                if ((this._emitCompleteOnItems("remove", b), b && b.length))
                    for (var c = 0, d = b.length; d > c; c++) {
                        var f = b[c];
                        f.remove(), e.removeFrom(this.items, f);
                    }
            }),
            (g.prototype.destroy = function () {
                var a = this.element.style;
                (a.height = ""), (a.position = ""), (a.width = "");
                for (var b = 0, c = this.items.length; c > b; b++) {
                    var d = this.items[b];
                    d.destroy();
                }
                this.unbindResize();
                var e = this.element.outlayerGUID;
                delete l[e], delete this.element.outlayerGUID, i && i.removeData(this.element, this.constructor.namespace);
            }),
            (g.data = function (a) {
                a = e.getQueryElement(a);
                var b = a && a.outlayerGUID;
                return b && l[b];
            }),
            (g.create = function (a, b) {
                function c() {
                    g.apply(this, arguments);
                }
                return (
                    Object.create ? (c.prototype = Object.create(g.prototype)) : e.extend(c.prototype, g.prototype),
                    (c.prototype.constructor = c),
                    (c.defaults = e.extend({}, g.defaults)),
                    e.extend(c.defaults, b),
                    (c.prototype.settings = {}),
                    (c.namespace = a),
                    (c.data = g.data),
                    (c.Item = function () {
                        f.apply(this, arguments);
                    }),
                    (c.Item.prototype = new f()),
                    e.htmlInit(c, a),
                    i && i.bridget && i.bridget(a, c),
                    c
                );
            }),
            (g.Item = f),
            g
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd ? define("packery/js/rect", b) : "object" == typeof exports ? (module.exports = b()) : ((a.Packery = a.Packery || {}), (a.Packery.Rect = b()));
    })(window, function () {
        function a(b) {
            for (var c in a.defaults) this[c] = a.defaults[c];
            for (c in b) this[c] = b[c];
        }
        var b = (window.Packery = function () {});
        return (
            (b.Rect = a),
            (a.defaults = { x: 0, y: 0, width: 0, height: 0 }),
            (a.prototype.contains = function (a) {
                var b = a.width || 0,
                    c = a.height || 0;
                return this.x <= a.x && this.y <= a.y && this.x + this.width >= a.x + b && this.y + this.height >= a.y + c;
            }),
            (a.prototype.overlaps = function (a) {
                var b = this.x + this.width,
                    c = this.y + this.height,
                    d = a.x + a.width,
                    e = a.y + a.height;
                return this.x < d && b > a.x && this.y < e && c > a.y;
            }),
            (a.prototype.getMaximalFreeRects = function (b) {
                if (!this.overlaps(b)) return !1;
                var c,
                    d = [],
                    e = this.x + this.width,
                    f = this.y + this.height,
                    g = b.x + b.width,
                    h = b.y + b.height;
                return (
                    this.y < b.y && ((c = new a({ x: this.x, y: this.y, width: this.width, height: b.y - this.y })), d.push(c)),
                    e > g && ((c = new a({ x: g, y: this.y, width: e - g, height: this.height })), d.push(c)),
                    f > h && ((c = new a({ x: this.x, y: h, width: this.width, height: f - h })), d.push(c)),
                    this.x < b.x && ((c = new a({ x: this.x, y: this.y, width: b.x - this.x, height: this.height })), d.push(c)),
                    d
                );
            }),
            (a.prototype.canFit = function (a) {
                return this.width >= a.width && this.height >= a.height;
            }),
            a
        );
    }),
    (function (a, b) {
        if ("function" == typeof define && define.amd) define("packery/js/packer", ["./rect"], b);
        else if ("object" == typeof exports) module.exports = b(require("./rect"));
        else {
            var c = (a.Packery = a.Packery || {});
            c.Packer = b(c.Rect);
        }
    })(window, function (a) {
        function b(a, b, c) {
            (this.width = a || 0), (this.height = b || 0), (this.sortDirection = c || "downwardLeftToRight"), this.reset();
        }
        (b.prototype.reset = function () {
            (this.spaces = []), (this.newSpaces = []);
            var b = new a({ x: 0, y: 0, width: this.width, height: this.height });
            this.spaces.push(b), (this.sorter = c[this.sortDirection] || c.downwardLeftToRight);
        }),
            (b.prototype.pack = function (a) {
                for (var b = 0, c = this.spaces.length; c > b; b++) {
                    var d = this.spaces[b];
                    if (d.canFit(a)) {
                        this.placeInSpace(a, d);
                        break;
                    }
                }
            }),
            (b.prototype.placeInSpace = function (a, b) {
                (a.x = b.x), (a.y = b.y), this.placed(a);
            }),
            (b.prototype.placed = function (a) {
                for (var b = [], c = 0, d = this.spaces.length; d > c; c++) {
                    var e = this.spaces[c],
                        f = e.getMaximalFreeRects(a);
                    f ? b.push.apply(b, f) : b.push(e);
                }
                (this.spaces = b), this.mergeSortSpaces();
            }),
            (b.prototype.mergeSortSpaces = function () {
                b.mergeRects(this.spaces), this.spaces.sort(this.sorter);
            }),
            (b.prototype.addSpace = function (a) {
                this.spaces.push(a), this.mergeSortSpaces();
            }),
            (b.mergeRects = function (a) {
                for (var b = 0, c = a.length; c > b; b++) {
                    var d = a[b];
                    if (d) {
                        var e = a.slice(0);
                        e.splice(b, 1);
                        for (var f = 0, g = 0, h = e.length; h > g; g++) {
                            var i = e[g],
                                j = b > g ? 0 : 1;
                            d.contains(i) && (a.splice(g + j - f, 1), f++);
                        }
                    }
                }
                return a;
            });
        var c = {
            downwardLeftToRight: function (a, b) {
                return a.y - b.y || a.x - b.x;
            },
            rightwardTopToBottom: function (a, b) {
                return a.x - b.x || a.y - b.y;
            },
        };
        return b;
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define("packery/js/item", ["get-style-property/get-style-property", "outlayer/outlayer", "./rect"], b)
            : "object" == typeof exports
            ? (module.exports = b(require("desandro-get-style-property"), require("outlayer"), require("./rect")))
            : (a.Packery.Item = b(a.getStyleProperty, a.Outlayer, a.Packery.Rect));
    })(window, function (a, b, c) {
        var d = a("transform"),
            e = function () {
                b.Item.apply(this, arguments);
            };
        e.prototype = new b.Item();
        var f = e.prototype._create;
        return (
            (e.prototype._create = function () {
                f.call(this), (this.rect = new c()), (this.placeRect = new c());
            }),
            (e.prototype.dragStart = function () {
                this.getPosition(),
                    this.removeTransitionStyles(),
                    this.isTransitioning && d && (this.element.style[d] = "none"),
                    this.getSize(),
                    (this.isPlacing = !0),
                    (this.needsPositioning = !1),
                    this.positionPlaceRect(this.position.x, this.position.y),
                    (this.isTransitioning = !1),
                    (this.didDrag = !1);
            }),
            (e.prototype.dragMove = function (a, b) {
                this.didDrag = !0;
                var c = this.layout.size;
                (a -= c.paddingLeft), (b -= c.paddingTop), this.positionPlaceRect(a, b);
            }),
            (e.prototype.dragStop = function () {
                this.getPosition();
                var a = this.position.x != this.placeRect.x,
                    b = this.position.y != this.placeRect.y;
                (this.needsPositioning = a || b), (this.didDrag = !1);
            }),
            (e.prototype.positionPlaceRect = function (a, b, c) {
                (this.placeRect.x = this.getPlaceRectCoord(a, !0)), (this.placeRect.y = this.getPlaceRectCoord(b, !1, c));
            }),
            (e.prototype.getPlaceRectCoord = function (a, b, c) {
                var d = b ? "Width" : "Height",
                    e = this.size["outer" + d],
                    f = this.layout[b ? "columnWidth" : "rowHeight"],
                    g = this.layout.size["inner" + d];
                b || ((g = Math.max(g, this.layout.maxY)), this.layout.rowHeight || (g -= this.layout.gutter));
                var h;
                if (f) {
                    (f += this.layout.gutter), (g += b ? this.layout.gutter : 0), (a = Math.round(a / f));
                    var i;
                    i = this.layout.options.isHorizontal ? (b ? "ceil" : "floor") : b ? "floor" : "ceil";
                    var j = Math[i](g / f);
                    (j -= Math.ceil(e / f)), (h = j);
                } else h = g - e;
                return (a = c ? a : Math.min(a, h)), (a *= f || 1), Math.max(0, a);
            }),
            (e.prototype.copyPlaceRectPosition = function () {
                (this.rect.x = this.placeRect.x), (this.rect.y = this.placeRect.y);
            }),
            (e.prototype.removeElem = function () {
                this.element.parentNode.removeChild(this.element), this.layout.packer.addSpace(this.rect), this.emitEvent("remove", [this]);
            }),
            e
        );
    }),
    (function (a, b) {
        "function" == typeof define && define.amd
            ? define(["classie/classie", "get-size/get-size", "outlayer/outlayer", "packery/js/rect", "packery/js/packer", "packery/js/item"], b)
            : "object" == typeof exports
            ? (module.exports = b(require("desandro-classie"), require("get-size"), require("outlayer"), require("./rect"), require("./packer"), require("./item")))
            : (a.Packery = b(a.classie, a.getSize, a.Outlayer, a.Packery.Rect, a.Packery.Packer, a.Packery.Item));
    })(window, function (a, b, c, d, e, f) {
        function g(a, b) {
            return a.position.y - b.position.y || a.position.x - b.position.x;
        }
        function h(a, b) {
            return a.position.x - b.position.x || a.position.y - b.position.y;
        }
        d.prototype.canFit = function (a) {
            return this.width >= a.width - 1 && this.height >= a.height - 1;
        };
        var i = c.create("packery");
        return (
            (i.Item = f),
            (i.prototype._create = function () {
                c.prototype._create.call(this), (this.packer = new e()), this.stamp(this.options.stamped);
                var a = this;
                (this.handleDraggabilly = {
                    dragStart: function () {
                        a.itemDragStart(this.element);
                    },
                    dragMove: function () {
                        a.itemDragMove(this.element, this.position.x, this.position.y);
                    },
                    dragEnd: function () {
                        a.itemDragEnd(this.element);
                    },
                }),
                    (this.handleUIDraggable = {
                        start: function (b, c) {
                            c && a.itemDragStart(b.currentTarget);
                        },
                        drag: function (b, c) {
                            c && a.itemDragMove(b.currentTarget, c.position.left, c.position.top);
                        },
                        stop: function (b, c) {
                            c && a.itemDragEnd(b.currentTarget);
                        },
                    });
            }),
            (i.prototype._resetLayout = function () {
                this.getSize(), this._getMeasurements();
                var a = this.packer;
                this.options.isHorizontal
                    ? ((a.width = Number.POSITIVE_INFINITY), (a.height = this.size.innerHeight + this.gutter), (a.sortDirection = "rightwardTopToBottom"))
                    : ((a.width = this.size.innerWidth + this.gutter), (a.height = Number.POSITIVE_INFINITY), (a.sortDirection = "downwardLeftToRight")),
                    a.reset(),
                    (this.maxY = 0),
                    (this.maxX = 0);
            }),
            (i.prototype._getMeasurements = function () {
                this._getMeasurement("columnWidth", "width"), this._getMeasurement("rowHeight", "height"), this._getMeasurement("gutter", "width");
            }),
            (i.prototype._getItemLayoutPosition = function (a) {
                return this._packItem(a), a.rect;
            }),
            (i.prototype._packItem = function (a) {
                this._setRectSize(a.element, a.rect), this.packer.pack(a.rect), this._setMaxXY(a.rect);
            }),
            (i.prototype._setMaxXY = function (a) {
                (this.maxX = Math.max(a.x + a.width, this.maxX)), (this.maxY = Math.max(a.y + a.height, this.maxY));
            }),
            (i.prototype._setRectSize = function (a, c) {
                var d = b(a),
                    e = d.outerWidth,
                    f = d.outerHeight;
                (e || f) && ((e = this._applyGridGutter(e, this.columnWidth)), (f = this._applyGridGutter(f, this.rowHeight))), (c.width = Math.min(e, this.packer.width)), (c.height = Math.min(f, this.packer.height));
            }),
            (i.prototype._applyGridGutter = function (a, b) {
                if (!b) return a + this.gutter;
                b += this.gutter;
                var c = a % b,
                    d = c && 1 > c ? "round" : "ceil";
                return (a = Math[d](a / b) * b);
            }),
            (i.prototype._getContainerSize = function () {
                return this.options.isHorizontal ? { width: this.maxX - this.gutter } : { height: this.maxY - this.gutter };
            }),
            (i.prototype._manageStamp = function (a) {
                var b,
                    c = this.getItem(a);
                if (c && c.isPlacing) b = c.placeRect;
                else {
                    var e = this._getElementOffset(a);
                    b = new d({ x: this.options.isOriginLeft ? e.left : e.right, y: this.options.isOriginTop ? e.top : e.bottom });
                }
                this._setRectSize(a, b), this.packer.placed(b), this._setMaxXY(b);
            }),
            (i.prototype.sortItemsByPosition = function () {
                var a = this.options.isHorizontal ? h : g;
                this.items.sort(a);
            }),
            (i.prototype.fit = function (a, b, c) {
                var d = this.getItem(a);
                d &&
                    (this._getMeasurements(),
                    this.stamp(d.element),
                    d.getSize(),
                    (d.isPlacing = !0),
                    (b = void 0 === b ? d.rect.x : b),
                    (c = void 0 === c ? d.rect.y : c),
                    d.positionPlaceRect(b, c, !0),
                    this._bindFitEvents(d),
                    d.moveTo(d.placeRect.x, d.placeRect.y),
                    this.layout(),
                    this.unstamp(d.element),
                    this.sortItemsByPosition(),
                    (d.isPlacing = !1),
                    d.copyPlaceRectPosition());
            }),
            (i.prototype._bindFitEvents = function (a) {
                function b() {
                    d++, 2 == d && c.dispatchEvent("fitComplete", null, [a]);
                }
                var c = this,
                    d = 0;
                a.on("layout", function () {
                    return b(), !0;
                }),
                    this.on("layoutComplete", function () {
                        return b(), !0;
                    });
            }),
            (i.prototype.resize = function () {
                var a = b(this.element),
                    c = this.size && a,
                    d = this.options.isHorizontal ? "innerHeight" : "innerWidth";
                (c && a[d] == this.size[d]) || this.layout();
            }),
            (i.prototype.itemDragStart = function (a) {
                this.stamp(a);
                var b = this.getItem(a);
                b && b.dragStart();
            }),
            (i.prototype.itemDragMove = function (a, b, c) {
                function d() {
                    f.layout(), delete f.dragTimeout;
                }
                var e = this.getItem(a);
                e && e.dragMove(b, c);
                var f = this;
                this.clearDragTimeout(), (this.dragTimeout = setTimeout(d, 40));
            }),
            (i.prototype.clearDragTimeout = function () {
                this.dragTimeout && clearTimeout(this.dragTimeout);
            }),
            (i.prototype.itemDragEnd = function (b) {
                var c,
                    d = this.getItem(b);
                if ((d && ((c = d.didDrag), d.dragStop()), !d || (!c && !d.needsPositioning))) return void this.unstamp(b);
                a.add(d.element, "is-positioning-post-drag");
                var e = this._getDragEndLayoutComplete(b, d);
                d.needsPositioning ? (d.on("layout", e), d.moveTo(d.placeRect.x, d.placeRect.y)) : d && d.copyPlaceRectPosition(), this.clearDragTimeout(), this.on("layoutComplete", e), this.layout();
            }),
            (i.prototype._getDragEndLayoutComplete = function (b, c) {
                var d = c && c.needsPositioning,
                    e = 0,
                    f = d ? 2 : 1,
                    g = this;
                return function () {
                    return (
                        e++,
                        e != f ? !0 : (c && (a.remove(c.element, "is-positioning-post-drag"), (c.isPlacing = !1), c.copyPlaceRectPosition()), g.unstamp(b), g.sortItemsByPosition(), d && g.dispatchEvent("dragItemPositioned", null, [c]), !0)
                    );
                };
            }),
            (i.prototype.bindDraggabillyEvents = function (a) {
                a.on("dragStart", this.handleDraggabilly.dragStart), a.on("dragMove", this.handleDraggabilly.dragMove), a.on("dragEnd", this.handleDraggabilly.dragEnd);
            }),
            (i.prototype.bindUIDraggableEvents = function (a) {
                a.on("dragstart", this.handleUIDraggable.start).on("drag", this.handleUIDraggable.drag).on("dragstop", this.handleUIDraggable.stop);
            }),
            (i.Rect = d),
            (i.Packer = e),
            i
        );
    });
/* Owl Carousel v2.3.4 */
!(function (a, b, c, d) {
    function e(b, c) {
        (this.settings = null),
            (this.options = a.extend({}, e.Defaults, c)),
            (this.$element = a(b)),
            (this._handlers = {}),
            (this._plugins = {}),
            (this._supress = {}),
            (this._current = null),
            (this._speed = null),
            (this._coordinates = []),
            (this._breakpoint = null),
            (this._width = null),
            (this._items = []),
            (this._clones = []),
            (this._mergers = []),
            (this._widths = []),
            (this._invalidated = {}),
            (this._pipe = []),
            (this._drag = { time: null, target: null, pointer: null, stage: { start: null, current: null }, direction: null }),
            (this._states = { current: {}, tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] } }),
            a.each(
                ["onResize", "onThrottledResize"],
                a.proxy(function (b, c) {
                    this._handlers[c] = a.proxy(this[c], this);
                }, this)
            ),
            a.each(
                e.Plugins,
                a.proxy(function (a, b) {
                    this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
                }, this)
            ),
            a.each(
                e.Workers,
                a.proxy(function (b, c) {
                    this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
                }, this)
            ),
            this.setup(),
            this.initialize();
    }
    (e.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        checkVisibility: !0,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: b,
        fallbackEasing: "swing",
        slideTransition: "",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab",
    }),
        (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
        (e.Type = { Event: "event", State: "state" }),
        (e.Plugins = {}),
        (e.Workers = [
            {
                filter: ["width", "settings"],
                run: function () {
                    this._width = this.$element.width();
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    a.current = this._items && this._items[this.relative(this._current)];
                },
            },
            {
                filter: ["items", "settings"],
                run: function () {
                    this.$stage.children(".cloned").remove();
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    var b = this.settings.margin || "",
                        c = !this.settings.autoWidth,
                        d = this.settings.rtl,
                        e = { width: "auto", "margin-left": d ? b : "", "margin-right": d ? "" : b };
                    !c && this.$stage.children().css(e), (a.css = e);
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    var b = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
                        c = null,
                        d = this._items.length,
                        e = !this.settings.autoWidth,
                        f = [];
                    for (a.items = { merge: !1, width: b }; d--; )
                        (c = this._mergers[d]), (c = (this.settings.mergeFit && Math.min(c, this.settings.items)) || c), (a.items.merge = c > 1 || a.items.merge), (f[d] = e ? b * c : this._items[d].width());
                    this._widths = f;
                },
            },
            {
                filter: ["items", "settings"],
                run: function () {
                    var b = [],
                        c = this._items,
                        d = this.settings,
                        e = Math.max(2 * d.items, 4),
                        f = 2 * Math.ceil(c.length / 2),
                        g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
                        h = "",
                        i = "";
                    for (g /= 2; g > 0; ) b.push(this.normalize(b.length / 2, !0)), (h += c[b[b.length - 1]][0].outerHTML), b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)), (i = c[b[b.length - 1]][0].outerHTML + i), (g -= 1);
                    (this._clones = b), a(h).addClass("cloned").appendTo(this.$stage), a(i).addClass("cloned").prependTo(this.$stage);
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function () {
                    for (var a = this.settings.rtl ? 1 : -1, b = this._clones.length + this._items.length, c = -1, d = 0, e = 0, f = []; ++c < b; )
                        (d = f[c - 1] || 0), (e = this._widths[this.relative(c)] + this.settings.margin), f.push(d + e * a);
                    this._coordinates = f;
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function () {
                    var a = this.settings.stagePadding,
                        b = this._coordinates,
                        c = { width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a, "padding-left": a || "", "padding-right": a || "" };
                    this.$stage.css(c);
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    var b = this._coordinates.length,
                        c = !this.settings.autoWidth,
                        d = this.$stage.children();
                    if (c && a.items.merge) for (; b--; ) (a.css.width = this._widths[this.relative(b)]), d.eq(b).css(a.css);
                    else c && ((a.css.width = a.items.width), d.css(a.css));
                },
            },
            {
                filter: ["items"],
                run: function () {
                    this._coordinates.length < 1 && this.$stage.removeAttr("style");
                },
            },
            {
                filter: ["width", "items", "settings"],
                run: function (a) {
                    (a.current = a.current ? this.$stage.children().index(a.current) : 0), (a.current = Math.max(this.minimum(), Math.min(this.maximum(), a.current))), this.reset(a.current);
                },
            },
            {
                filter: ["position"],
                run: function () {
                    this.animate(this.coordinates(this._current));
                },
            },
            {
                filter: ["width", "position", "items", "settings"],
                run: function () {
                    var a,
                        b,
                        c,
                        d,
                        e = this.settings.rtl ? 1 : -1,
                        f = 2 * this.settings.stagePadding,
                        g = this.coordinates(this.current()) + f,
                        h = g + this.width() * e,
                        i = [];
                    for (c = 0, d = this._coordinates.length; c < d; c++)
                        (a = this._coordinates[c - 1] || 0), (b = Math.abs(this._coordinates[c]) + f * e), ((this.op(a, "<=", g) && this.op(a, ">", h)) || (this.op(b, "<", g) && this.op(b, ">", h))) && i.push(c);
                    this.$stage.children(".active").removeClass("active"),
                        this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass("active"),
                        this.$stage.children(".center").removeClass("center"),
                        this.settings.center && this.$stage.children().eq(this.current()).addClass("center");
                },
            },
        ]),
        (e.prototype.initializeStage = function () {
            (this.$stage = this.$element.find("." + this.settings.stageClass)),
                this.$stage.length ||
                    (this.$element.addClass(this.options.loadingClass),
                    (this.$stage = a("<" + this.settings.stageElement + ">", { class: this.settings.stageClass }).wrap(a("<div/>", { class: this.settings.stageOuterClass }))),
                    this.$element.append(this.$stage.parent()));
        }),
        (e.prototype.initializeItems = function () {
            var b = this.$element.find(".owl-item");
            if (b.length)
                return (
                    (this._items = b.get().map(function (b) {
                        return a(b);
                    })),
                    (this._mergers = this._items.map(function () {
                        return 1;
                    })),
                    void this.refresh()
                );
            this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);
        }),
        (e.prototype.initialize = function () {
            if ((this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading"))) {
                var a, b, c;
                (a = this.$element.find("img")), (b = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d), (c = this.$element.children(b).width()), a.length && c <= 0 && this.preloadAutoWidthImages(a);
            }
            this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized");
        }),
        (e.prototype.isVisible = function () {
            return !this.settings.checkVisibility || this.$element.is(":visible");
        }),
        (e.prototype.setup = function () {
            var b = this.viewport(),
                c = this.options.responsive,
                d = -1,
                e = null;
            c
                ? (a.each(c, function (a) {
                      a <= b && a > d && (d = Number(a));
                  }),
                  (e = a.extend({}, this.options, c[d])),
                  "function" == typeof e.stagePadding && (e.stagePadding = e.stagePadding()),
                  delete e.responsive,
                  e.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + d)))
                : (e = a.extend({}, this.options)),
                this.trigger("change", { property: { name: "settings", value: e } }),
                (this._breakpoint = d),
                (this.settings = e),
                this.invalidate("settings"),
                this.trigger("changed", { property: { name: "settings", value: this.settings } });
        }),
        (e.prototype.optionsLogic = function () {
            this.settings.autoWidth && ((this.settings.stagePadding = !1), (this.settings.merge = !1));
        }),
        (e.prototype.prepare = function (b) {
            var c = this.trigger("prepare", { content: b });
            return (
                c.data ||
                    (c.data = a("<" + this.settings.itemElement + "/>")
                        .addClass(this.options.itemClass)
                        .append(b)),
                this.trigger("prepared", { content: c.data }),
                c.data
            );
        }),
        (e.prototype.update = function () {
            for (
                var b = 0,
                    c = this._pipe.length,
                    d = a.proxy(function (a) {
                        return this[a];
                    }, this._invalidated),
                    e = {};
                b < c;

            )
                (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++;
            (this._invalidated = {}), !this.is("valid") && this.enter("valid");
        }),
        (e.prototype.width = function (a) {
            switch ((a = a || e.Width.Default)) {
                case e.Width.Inner:
                case e.Width.Outer:
                    return this._width;
                default:
                    return this._width - 2 * this.settings.stagePadding + this.settings.margin;
            }
        }),
        (e.prototype.refresh = function () {
            this.enter("refreshing"),
                this.trigger("refresh"),
                this.setup(),
                this.optionsLogic(),
                this.$element.addClass(this.options.refreshClass),
                this.update(),
                this.$element.removeClass(this.options.refreshClass),
                this.leave("refreshing"),
                this.trigger("refreshed");
        }),
        (e.prototype.onThrottledResize = function () {
            b.clearTimeout(this.resizeTimer), (this.resizeTimer = b.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate));
        }),
        (e.prototype.onResize = function () {
            return (
                !!this._items.length &&
                this._width !== this.$element.width() &&
                !!this.isVisible() &&
                (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")))
            );
        }),
        (e.prototype.registerEventHandlers = function () {
            a.support.transition && this.$stage.on(a.support.transition.end + ".owl.core", a.proxy(this.onTransitionEnd, this)),
                !1 !== this.settings.responsive && this.on(b, "resize", this._handlers.onThrottledResize),
                this.settings.mouseDrag &&
                    (this.$element.addClass(this.options.dragClass),
                    this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)),
                    this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
                        return !1;
                    })),
                this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", a.proxy(this.onDragEnd, this)));
        }),
        (e.prototype.onDragStart = function (b) {
            var d = null;
            3 !== b.which &&
                (a.support.transform
                    ? ((d = this.$stage
                          .css("transform")
                          .replace(/.*\(|\)| /g, "")
                          .split(",")),
                      (d = { x: d[16 === d.length ? 12 : 4], y: d[16 === d.length ? 13 : 5] }))
                    : ((d = this.$stage.position()), (d = { x: this.settings.rtl ? d.left + this.$stage.width() - this.width() + this.settings.margin : d.left, y: d.top })),
                this.is("animating") && (a.support.transform ? this.animate(d.x) : this.$stage.stop(), this.invalidate("position")),
                this.$element.toggleClass(this.options.grabClass, "mousedown" === b.type),
                this.speed(0),
                (this._drag.time = new Date().getTime()),
                (this._drag.target = a(b.target)),
                (this._drag.stage.start = d),
                (this._drag.stage.current = d),
                (this._drag.pointer = this.pointer(b)),
                a(c).on("mouseup.owl.core touchend.owl.core", a.proxy(this.onDragEnd, this)),
                a(c).one(
                    "mousemove.owl.core touchmove.owl.core",
                    a.proxy(function (b) {
                        var d = this.difference(this._drag.pointer, this.pointer(b));
                        a(c).on("mousemove.owl.core touchmove.owl.core", a.proxy(this.onDragMove, this)), (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) || (b.preventDefault(), this.enter("dragging"), this.trigger("drag"));
                    }, this)
                ));
        }),
        (e.prototype.onDragMove = function (a) {
            var b = null,
                c = null,
                d = null,
                e = this.difference(this._drag.pointer, this.pointer(a)),
                f = this.difference(this._drag.stage.start, e);
            this.is("dragging") &&
                (a.preventDefault(),
                this.settings.loop
                    ? ((b = this.coordinates(this.minimum())), (c = this.coordinates(this.maximum() + 1) - b), (f.x = ((((f.x - b) % c) + c) % c) + b))
                    : ((b = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum())),
                      (c = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum())),
                      (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
                      (f.x = Math.max(Math.min(f.x, b + d), c + d))),
                (this._drag.stage.current = f),
                this.animate(f.x));
        }),
        (e.prototype.onDragEnd = function (b) {
            var d = this.difference(this._drag.pointer, this.pointer(b)),
                e = this._drag.stage.current,
                f = (d.x > 0) ^ this.settings.rtl ? "left" : "right";
            a(c).off(".owl.core"),
                this.$element.removeClass(this.options.grabClass),
                ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
                    (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
                    this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
                    this.invalidate("position"),
                    this.update(),
                    (this._drag.direction = f),
                    (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
                        this._drag.target.one("click.owl.core", function () {
                            return !1;
                        })),
                this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
        }),
        (e.prototype.closest = function (b, c) {
            var e = -1,
                f = 30,
                g = this.width(),
                h = this.coordinates();
            return (
                this.settings.freeDrag ||
                    a.each(
                        h,
                        a.proxy(function (a, i) {
                            return (
                                "left" === c && b > i - f && b < i + f
                                    ? (e = a)
                                    : "right" === c && b > i - g - f && b < i - g + f
                                    ? (e = a + 1)
                                    : this.op(b, "<", i) && this.op(b, ">", h[a + 1] !== d ? h[a + 1] : i - g) && (e = "left" === c ? a + 1 : a),
                                -1 === e
                            );
                        }, this)
                    ),
                this.settings.loop || (this.op(b, ">", h[this.minimum()]) ? (e = b = this.minimum()) : this.op(b, "<", h[this.maximum()]) && (e = b = this.maximum())),
                e
            );
        }),
        (e.prototype.animate = function (b) {
            var c = this.speed() > 0;
            this.is("animating") && this.onTransitionEnd(),
                c && (this.enter("animating"), this.trigger("translate")),
                a.support.transform3d && a.support.transition
                    ? this.$stage.css({ transform: "translate3d(" + b + "px,0px,0px)", transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "") })
                    : c
                    ? this.$stage.animate({ left: b + "px" }, this.speed(), this.settings.fallbackEasing, a.proxy(this.onTransitionEnd, this))
                    : this.$stage.css({ left: b + "px" });
        }),
        (e.prototype.is = function (a) {
            return this._states.current[a] && this._states.current[a] > 0;
        }),
        (e.prototype.current = function (a) {
            if (a === d) return this._current;
            if (0 === this._items.length) return d;
            if (((a = this.normalize(a)), this._current !== a)) {
                var b = this.trigger("change", { property: { name: "position", value: a } });
                b.data !== d && (a = this.normalize(b.data)), (this._current = a), this.invalidate("position"), this.trigger("changed", { property: { name: "position", value: this._current } });
            }
            return this._current;
        }),
        (e.prototype.invalidate = function (b) {
            return (
                "string" === a.type(b) && ((this._invalidated[b] = !0), this.is("valid") && this.leave("valid")),
                a.map(this._invalidated, function (a, b) {
                    return b;
                })
            );
        }),
        (e.prototype.reset = function (a) {
            (a = this.normalize(a)) !== d && ((this._speed = 0), (this._current = a), this.suppress(["translate", "translated"]), this.animate(this.coordinates(a)), this.release(["translate", "translated"]));
        }),
        (e.prototype.normalize = function (a, b) {
            var c = this._items.length,
                e = b ? 0 : this._clones.length;
            return !this.isNumeric(a) || c < 1 ? (a = d) : (a < 0 || a >= c + e) && (a = ((((a - e / 2) % c) + c) % c) + e / 2), a;
        }),
        (e.prototype.relative = function (a) {
            return (a -= this._clones.length / 2), this.normalize(a, !0);
        }),
        (e.prototype.maximum = function (a) {
            var b,
                c,
                d,
                e = this.settings,
                f = this._coordinates.length;
            if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
            else if (e.autoWidth || e.merge) {
                if ((b = this._items.length)) for (c = this._items[--b].width(), d = this.$element.width(); b-- && !((c += this._items[b].width() + this.settings.margin) > d); );
                f = b + 1;
            } else f = e.center ? this._items.length - 1 : this._items.length - e.items;
            return a && (f -= this._clones.length / 2), Math.max(f, 0);
        }),
        (e.prototype.minimum = function (a) {
            return a ? 0 : this._clones.length / 2;
        }),
        (e.prototype.items = function (a) {
            return a === d ? this._items.slice() : ((a = this.normalize(a, !0)), this._items[a]);
        }),
        (e.prototype.mergers = function (a) {
            return a === d ? this._mergers.slice() : ((a = this.normalize(a, !0)), this._mergers[a]);
        }),
        (e.prototype.clones = function (b) {
            var c = this._clones.length / 2,
                e = c + this._items.length,
                f = function (a) {
                    return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2;
                };
            return b === d
                ? a.map(this._clones, function (a, b) {
                      return f(b);
                  })
                : a.map(this._clones, function (a, c) {
                      return a === b ? f(c) : null;
                  });
        }),
        (e.prototype.speed = function (a) {
            return a !== d && (this._speed = a), this._speed;
        }),
        (e.prototype.coordinates = function (b) {
            var c,
                e = 1,
                f = b - 1;
            return b === d
                ? a.map(
                      this._coordinates,
                      a.proxy(function (a, b) {
                          return this.coordinates(b);
                      }, this)
                  )
                : (this.settings.center ? (this.settings.rtl && ((e = -1), (f = b + 1)), (c = this._coordinates[b]), (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e)) : (c = this._coordinates[f] || 0), (c = Math.ceil(c)));
        }),
        (e.prototype.duration = function (a, b, c) {
            return 0 === c ? 0 : Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed);
        }),
        (e.prototype.to = function (a, b) {
            var c = this.current(),
                d = null,
                e = a - this.relative(c),
                f = (e > 0) - (e < 0),
                g = this._items.length,
                h = this.minimum(),
                i = this.maximum();
            this.settings.loop
                ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g), (a = c + e), (d = ((((a - h) % g) + g) % g) + h) !== a && d - e <= i && d - e > 0 && ((c = d - e), (a = d), this.reset(c)))
                : this.settings.rewind
                ? ((i += 1), (a = ((a % i) + i) % i))
                : (a = Math.max(h, Math.min(i, a))),
                this.speed(this.duration(c, a, b)),
                this.current(a),
                this.isVisible() && this.update();
        }),
        (e.prototype.next = function (a) {
            (a = a || !1), this.to(this.relative(this.current()) + 1, a);
        }),
        (e.prototype.prev = function (a) {
            (a = a || !1), this.to(this.relative(this.current()) - 1, a);
        }),
        (e.prototype.onTransitionEnd = function (a) {
            if (a !== d && (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))) return !1;
            this.leave("animating"), this.trigger("translated");
        }),
        (e.prototype.viewport = function () {
            var d;
            return (
                this.options.responsiveBaseElement !== b
                    ? (d = a(this.options.responsiveBaseElement).width())
                    : b.innerWidth
                    ? (d = b.innerWidth)
                    : c.documentElement && c.documentElement.clientWidth
                    ? (d = c.documentElement.clientWidth)
                    : console.warn("Can not detect viewport width."),
                d
            );
        }),
        (e.prototype.replace = function (b) {
            this.$stage.empty(),
                (this._items = []),
                b && (b = b instanceof jQuery ? b : a(b)),
                this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)),
                b
                    .filter(function () {
                        return 1 === this.nodeType;
                    })
                    .each(
                        a.proxy(function (a, b) {
                            (b = this.prepare(b)), this.$stage.append(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1);
                        }, this)
                    ),
                this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
                this.invalidate("items");
        }),
        (e.prototype.add = function (b, c) {
            var e = this.relative(this._current);
            (c = c === d ? this._items.length : this.normalize(c, !0)),
                (b = b instanceof jQuery ? b : a(b)),
                this.trigger("add", { content: b, position: c }),
                (b = this.prepare(b)),
                0 === this._items.length || c === this._items.length
                    ? (0 === this._items.length && this.$stage.append(b),
                      0 !== this._items.length && this._items[c - 1].after(b),
                      this._items.push(b),
                      this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1))
                    : (this._items[c].before(b), this._items.splice(c, 0, b), this._mergers.splice(c, 0, 1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)),
                this._items[e] && this.reset(this._items[e].index()),
                this.invalidate("items"),
                this.trigger("added", { content: b, position: c });
        }),
        (e.prototype.remove = function (a) {
            (a = this.normalize(a, !0)) !== d &&
                (this.trigger("remove", { content: this._items[a], position: a }),
                this._items[a].remove(),
                this._items.splice(a, 1),
                this._mergers.splice(a, 1),
                this.invalidate("items"),
                this.trigger("removed", { content: null, position: a }));
        }),
        (e.prototype.preloadAutoWidthImages = function (b) {
            b.each(
                a.proxy(function (b, c) {
                    this.enter("pre-loading"),
                        (c = a(c)),
                        a(new Image())
                            .one(
                                "load",
                                a.proxy(function (a) {
                                    c.attr("src", a.target.src), c.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh();
                                }, this)
                            )
                            .attr("src", c.attr("src") || c.attr("data-src") || c.attr("data-src-retina"));
                }, this)
            );
        }),
        (e.prototype.destroy = function () {
            this.$element.off(".owl.core"), this.$stage.off(".owl.core"), a(c).off(".owl.core"), !1 !== this.settings.responsive && (b.clearTimeout(this.resizeTimer), this.off(b, "resize", this._handlers.onThrottledResize));
            for (var d in this._plugins) this._plugins[d].destroy();
            this.$stage.children(".cloned").remove(),
                this.$stage.unwrap(),
                this.$stage.children().contents().unwrap(),
                this.$stage.children().unwrap(),
                this.$stage.remove(),
                this.$element
                    .removeClass(this.options.refreshClass)
                    .removeClass(this.options.loadingClass)
                    .removeClass(this.options.loadedClass)
                    .removeClass(this.options.rtlClass)
                    .removeClass(this.options.dragClass)
                    .removeClass(this.options.grabClass)
                    .attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), ""))
                    .removeData("owl.carousel");
        }),
        (e.prototype.op = function (a, b, c) {
            var d = this.settings.rtl;
            switch (b) {
                case "<":
                    return d ? a > c : a < c;
                case ">":
                    return d ? a < c : a > c;
                case ">=":
                    return d ? a <= c : a >= c;
                case "<=":
                    return d ? a >= c : a <= c;
            }
        }),
        (e.prototype.on = function (a, b, c, d) {
            a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c);
        }),
        (e.prototype.off = function (a, b, c, d) {
            a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c);
        }),
        (e.prototype.trigger = function (b, c, d, f, g) {
            var h = { item: { count: this._items.length, index: this.current() } },
                i = a.camelCase(
                    a
                        .grep(["on", b, d], function (a) {
                            return a;
                        })
                        .join("-")
                        .toLowerCase()
                ),
                j = a.Event([b, "owl", d || "carousel"].join(".").toLowerCase(), a.extend({ relatedTarget: this }, h, c));
            return (
                this._supress[b] ||
                    (a.each(this._plugins, function (a, b) {
                        b.onTrigger && b.onTrigger(j);
                    }),
                    this.register({ type: e.Type.Event, name: b }),
                    this.$element.trigger(j),
                    this.settings && "function" == typeof this.settings[i] && this.settings[i].call(this, j)),
                j
            );
        }),
        (e.prototype.enter = function (b) {
            a.each(
                [b].concat(this._states.tags[b] || []),
                a.proxy(function (a, b) {
                    this._states.current[b] === d && (this._states.current[b] = 0), this._states.current[b]++;
                }, this)
            );
        }),
        (e.prototype.leave = function (b) {
            a.each(
                [b].concat(this._states.tags[b] || []),
                a.proxy(function (a, b) {
                    this._states.current[b]--;
                }, this)
            );
        }),
        (e.prototype.register = function (b) {
            if (b.type === e.Type.Event) {
                if ((a.event.special[b.name] || (a.event.special[b.name] = {}), !a.event.special[b.name].owl)) {
                    var c = a.event.special[b.name]._default;
                    (a.event.special[b.name]._default = function (a) {
                        return !c || !c.apply || (a.namespace && -1 !== a.namespace.indexOf("owl")) ? a.namespace && a.namespace.indexOf("owl") > -1 : c.apply(this, arguments);
                    }),
                        (a.event.special[b.name].owl = !0);
                }
            } else
                b.type === e.Type.State &&
                    (this._states.tags[b.name] ? (this._states.tags[b.name] = this._states.tags[b.name].concat(b.tags)) : (this._states.tags[b.name] = b.tags),
                    (this._states.tags[b.name] = a.grep(
                        this._states.tags[b.name],
                        a.proxy(function (c, d) {
                            return a.inArray(c, this._states.tags[b.name]) === d;
                        }, this)
                    )));
        }),
        (e.prototype.suppress = function (b) {
            a.each(
                b,
                a.proxy(function (a, b) {
                    this._supress[b] = !0;
                }, this)
            );
        }),
        (e.prototype.release = function (b) {
            a.each(
                b,
                a.proxy(function (a, b) {
                    delete this._supress[b];
                }, this)
            );
        }),
        (e.prototype.pointer = function (a) {
            var c = { x: null, y: null };
            return (
                (a = a.originalEvent || a || b.event),
                (a = a.touches && a.touches.length ? a.touches[0] : a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : a),
                a.pageX ? ((c.x = a.pageX), (c.y = a.pageY)) : ((c.x = a.clientX), (c.y = a.clientY)),
                c
            );
        }),
        (e.prototype.isNumeric = function (a) {
            return !isNaN(parseFloat(a));
        }),
        (e.prototype.difference = function (a, b) {
            return { x: a.x - b.x, y: a.y - b.y };
        }),
        (a.fn.owlCarousel = function (b) {
            var c = Array.prototype.slice.call(arguments, 1);
            return this.each(function () {
                var d = a(this),
                    f = d.data("owl.carousel");
                f ||
                    ((f = new e(this, "object" == typeof b && b)),
                    d.data("owl.carousel", f),
                    a.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (b, c) {
                        f.register({ type: e.Type.Event, name: c }),
                            f.$element.on(
                                c + ".owl.carousel.core",
                                a.proxy(function (a) {
                                    a.namespace && a.relatedTarget !== this && (this.suppress([c]), f[c].apply(this, [].slice.call(arguments, 1)), this.release([c]));
                                }, f)
                            );
                    })),
                    "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
            });
        }),
        (a.fn.owlCarousel.Constructor = e);
})(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this._core = b),
                (this._interval = null),
                (this._visible = null),
                (this._handlers = {
                    "initialized.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoRefresh && this.watch();
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this._core.$element.on(this._handlers);
        };
        (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
            (e.prototype.watch = function () {
                this._interval || ((this._visible = this._core.isVisible()), (this._interval = b.setInterval(a.proxy(this.refresh, this), this._core.settings.autoRefreshInterval)));
            }),
            (e.prototype.refresh = function () {
                this._core.isVisible() !== this._visible && ((this._visible = !this._visible), this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh());
            }),
            (e.prototype.destroy = function () {
                var a, c;
                b.clearInterval(this._interval);
                for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
                for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this._core = b),
                (this._loaded = []),
                (this._handlers = {
                    "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (b) {
                        if (b.namespace && this._core.settings && this._core.settings.lazyLoad && ((b.property && "position" == b.property.name) || "initialized" == b.type)) {
                            var c = this._core.settings,
                                e = (c.center && Math.ceil(c.items / 2)) || c.items,
                                f = (c.center && -1 * e) || 0,
                                g = (b.property && b.property.value !== d ? b.property.value : this._core.current()) + f,
                                h = this._core.clones().length,
                                i = a.proxy(function (a, b) {
                                    this.load(b);
                                }, this);
                            for (c.lazyLoadEager > 0 && ((e += c.lazyLoadEager), c.loop && ((g -= c.lazyLoadEager), e++)); f++ < e; ) this.load(h / 2 + this._core.relative(g)), h && a.each(this._core.clones(this._core.relative(g)), i), g++;
                        }
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this._core.$element.on(this._handlers);
        };
        (e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
            (e.prototype.load = function (c) {
                var d = this._core.$stage.children().eq(c),
                    e = d && d.find(".owl-lazy");
                !e ||
                    a.inArray(d.get(0), this._loaded) > -1 ||
                    (e.each(
                        a.proxy(function (c, d) {
                            var e,
                                f = a(d),
                                g = (b.devicePixelRatio > 1 && f.attr("data-src-retina")) || f.attr("data-src") || f.attr("data-srcset");
                            this._core.trigger("load", { element: f, url: g }, "lazy"),
                                f.is("img")
                                    ? f
                                          .one(
                                              "load.owl.lazy",
                                              a.proxy(function () {
                                                  f.css("opacity", 1), this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                              }, this)
                                          )
                                          .attr("src", g)
                                    : f.is("source")
                                    ? f
                                          .one(
                                              "load.owl.lazy",
                                              a.proxy(function () {
                                                  this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                              }, this)
                                          )
                                          .attr("srcset", g)
                                    : ((e = new Image()),
                                      (e.onload = a.proxy(function () {
                                          f.css({ "background-image": 'url("' + g + '")', opacity: "1" }), this._core.trigger("loaded", { element: f, url: g }, "lazy");
                                      }, this)),
                                      (e.src = g));
                        }, this)
                    ),
                    this._loaded.push(d.get(0)));
            }),
            (e.prototype.destroy = function () {
                var a, b;
                for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (c) {
            (this._core = c),
                (this._previousHeight = null),
                (this._handlers = {
                    "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoHeight && this.update();
                    }, this),
                    "changed.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoHeight && "position" === a.property.name && this.update();
                    }, this),
                    "loaded.owl.lazy": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoHeight && a.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update();
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this._core.$element.on(this._handlers),
                (this._intervalId = null);
            var d = this;
            a(b).on("load", function () {
                d._core.settings.autoHeight && d.update();
            }),
                a(b).resize(function () {
                    d._core.settings.autoHeight &&
                        (null != d._intervalId && clearTimeout(d._intervalId),
                        (d._intervalId = setTimeout(function () {
                            d.update();
                        }, 250)));
                });
        };
        (e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
            (e.prototype.update = function () {
                var b = this._core._current,
                    c = b + this._core.settings.items,
                    d = this._core.settings.lazyLoad,
                    e = this._core.$stage.children().toArray().slice(b, c),
                    f = [],
                    g = 0;
                a.each(e, function (b, c) {
                    f.push(a(c).height());
                }),
                    (g = Math.max.apply(null, f)),
                    g <= 1 && d && this._previousHeight && (g = this._previousHeight),
                    (this._previousHeight = g),
                    this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass);
            }),
            (e.prototype.destroy = function () {
                var a, b;
                for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this._core = b),
                (this._videos = {}),
                (this._playing = null),
                (this._handlers = {
                    "initialized.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.register({ type: "state", name: "playing", tags: ["interacting"] });
                    }, this),
                    "resize.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault();
                    }, this),
                    "refreshed.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove();
                    }, this),
                    "changed.owl.carousel": a.proxy(function (a) {
                        a.namespace && "position" === a.property.name && this._playing && this.stop();
                    }, this),
                    "prepared.owl.carousel": a.proxy(function (b) {
                        if (b.namespace) {
                            var c = a(b.content).find(".owl-video");
                            c.length && (c.css("display", "none"), this.fetch(c, a(b.content)));
                        }
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this._core.$element.on(this._handlers),
                this._core.$element.on(
                    "click.owl.video",
                    ".owl-video-play-icon",
                    a.proxy(function (a) {
                        this.play(a);
                    }, this)
                );
        };
        (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
            (e.prototype.fetch = function (a, b) {
                var c = (function () {
                        return a.attr("data-vimeo-id") ? "vimeo" : a.attr("data-vzaar-id") ? "vzaar" : "youtube";
                    })(),
                    d = a.attr("data-vimeo-id") || a.attr("data-youtube-id") || a.attr("data-vzaar-id"),
                    e = a.attr("data-width") || this._core.settings.videoWidth,
                    f = a.attr("data-height") || this._core.settings.videoHeight,
                    g = a.attr("href");
                if (!g) throw new Error("Missing video URL.");
                if (
                    ((d = g.match(
                        /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
                    )),
                    d[3].indexOf("youtu") > -1)
                )
                    c = "youtube";
                else if (d[3].indexOf("vimeo") > -1) c = "vimeo";
                else {
                    if (!(d[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
                    c = "vzaar";
                }
                (d = d[6]), (this._videos[g] = { type: c, id: d, width: e, height: f }), b.attr("data-video", g), this.thumbnail(a, this._videos[g]);
            }),
            (e.prototype.thumbnail = function (b, c) {
                var d,
                    e,
                    f,
                    g = c.width && c.height ? "width:" + c.width + "px;height:" + c.height + "px;" : "",
                    h = b.find("img"),
                    i = "src",
                    j = "",
                    k = this._core.settings,
                    l = function (c) {
                        (e = '<div class="owl-video-play-icon"></div>'),
                            (d = k.lazyLoad ? a("<div/>", { class: "owl-video-tn " + j, srcType: c }) : a("<div/>", { class: "owl-video-tn", style: "opacity:1;background-image:url(" + c + ")" })),
                            b.after(d),
                            b.after(e);
                    };
                if ((b.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })), this._core.settings.lazyLoad && ((i = "data-src"), (j = "owl-lazy")), h.length)) return l(h.attr(i)), h.remove(), !1;
                "youtube" === c.type
                    ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"), l(f))
                    : "vimeo" === c.type
                    ? a.ajax({
                          type: "GET",
                          url: "//vimeo.com/api/v2/video/" + c.id + ".json",
                          jsonp: "callback",
                          dataType: "jsonp",
                          success: function (a) {
                              (f = a[0].thumbnail_large), l(f);
                          },
                      })
                    : "vzaar" === c.type &&
                      a.ajax({
                          type: "GET",
                          url: "//vzaar.com/api/videos/" + c.id + ".json",
                          jsonp: "callback",
                          dataType: "jsonp",
                          success: function (a) {
                              (f = a.framegrab_url), l(f);
                          },
                      });
            }),
            (e.prototype.stop = function () {
                this._core.trigger("stop", null, "video"),
                    this._playing.find(".owl-video-frame").remove(),
                    this._playing.removeClass("owl-video-playing"),
                    (this._playing = null),
                    this._core.leave("playing"),
                    this._core.trigger("stopped", null, "video");
            }),
            (e.prototype.play = function (b) {
                var c,
                    d = a(b.target),
                    e = d.closest("." + this._core.settings.itemClass),
                    f = this._videos[e.attr("data-video")],
                    g = f.width || "100%",
                    h = f.height || this._core.$stage.height();
                this._playing ||
                    (this._core.enter("playing"),
                    this._core.trigger("play", null, "video"),
                    (e = this._core.items(this._core.relative(e.index()))),
                    this._core.reset(e.index()),
                    (c = a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')),
                    c.attr("height", h),
                    c.attr("width", g),
                    "youtube" === f.type
                        ? c.attr("src", "//www.youtube.com/embed/" + f.id + "?autoplay=1&rel=0&v=" + f.id)
                        : "vimeo" === f.type
                        ? c.attr("src", "//player.vimeo.com/video/" + f.id + "?autoplay=1")
                        : "vzaar" === f.type && c.attr("src", "//view.vzaar.com/" + f.id + "/player?autoplay=true"),
                    a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")),
                    (this._playing = e.addClass("owl-video-playing")));
            }),
            (e.prototype.isInFullScreen = function () {
                var b = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;
                return b && a(b).parent().hasClass("owl-video-frame");
            }),
            (e.prototype.destroy = function () {
                var a, b;
                this._core.$element.off("click.owl.video");
                for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Video = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this.core = b),
                (this.core.options = a.extend({}, e.Defaults, this.core.options)),
                (this.swapping = !0),
                (this.previous = d),
                (this.next = d),
                (this.handlers = {
                    "change.owl.carousel": a.proxy(function (a) {
                        a.namespace && "position" == a.property.name && ((this.previous = this.core.current()), (this.next = a.property.value));
                    }, this),
                    "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function (a) {
                        a.namespace && (this.swapping = "translated" == a.type);
                    }, this),
                    "translate.owl.carousel": a.proxy(function (a) {
                        a.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
                    }, this),
                }),
                this.core.$element.on(this.handlers);
        };
        (e.Defaults = { animateOut: !1, animateIn: !1 }),
            (e.prototype.swap = function () {
                if (1 === this.core.settings.items && a.support.animation && a.support.transition) {
                    this.core.speed(0);
                    var b,
                        c = a.proxy(this.clear, this),
                        d = this.core.$stage.children().eq(this.previous),
                        e = this.core.$stage.children().eq(this.next),
                        f = this.core.settings.animateIn,
                        g = this.core.settings.animateOut;
                    this.core.current() !== this.previous &&
                        (g &&
                            ((b = this.core.coordinates(this.previous) - this.core.coordinates(this.next)),
                            d
                                .one(a.support.animation.end, c)
                                .css({ left: b + "px" })
                                .addClass("animated owl-animated-out")
                                .addClass(g)),
                        f && e.one(a.support.animation.end, c).addClass("animated owl-animated-in").addClass(f));
                }
            }),
            (e.prototype.clear = function (b) {
                a(b.target).css({ left: "" }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd();
            }),
            (e.prototype.destroy = function () {
                var a, b;
                for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        var e = function (b) {
            (this._core = b),
                (this._call = null),
                (this._time = 0),
                (this._timeout = 0),
                (this._paused = !0),
                (this._handlers = {
                    "changed.owl.carousel": a.proxy(function (a) {
                        a.namespace && "settings" === a.property.name ? (this._core.settings.autoplay ? this.play() : this.stop()) : a.namespace && "position" === a.property.name && this._paused && (this._time = 0);
                    }, this),
                    "initialized.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.autoplay && this.play();
                    }, this),
                    "play.owl.autoplay": a.proxy(function (a, b, c) {
                        a.namespace && this.play(b, c);
                    }, this),
                    "stop.owl.autoplay": a.proxy(function (a) {
                        a.namespace && this.stop();
                    }, this),
                    "mouseover.owl.autoplay": a.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                    }, this),
                    "mouseleave.owl.autoplay": a.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
                    }, this),
                    "touchstart.owl.core": a.proxy(function () {
                        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
                    }, this),
                    "touchend.owl.core": a.proxy(function () {
                        this._core.settings.autoplayHoverPause && this.play();
                    }, this),
                }),
                this._core.$element.on(this._handlers),
                (this._core.options = a.extend({}, e.Defaults, this._core.options));
        };
        (e.Defaults = { autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1 }),
            (e.prototype._next = function (d) {
                (this._call = b.setTimeout(a.proxy(this._next, this, d), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read())),
                    this._core.is("interacting") || c.hidden || this._core.next(d || this._core.settings.autoplaySpeed);
            }),
            (e.prototype.read = function () {
                return new Date().getTime() - this._time;
            }),
            (e.prototype.play = function (c, d) {
                var e;
                this._core.is("rotating") || this._core.enter("rotating"),
                    (c = c || this._core.settings.autoplayTimeout),
                    (e = Math.min(this._time % (this._timeout || c), c)),
                    this._paused ? ((this._time = this.read()), (this._paused = !1)) : b.clearTimeout(this._call),
                    (this._time += (this.read() % c) - e),
                    (this._timeout = c),
                    (this._call = b.setTimeout(a.proxy(this._next, this, d), c - e));
            }),
            (e.prototype.stop = function () {
                this._core.is("rotating") && ((this._time = 0), (this._paused = !0), b.clearTimeout(this._call), this._core.leave("rotating"));
            }),
            (e.prototype.pause = function () {
                this._core.is("rotating") && !this._paused && ((this._time = this.read()), (this._paused = !0), b.clearTimeout(this._call));
            }),
            (e.prototype.destroy = function () {
                var a, b;
                this.stop();
                for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
                for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        "use strict";
        var e = function (b) {
            (this._core = b),
                (this._initialized = !1),
                (this._pages = []),
                (this._controls = {}),
                (this._templates = []),
                (this.$element = this._core.$element),
                (this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }),
                (this._handlers = {
                    "prepared.owl.carousel": a.proxy(function (b) {
                        b.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>");
                    }, this),
                    "added.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 0, this._templates.pop());
                    }, this),
                    "remove.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1);
                    }, this),
                    "changed.owl.carousel": a.proxy(function (a) {
                        a.namespace && "position" == a.property.name && this.draw();
                    }, this),
                    "initialized.owl.carousel": a.proxy(function (a) {
                        a.namespace &&
                            !this._initialized &&
                            (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), (this._initialized = !0), this._core.trigger("initialized", null, "navigation"));
                    }, this),
                    "refreshed.owl.carousel": a.proxy(function (a) {
                        a.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"));
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this.$element.on(this._handlers);
        };
        (e.Defaults = {
            nav: !1,
            navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'],
            navSpeed: !1,
            navElement: 'button type="button" role="presentation"',
            navContainer: !1,
            navContainerClass: "owl-nav",
            navClass: ["owl-prev", "owl-next"],
            slideBy: 1,
            dotClass: "owl-dot",
            dotsClass: "owl-dots",
            dots: !0,
            dotsEach: !1,
            dotsData: !1,
            dotsSpeed: !1,
            dotsContainer: !1,
        }),
            (e.prototype.initialize = function () {
                var b,
                    c = this._core.settings;
                (this._controls.$relative = (c.navContainer ? a(c.navContainer) : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled")),
                    (this._controls.$previous = a("<" + c.navElement + ">")
                        .addClass(c.navClass[0])
                        .html(c.navText[0])
                        .prependTo(this._controls.$relative)
                        .on(
                            "click",
                            a.proxy(function (a) {
                                this.prev(c.navSpeed);
                            }, this)
                        )),
                    (this._controls.$next = a("<" + c.navElement + ">")
                        .addClass(c.navClass[1])
                        .html(c.navText[1])
                        .appendTo(this._controls.$relative)
                        .on(
                            "click",
                            a.proxy(function (a) {
                                this.next(c.navSpeed);
                            }, this)
                        )),
                    c.dotsData || (this._templates = [a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),
                    (this._controls.$absolute = (c.dotsContainer ? a(c.dotsContainer) : a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled")),
                    this._controls.$absolute.on(
                        "click",
                        "button",
                        a.proxy(function (b) {
                            var d = a(b.target).parent().is(this._controls.$absolute) ? a(b.target).index() : a(b.target).parent().index();
                            b.preventDefault(), this.to(d, c.dotsSpeed);
                        }, this)
                    );
                for (b in this._overrides) this._core[b] = a.proxy(this[b], this);
            }),
            (e.prototype.destroy = function () {
                var a, b, c, d, e;
                e = this._core.settings;
                for (a in this._handlers) this.$element.off(a, this._handlers[a]);
                for (b in this._controls) "$relative" === b && e.navContainer ? this._controls[b].html("") : this._controls[b].remove();
                for (d in this.overides) this._core[d] = this._overrides[d];
                for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null);
            }),
            (e.prototype.update = function () {
                var a,
                    b,
                    c,
                    d = this._core.clones().length / 2,
                    e = d + this._core.items().length,
                    f = this._core.maximum(!0),
                    g = this._core.settings,
                    h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
                if (("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)), g.dots || "page" == g.slideBy))
                    for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
                        if (b >= h || 0 === b) {
                            if ((this._pages.push({ start: Math.min(f, a - d), end: a - d + h - 1 }), Math.min(f, a - d) === f)) break;
                            (b = 0), ++c;
                        }
                        b += this._core.mergers(this._core.relative(a));
                    }
            }),
            (e.prototype.draw = function () {
                var b,
                    c = this._core.settings,
                    d = this._core.items().length <= c.items,
                    e = this._core.relative(this._core.current()),
                    f = c.loop || c.rewind;
                this._controls.$relative.toggleClass("disabled", !c.nav || d),
                    c.nav && (this._controls.$previous.toggleClass("disabled", !f && e <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !f && e >= this._core.maximum(!0))),
                    this._controls.$absolute.toggleClass("disabled", !c.dots || d),
                    c.dots &&
                        ((b = this._pages.length - this._controls.$absolute.children().length),
                        c.dotsData && 0 !== b
                            ? this._controls.$absolute.html(this._templates.join(""))
                            : b > 0
                            ? this._controls.$absolute.append(new Array(b + 1).join(this._templates[0]))
                            : b < 0 && this._controls.$absolute.children().slice(b).remove(),
                        this._controls.$absolute.find(".active").removeClass("active"),
                        this._controls.$absolute.children().eq(a.inArray(this.current(), this._pages)).addClass("active"));
            }),
            (e.prototype.onTrigger = function (b) {
                var c = this._core.settings;
                b.page = { index: a.inArray(this.current(), this._pages), count: this._pages.length, size: c && (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items) };
            }),
            (e.prototype.current = function () {
                var b = this._core.relative(this._core.current());
                return a
                    .grep(
                        this._pages,
                        a.proxy(function (a, c) {
                            return a.start <= b && a.end >= b;
                        }, this)
                    )
                    .pop();
            }),
            (e.prototype.getPosition = function (b) {
                var c,
                    d,
                    e = this._core.settings;
                return (
                    "page" == e.slideBy
                        ? ((c = a.inArray(this.current(), this._pages)), (d = this._pages.length), b ? ++c : --c, (c = this._pages[((c % d) + d) % d].start))
                        : ((c = this._core.relative(this._core.current())), (d = this._core.items().length), b ? (c += e.slideBy) : (c -= e.slideBy)),
                    c
                );
            }),
            (e.prototype.next = function (b) {
                a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
            }),
            (e.prototype.prev = function (b) {
                a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
            }),
            (e.prototype.to = function (b, c, d) {
                var e;
                !d && this._pages.length ? ((e = this._pages.length), a.proxy(this._overrides.to, this._core)(this._pages[((b % e) + e) % e].start, c)) : a.proxy(this._overrides.to, this._core)(b, c);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        "use strict";
        var e = function (c) {
            (this._core = c),
                (this._hashes = {}),
                (this.$element = this._core.$element),
                (this._handlers = {
                    "initialized.owl.carousel": a.proxy(function (c) {
                        c.namespace && "URLHash" === this._core.settings.startPosition && a(b).trigger("hashchange.owl.navigation");
                    }, this),
                    "prepared.owl.carousel": a.proxy(function (b) {
                        if (b.namespace) {
                            var c = a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                            if (!c) return;
                            this._hashes[c] = b.content;
                        }
                    }, this),
                    "changed.owl.carousel": a.proxy(function (c) {
                        if (c.namespace && "position" === c.property.name) {
                            var d = this._core.items(this._core.relative(this._core.current())),
                                e = a
                                    .map(this._hashes, function (a, b) {
                                        return a === d ? b : null;
                                    })
                                    .join();
                            if (!e || b.location.hash.slice(1) === e) return;
                            b.location.hash = e;
                        }
                    }, this),
                }),
                (this._core.options = a.extend({}, e.Defaults, this._core.options)),
                this.$element.on(this._handlers),
                a(b).on(
                    "hashchange.owl.navigation",
                    a.proxy(function (a) {
                        var c = b.location.hash.substring(1),
                            e = this._core.$stage.children(),
                            f = this._hashes[c] && e.index(this._hashes[c]);
                        f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), !1, !0);
                    }, this)
                );
        };
        (e.Defaults = { URLhashListener: !1 }),
            (e.prototype.destroy = function () {
                var c, d;
                a(b).off("hashchange.owl.navigation");
                for (c in this._handlers) this._core.$element.off(c, this._handlers[c]);
                for (d in Object.getOwnPropertyNames(this)) "function" != typeof this[d] && (this[d] = null);
            }),
            (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
        function e(b, c) {
            var e = !1,
                f = b.charAt(0).toUpperCase() + b.slice(1);
            return (
                a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
                    if (g[b] !== d) return (e = !c || b), !1;
                }),
                e
            );
        }
        function f(a) {
            return e(a, !0);
        }
        var g = a("<support>").get(0).style,
            h = "Webkit Moz O ms".split(" "),
            i = {
                transition: { end: { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend" } },
                animation: { end: { WebkitAnimation: "webkitAnimationEnd", MozAnimation: "animationend", OAnimation: "oAnimationEnd", animation: "animationend" } },
            },
            j = {
                csstransforms: function () {
                    return !!e("transform");
                },
                csstransforms3d: function () {
                    return !!e("perspective");
                },
                csstransitions: function () {
                    return !!e("transition");
                },
                cssanimations: function () {
                    return !!e("animation");
                },
            };
        j.csstransitions() && ((a.support.transition = new String(f("transition"))), (a.support.transition.end = i.transition.end[a.support.transition])),
            j.cssanimations() && ((a.support.animation = new String(f("animation"))), (a.support.animation.end = i.animation.end[a.support.animation])),
            j.csstransforms() && ((a.support.transform = new String(f("transform"))), (a.support.transform3d = j.csstransforms3d()));
    })(window.Zepto || window.jQuery, window, document);
// Magnific Popup
!(function (a) {
    "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto);
})(function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h = "Close",
        i = "BeforeClose",
        j = "AfterClose",
        k = "BeforeAppend",
        l = "MarkupParse",
        m = "Open",
        n = "Change",
        o = "mfp",
        p = "." + o,
        q = "mfp-ready",
        r = "mfp-removing",
        s = "mfp-prevent-close",
        t = function () {},
        u = !!window.jQuery,
        v = a(window),
        w = function (a, c) {
            b.ev.on(o + a + p, c);
        },
        x = function (b, c, d, e) {
            var f = document.createElement("div");
            return (f.className = "mfp-" + b), d && (f.innerHTML = d), e ? c && c.appendChild(f) : ((f = a(f)), c && f.appendTo(c)), f;
        },
        y = function (c, d) {
            b.ev.triggerHandler(o + c, d), b.st.callbacks && ((c = c.charAt(0).toLowerCase() + c.slice(1)), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]));
        },
        z = function (c) {
            return (c === g && b.currTemplate.closeBtn) || ((b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose))), (g = c)), b.currTemplate.closeBtn;
        },
        A = function () {
            a.magnificPopup.instance || ((b = new t()), b.init(), (a.magnificPopup.instance = b));
        },
        B = function () {
            var a = document.createElement("p").style,
                b = ["ms", "O", "Moz", "Webkit"];
            if (void 0 !== a.transition) return !0;
            for (; b.length; ) if (b.pop() + "Transition" in a) return !0;
            return !1;
        };
    (t.prototype = {
        constructor: t,
        init: function () {
            var c = navigator.appVersion;
            (b.isLowIE = b.isIE8 = document.all && !document.addEventListener),
                (b.isAndroid = /android/gi.test(c)),
                (b.isIOS = /iphone|ipad|ipod/gi.test(c)),
                (b.supportsTransition = B()),
                (b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent)),
                (d = a(document)),
                (b.popupsCache = {});
        },
        open: function (c) {
            var e;
            if (c.isObj === !1) {
                (b.items = c.items.toArray()), (b.index = 0);
                var g,
                    h = c.items;
                for (e = 0; e < h.length; e++)
                    if (((g = h[e]), g.parsed && (g = g.el[0]), g === c.el[0])) {
                        b.index = e;
                        break;
                    }
            } else (b.items = a.isArray(c.items) ? c.items : [c.items]), (b.index = c.index || 0);
            if (b.isOpen) return void b.updateItemHTML();
            (b.types = []),
                (f = ""),
                c.mainEl && c.mainEl.length ? (b.ev = c.mainEl.eq(0)) : (b.ev = d),
                c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), (b.currTemplate = b.popupsCache[c.key])) : (b.currTemplate = {}),
                (b.st = a.extend(!0, {}, a.magnificPopup.defaults, c)),
                (b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos),
                b.st.modal && ((b.st.closeOnContentClick = !1), (b.st.closeOnBgClick = !1), (b.st.showCloseBtn = !1), (b.st.enableEscapeKey = !1)),
                b.bgOverlay ||
                    ((b.bgOverlay = x("bg").on("click" + p, function () {
                        b.close();
                    })),
                    (b.wrap = x("wrap")
                        .attr("tabindex", -1)
                        .on("click" + p, function (a) {
                            b._checkIfClose(a.target) && b.close();
                        })),
                    (b.container = x("container", b.wrap))),
                (b.contentContainer = x("content")),
                b.st.preloader && (b.preloader = x("preloader", b.container, b.st.tLoading));
            var i = a.magnificPopup.modules;
            for (e = 0; e < i.length; e++) {
                var j = i[e];
                (j = j.charAt(0).toUpperCase() + j.slice(1)), b["init" + j].call(b);
            }
            y("BeforeOpen"),
                b.st.showCloseBtn &&
                    (b.st.closeBtnInside
                        ? (w(l, function (a, b, c, d) {
                              c.close_replaceWith = z(d.type);
                          }),
                          (f += " mfp-close-btn-in"))
                        : b.wrap.append(z())),
                b.st.alignTop && (f += " mfp-align-top"),
                b.fixedContentPos ? b.wrap.css({ overflow: b.st.overflowY, overflowX: "hidden", overflowY: b.st.overflowY }) : b.wrap.css({ top: v.scrollTop(), position: "absolute" }),
                (b.st.fixedBgPos === !1 || ("auto" === b.st.fixedBgPos && !b.fixedContentPos)) && b.bgOverlay.css({ height: d.height(), position: "absolute" }),
                b.st.enableEscapeKey &&
                    d.on("keyup" + p, function (a) {
                        27 === a.keyCode && b.close();
                    }),
                v.on("resize" + p, function () {
                    b.updateSize();
                }),
                b.st.closeOnContentClick || (f += " mfp-auto-cursor"),
                f && b.wrap.addClass(f);
            var k = (b.wH = v.height()),
                n = {};
            if (b.fixedContentPos && b._hasScrollBar(k)) {
                var o = b._getScrollbarSize();
                o && (n.marginRight = o);
            }
            b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : (n.overflow = "hidden"));
            var r = b.st.mainClass;
            return (
                b.isIE7 && (r += " mfp-ie7"),
                r && b._addClassToMFP(r),
                b.updateItemHTML(),
                y("BuildControls"),
                a("html").css(n),
                b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || a(document.body)),
                (b._lastFocusedEl = document.activeElement),
                setTimeout(function () {
                    b.content ? (b._addClassToMFP(q), b._setFocus()) : b.bgOverlay.addClass(q), d.on("focusin" + p, b._onFocusIn);
                }, 16),
                (b.isOpen = !0),
                b.updateSize(k),
                y(m),
                c
            );
        },
        close: function () {
            b.isOpen &&
                (y(i),
                (b.isOpen = !1),
                b.st.removalDelay && !b.isLowIE && b.supportsTransition
                    ? (b._addClassToMFP(r),
                      setTimeout(function () {
                          b._close();
                      }, b.st.removalDelay))
                    : b._close());
        },
        _close: function () {
            y(h);
            var c = r + " " + q + " ";
            if ((b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos)) {
                var e = { marginRight: "" };
                b.isIE7 ? a("body, html").css("overflow", "") : (e.overflow = ""), a("html").css(e);
            }
            d.off("keyup" + p + " focusin" + p),
                b.ev.off(p),
                b.wrap.attr("class", "mfp-wrap").removeAttr("style"),
                b.bgOverlay.attr("class", "mfp-bg"),
                b.container.attr("class", "mfp-container"),
                !b.st.showCloseBtn || (b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0) || (b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach()),
                b.st.autoFocusLast && b._lastFocusedEl && a(b._lastFocusedEl).focus(),
                (b.currItem = null),
                (b.content = null),
                (b.currTemplate = null),
                (b.prevHeight = 0),
                y(j);
        },
        updateSize: function (a) {
            if (b.isIOS) {
                var c = document.documentElement.clientWidth / window.innerWidth,
                    d = window.innerHeight * c;
                b.wrap.css("height", d), (b.wH = d);
            } else b.wH = a || v.height();
            b.fixedContentPos || b.wrap.css("height", b.wH), y("Resize");
        },
        updateItemHTML: function () {
            var c = b.items[b.index];
            b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));
            var d = c.type;
            if ((y("BeforeChange", [b.currItem ? b.currItem.type : "", d]), (b.currItem = c), !b.currTemplate[d])) {
                var f = b.st[d] ? b.st[d].markup : !1;
                y("FirstMarkupParse", f), f ? (b.currTemplate[d] = a(f)) : (b.currTemplate[d] = !0);
            }
            e && e !== c.type && b.container.removeClass("mfp-" + e + "-holder");
            var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
            b.appendContent(g, d), (c.preloaded = !0), y(n, c), (e = c.type), b.container.prepend(b.contentContainer), y("AfterChange");
        },
        appendContent: function (a, c) {
            (b.content = a),
                a ? (b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(z()) : (b.content = a)) : (b.content = ""),
                y(k),
                b.container.addClass("mfp-" + c + "-holder"),
                b.contentContainer.append(b.content);
        },
        parseEl: function (c) {
            var d,
                e = b.items[c];
            if ((e.tagName ? (e = { el: a(e) }) : ((d = e.type), (e = { data: e, src: e.src })), e.el)) {
                for (var f = b.types, g = 0; g < f.length; g++)
                    if (e.el.hasClass("mfp-" + f[g])) {
                        d = f[g];
                        break;
                    }
                (e.src = e.el.attr("data-mfp-src")), e.src || (e.src = e.el.attr("href"));
            }
            return (e.type = d || b.st.type || "inline"), (e.index = c), (e.parsed = !0), (b.items[c] = e), y("ElementParse", e), b.items[c];
        },
        addGroup: function (a, c) {
            var d = function (d) {
                (d.mfpEl = this), b._openClick(d, a, c);
            };
            c || (c = {});
            var e = "click.magnificPopup";
            (c.mainEl = a), c.items ? ((c.isObj = !0), a.off(e).on(e, d)) : ((c.isObj = !1), c.delegate ? a.off(e).on(e, c.delegate, d) : ((c.items = a), a.off(e).on(e, d)));
        },
        _openClick: function (c, d, e) {
            var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
            if (f || !(2 === c.which || c.ctrlKey || c.metaKey || c.altKey || c.shiftKey)) {
                var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
                if (g)
                    if (a.isFunction(g)) {
                        if (!g.call(b)) return !0;
                    } else if (v.width() < g) return !0;
                c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), (e.el = a(c.mfpEl)), e.delegate && (e.items = d.find(e.delegate)), b.open(e);
            }
        },
        updateStatus: function (a, d) {
            if (b.preloader) {
                c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);
                var e = { status: a, text: d };
                y("UpdateStatus", e),
                    (a = e.status),
                    (d = e.text),
                    b.preloader.html(d),
                    b.preloader.find("a").on("click", function (a) {
                        a.stopImmediatePropagation();
                    }),
                    b.container.addClass("mfp-s-" + a),
                    (c = a);
            }
        },
        _checkIfClose: function (c) {
            if (!a(c).hasClass(s)) {
                var d = b.st.closeOnContentClick,
                    e = b.st.closeOnBgClick;
                if (d && e) return !0;
                if (!b.content || a(c).hasClass("mfp-close") || (b.preloader && c === b.preloader[0])) return !0;
                if (c === b.content[0] || a.contains(b.content[0], c)) {
                    if (d) return !0;
                } else if (e && a.contains(document, c)) return !0;
                return !1;
            }
        },
        _addClassToMFP: function (a) {
            b.bgOverlay.addClass(a), b.wrap.addClass(a);
        },
        _removeClassFromMFP: function (a) {
            this.bgOverlay.removeClass(a), b.wrap.removeClass(a);
        },
        _hasScrollBar: function (a) {
            return (b.isIE7 ? d.height() : document.body.scrollHeight) > (a || v.height());
        },
        _setFocus: function () {
            (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus();
        },
        _onFocusIn: function (c) {
            return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1);
        },
        _parseMarkup: function (b, c, d) {
            var e;
            d.data && (c = a.extend(d.data, c)),
                y(l, [b, c, d]),
                a.each(c, function (c, d) {
                    if (void 0 === d || d === !1) return !0;
                    if (((e = c.split("_")), e.length > 1)) {
                        var f = b.find(p + "-" + e[0]);
                        if (f.length > 0) {
                            var g = e[1];
                            "replaceWith" === g ? f[0] !== d[0] && f.replaceWith(d) : "img" === g ? (f.is("img") ? f.attr("src", d) : f.replaceWith(a("<img>").attr("src", d).attr("class", f.attr("class")))) : f.attr(e[1], d);
                        }
                    } else b.find(p + "-" + c).html(d);
                });
        },
        _getScrollbarSize: function () {
            if (void 0 === b.scrollbarSize) {
                var a = document.createElement("div");
                (a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"), document.body.appendChild(a), (b.scrollbarSize = a.offsetWidth - a.clientWidth), document.body.removeChild(a);
            }
            return b.scrollbarSize;
        },
    }),
        (a.magnificPopup = {
            instance: null,
            proto: t.prototype,
            modules: [],
            open: function (b, c) {
                return A(), (b = b ? a.extend(!0, {}, b) : {}), (b.isObj = !0), (b.index = c || 0), this.instance.open(b);
            },
            close: function () {
                return a.magnificPopup.instance && a.magnificPopup.instance.close();
            },
            registerModule: function (b, c) {
                c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b);
            },
            defaults: {
                disableOn: 0,
                key: null,
                midClick: !1,
                mainClass: "",
                preloader: !0,
                focus: "",
                closeOnContentClick: !1,
                closeOnBgClick: !0,
                closeBtnInside: !0,
                showCloseBtn: !0,
                enableEscapeKey: !0,
                modal: !1,
                alignTop: !1,
                removalDelay: 0,
                prependTo: null,
                fixedContentPos: "auto",
                fixedBgPos: "auto",
                overflowY: "auto",
                closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
                tClose: "Close (Esc)",
                tLoading: "Loading...",
                autoFocusLast: !0,
            },
        }),
        (a.fn.magnificPopup = function (c) {
            A();
            var d = a(this);
            if ("string" == typeof c)
                if ("open" === c) {
                    var e,
                        f = u ? d.data("magnificPopup") : d[0].magnificPopup,
                        g = parseInt(arguments[1], 10) || 0;
                    f.items ? (e = f.items[g]) : ((e = d), f.delegate && (e = e.find(f.delegate)), (e = e.eq(g))), b._openClick({ mfpEl: e }, d, f);
                } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
            else (c = a.extend(!0, {}, c)), u ? d.data("magnificPopup", c) : (d[0].magnificPopup = c), b.addGroup(d, c);
            return d;
        });
    var C,
        D,
        E,
        F = "inline",
        G = function () {
            E && (D.after(E.addClass(C)).detach(), (E = null));
        };
    a.magnificPopup.registerModule(F, {
        options: { hiddenClass: "hide", markup: "", tNotFound: "Content not found" },
        proto: {
            initInline: function () {
                b.types.push(F),
                    w(h + "." + F, function () {
                        G();
                    });
            },
            getInline: function (c, d) {
                if ((G(), c.src)) {
                    var e = b.st.inline,
                        f = a(c.src);
                    if (f.length) {
                        var g = f[0].parentNode;
                        g && g.tagName && (D || ((C = e.hiddenClass), (D = x(C)), (C = "mfp-" + C)), (E = f.after(D).detach().removeClass(C))), b.updateStatus("ready");
                    } else b.updateStatus("error", e.tNotFound), (f = a("<div>"));
                    return (c.inlineElement = f), f;
                }
                return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d;
            },
        },
    });
    var H,
        I = "ajax",
        J = function () {
            H && a(document.body).removeClass(H);
        },
        K = function () {
            J(), b.req && b.req.abort();
        };
    a.magnificPopup.registerModule(I, {
        options: { settings: null, cursor: "mfp-ajax-cur", tError: '<a href="%url%">The content</a> could not be loaded.' },
        proto: {
            initAjax: function () {
                b.types.push(I), (H = b.st.ajax.cursor), w(h + "." + I, K), w("BeforeChange." + I, K);
            },
            getAjax: function (c) {
                H && a(document.body).addClass(H), b.updateStatus("loading");
                var d = a.extend(
                    {
                        url: c.src,
                        success: function (d, e, f) {
                            var g = { data: d, xhr: f };
                            y("ParseAjax", g),
                                b.appendContent(a(g.data), I),
                                (c.finished = !0),
                                J(),
                                b._setFocus(),
                                setTimeout(function () {
                                    b.wrap.addClass(q);
                                }, 16),
                                b.updateStatus("ready"),
                                y("AjaxContentAdded");
                        },
                        error: function () {
                            J(), (c.finished = c.loadError = !0), b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src));
                        },
                    },
                    b.st.ajax.settings
                );
                return (b.req = a.ajax(d)), "";
            },
        },
    });
    var L,
        M = function (c) {
            if (c.data && void 0 !== c.data.title) return c.data.title;
            var d = b.st.image.titleSrc;
            if (d) {
                if (a.isFunction(d)) return d.call(b, c);
                if (c.el) return c.el.attr(d) || "";
            }
            return "";
        };
    a.magnificPopup.registerModule("image", {
        options: {
            markup:
                '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
            cursor: "mfp-zoom-out-cur",
            titleSrc: "title",
            verticalFit: !0,
            tError: '<a href="%url%">The image</a> could not be loaded.',
        },
        proto: {
            initImage: function () {
                var c = b.st.image,
                    d = ".image";
                b.types.push("image"),
                    w(m + d, function () {
                        "image" === b.currItem.type && c.cursor && a(document.body).addClass(c.cursor);
                    }),
                    w(h + d, function () {
                        c.cursor && a(document.body).removeClass(c.cursor), v.off("resize" + p);
                    }),
                    w("Resize" + d, b.resizeImage),
                    b.isLowIE && w("AfterChange", b.resizeImage);
            },
            resizeImage: function () {
                var a = b.currItem;
                if (a && a.img && b.st.image.verticalFit) {
                    var c = 0;
                    b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c);
                }
            },
            _onImageHasSize: function (a) {
                a.img && ((a.hasSize = !0), L && clearInterval(L), (a.isCheckingImgSize = !1), y("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), (a.imgHidden = !1)));
            },
            findImageSize: function (a) {
                var c = 0,
                    d = a.img[0],
                    e = function (f) {
                        L && clearInterval(L),
                            (L = setInterval(function () {
                                return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(L), c++, void (3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)));
                            }, f));
                    };
                e(1);
            },
            getImage: function (c, d) {
                var e = 0,
                    f = function () {
                        c &&
                            (c.img[0].complete
                                ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), (c.hasSize = !0), (c.loaded = !0), y("ImageLoadComplete"))
                                : (e++, 200 > e ? setTimeout(f, 100) : g()));
                    },
                    g = function () {
                        c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), (c.hasSize = !0), (c.loaded = !0), (c.loadError = !0));
                    },
                    h = b.st.image,
                    i = d.find(".mfp-img");
                if (i.length) {
                    var j = document.createElement("img");
                    (j.className = "mfp-img"),
                        c.el && c.el.find("img").length && (j.alt = c.el.find("img").attr("alt")),
                        (c.img = a(j).on("load.mfploader", f).on("error.mfploader", g)),
                        (j.src = c.src),
                        i.is("img") && (c.img = c.img.clone()),
                        (j = c.img[0]),
                        j.naturalWidth > 0 ? (c.hasSize = !0) : j.width || (c.hasSize = !1);
                }
                return (
                    b._parseMarkup(d, { title: M(c), img_replaceWith: c.img }, c),
                    b.resizeImage(),
                    c.hasSize
                        ? (L && clearInterval(L), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d)
                        : (b.updateStatus("loading"), (c.loading = !0), c.hasSize || ((c.imgHidden = !0), d.addClass("mfp-loading"), b.findImageSize(c)), d)
                );
            },
        },
    });
    var N,
        O = function () {
            return void 0 === N && (N = void 0 !== document.createElement("p").style.MozTransform), N;
        };
    a.magnificPopup.registerModule("zoom", {
        options: {
            enabled: !1,
            easing: "ease-in-out",
            duration: 300,
            opener: function (a) {
                return a.is("img") ? a : a.find("img");
            },
        },
        proto: {
            initZoom: function () {
                var a,
                    c = b.st.zoom,
                    d = ".zoom";
                if (c.enabled && b.supportsTransition) {
                    var e,
                        f,
                        g = c.duration,
                        j = function (a) {
                            var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                d = "all " + c.duration / 1e3 + "s " + c.easing,
                                e = { position: "fixed", zIndex: 9999, left: 0, top: 0, "-webkit-backface-visibility": "hidden" },
                                f = "transition";
                            return (e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d), b.css(e), b;
                        },
                        k = function () {
                            b.content.css("visibility", "visible");
                        };
                    w("BuildControls" + d, function () {
                        if (b._allowZoom()) {
                            if ((clearTimeout(e), b.content.css("visibility", "hidden"), (a = b._getItemToZoom()), !a)) return void k();
                            (f = j(a)),
                                f.css(b._getOffset()),
                                b.wrap.append(f),
                                (e = setTimeout(function () {
                                    f.css(b._getOffset(!0)),
                                        (e = setTimeout(function () {
                                            k(),
                                                setTimeout(function () {
                                                    f.remove(), (a = f = null), y("ZoomAnimationEnded");
                                                }, 16);
                                        }, g));
                                }, 16));
                        }
                    }),
                        w(i + d, function () {
                            if (b._allowZoom()) {
                                if ((clearTimeout(e), (b.st.removalDelay = g), !a)) {
                                    if (((a = b._getItemToZoom()), !a)) return;
                                    f = j(a);
                                }
                                f.css(b._getOffset(!0)),
                                    b.wrap.append(f),
                                    b.content.css("visibility", "hidden"),
                                    setTimeout(function () {
                                        f.css(b._getOffset());
                                    }, 16);
                            }
                        }),
                        w(h + d, function () {
                            b._allowZoom() && (k(), f && f.remove(), (a = null));
                        });
                }
            },
            _allowZoom: function () {
                return "image" === b.currItem.type;
            },
            _getItemToZoom: function () {
                return b.currItem.hasSize ? b.currItem.img : !1;
            },
            _getOffset: function (c) {
                var d;
                d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
                var e = d.offset(),
                    f = parseInt(d.css("padding-top"), 10),
                    g = parseInt(d.css("padding-bottom"), 10);
                e.top -= a(window).scrollTop() - f;
                var h = { width: d.width(), height: (u ? d.innerHeight() : d[0].offsetHeight) - g - f };
                return O() ? (h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)") : ((h.left = e.left), (h.top = e.top)), h;
            },
        },
    });
    var P = "iframe",
        Q = "//about:blank",
        R = function (a) {
            if (b.currTemplate[P]) {
                var c = b.currTemplate[P].find("iframe");
                c.length && (a || (c[0].src = Q), b.isIE8 && c.css("display", a ? "block" : "none"));
            }
        };
    a.magnificPopup.registerModule(P, {
        options: {
            markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe aaa" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
            srcAction: "iframe_src",
            patterns: {
                youtube: { index: "youtube.com", id: "v=", src: "%id%" },
                vimeo: { index: "vimeo.com/", id: "/", src: "//player.vimeo.com/video/%id%?autoplay=1" },
                gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
            },
        },
        proto: {
            initIframe: function () {
                b.types.push(P),
                    w("BeforeChange", function (a, b, c) {
                        b !== c && (b === P ? R() : c === P && R(!0));
                    }),
                    w(h + "." + P, function () {
                        R();
                    });
            },
            getIframe: function (c, d) {
                var e = c.src,
                    f = b.st.iframe;
                a.each(f.patterns, function () {
                    return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), (e = this.src.replace("%id%", e)), !1) : void 0;
                });
                var g = {};
                return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d;
            },
        },
    });
    var S = function (a) {
            var c = b.items.length;
            return a > c - 1 ? a - c : 0 > a ? c + a : a;
        },
        T = function (a, b, c) {
            return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c);
        };
    a.magnificPopup.registerModule("gallery", {
        options: {
            enabled: !1,
            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
            preload: [0, 2],
            navigateByImgClick: !0,
            arrows: !0,
            tPrev: "Previous (Left arrow key)",
            tNext: "Next (Right arrow key)",
            tCounter: "%curr% of %total%",
        },
        proto: {
            initGallery: function () {
                var c = b.st.gallery,
                    e = ".mfp-gallery";
                return (
                    (b.direction = !0),
                    c && c.enabled
                        ? ((f += " mfp-gallery"),
                          w(m + e, function () {
                              c.navigateByImgClick &&
                                  b.wrap.on("click" + e, ".mfp-img", function () {
                                      return b.items.length > 1 ? (b.next(), !1) : void 0;
                                  }),
                                  d.on("keydown" + e, function (a) {
                                      37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next();
                                  });
                          }),
                          w("UpdateStatus" + e, function (a, c) {
                              c.text && (c.text = T(c.text, b.currItem.index, b.items.length));
                          }),
                          w(l + e, function (a, d, e, f) {
                              var g = b.items.length;
                              e.counter = g > 1 ? T(c.tCounter, f.index, g) : "";
                          }),
                          w("BuildControls" + e, function () {
                              if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                                  var d = c.arrowMarkup,
                                      e = (b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(s)),
                                      f = (b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(s));
                                  e.click(function () {
                                      b.prev();
                                  }),
                                      f.click(function () {
                                          b.next();
                                      }),
                                      b.container.append(e.add(f));
                              }
                          }),
                          w(n + e, function () {
                              b._preloadTimeout && clearTimeout(b._preloadTimeout),
                                  (b._preloadTimeout = setTimeout(function () {
                                      b.preloadNearbyImages(), (b._preloadTimeout = null);
                                  }, 16));
                          }),
                          void w(h + e, function () {
                              d.off(e), b.wrap.off("click" + e), (b.arrowRight = b.arrowLeft = null);
                          }))
                        : !1
                );
            },
            next: function () {
                (b.direction = !0), (b.index = S(b.index + 1)), b.updateItemHTML();
            },
            prev: function () {
                (b.direction = !1), (b.index = S(b.index - 1)), b.updateItemHTML();
            },
            goTo: function (a) {
                (b.direction = a >= b.index), (b.index = a), b.updateItemHTML();
            },
            preloadNearbyImages: function () {
                var a,
                    c = b.st.gallery.preload,
                    d = Math.min(c[0], b.items.length),
                    e = Math.min(c[1], b.items.length);
                for (a = 1; a <= (b.direction ? e : d); a++) b._preloadItem(b.index + a);
                for (a = 1; a <= (b.direction ? d : e); a++) b._preloadItem(b.index - a);
            },
            _preloadItem: function (c) {
                if (((c = S(c)), !b.items[c].preloaded)) {
                    var d = b.items[c];
                    d.parsed || (d = b.parseEl(c)),
                        y("LazyLoad", d),
                        "image" === d.type &&
                            (d.img = a('<img class="mfp-img" />')
                                .on("load.mfploader", function () {
                                    d.hasSize = !0;
                                })
                                .on("error.mfploader", function () {
                                    (d.hasSize = !0), (d.loadError = !0), y("LazyLoadError", d);
                                })
                                .attr("src", d.src)),
                        (d.preloaded = !0);
                }
            },
        },
    });
    var U = "retina";
    a.magnificPopup.registerModule(U, {
        options: {
            replaceSrc: function (a) {
                return a.src.replace(/\.\w+$/, function (a) {
                    return "@2x" + a;
                });
            },
            ratio: 1,
        },
        proto: {
            initRetina: function () {
                if (window.devicePixelRatio > 1) {
                    var a = b.st.retina,
                        c = a.ratio;
                    (c = isNaN(c) ? c() : c),
                        c > 1 &&
                            (w("ImageHasSize." + U, function (a, b) {
                                b.img.css({ "max-width": b.img[0].naturalWidth / c, width: "100%" });
                            }),
                            w("ElementParse." + U, function (b, d) {
                                d.src = a.replaceSrc(d, c);
                            }));
                }
            },
        },
    }),
        A();
});
// accoordion
!(function (i) {
    i.fn.extend({
        mobileMenu: function (e) {
            var n = { accordion: "true", speed: 300, closedSign: "collapse", openedSign: "expand", multiopen: !1 },
                s = i.extend(n, e),
                t = i(this);
            t.find("li").each(function () {
                0 != i(this).find("ul").size() &&
                    (i(this)
                        .find("a:first")
                        .after("<span class='" + s.closedSign + "'>" + s.closedSign + "</span>"),
                    "#" == i(this).find("a:first").attr("href") &&
                        i(this)
                            .find("a:first")
                            .click(function () {
                                return !1;
                            }));
            }),
                t.find("li.active").each(function () {
                    i(this).parents("ul").slideDown(s.speed, s.easing),
                        i(this).parents("ul").parent("li").find("a:first").next().html(s.openedSign).removeClass(s.closedSign).addClass(s.openedSign),
                        i(this).find("ul:first").slideDown(s.speed, s.easing),
                        i(this).find("a:first").next().html(s.openedSign).removeClass(s.closedSign).addClass(s.openedSign);
                }),
                0 == s.mouseType &&
                    t.find("li span").click(function () {
                        0 != i(this).parent().find("ul").size() &&
                            (s.accordion &&
                                (i(this).parent().find("ul").is(":visible") ||
                                    ((parents = i(this).parent().parents("ul")),
                                    (visible = t.find("ul:visible")),
                                    visible.each(function (e) {
                                        var n = !0;
                                        parents.each(function (i) {
                                            if (parents[i] == visible[e]) return (n = !1), !1;
                                        }),
                                            n &&
                                                !s.multiopen &&
                                                i(this).parent().find("ul") != visible[e] &&
                                                i(visible[e]).slideUp(s.speed, function () {
                                                    i(this).parent("li").find("a:first").next().html(s.closedSign).addClass(s.closedSign);
                                                });
                                    }))),
                            i(this).parent().find("ul:first").is(":visible")
                                ? i(this)
                                      .parent()
                                      .find("ul:first")
                                      .slideUp(s.speed, s.easing, function () {
                                          i(this)
                                              .parent("li")
                                              .find("a:first")
                                              .next()
                                              .delay(s.speed + 1e3)
                                              .html(s.closedSign)
                                              .removeClass(s.openedSign)
                                              .addClass(s.closedSign);
                                      })
                                : i(this)
                                      .parent()
                                      .find("ul:first")
                                      .slideDown(s.speed, s.easing, function () {
                                          i(this)
                                              .parent("li")
                                              .find("a:first")
                                              .next()
                                              .delay(s.speed + 1e3)
                                              .html(s.openedSign)
                                              .removeClass(s.closedSign)
                                              .addClass(s.openedSign);
                                      }));
                    }),
                s.mouseType > 0 &&
                    t.find("li a").mouseenter(function () {
                        0 != i(this).parent().find("ul").size() &&
                            (s.accordion &&
                                (i(this).parent().find("ul").is(":visible") ||
                                    ((parents = i(this).parent().parents("ul")),
                                    (visible = t.find("ul:visible")),
                                    visible.each(function (e) {
                                        var n = !0;
                                        parents.each(function (i) {
                                            if (parents[i] == visible[e]) return (n = !1), !1;
                                        }),
                                            n &&
                                                i(this).parent().find("ul") != visible[e] &&
                                                i(visible[e]).slideUp(s.speed, function () {
                                                    i(this).parent("li").find("a:first").next().html(s.closedSign).addClass(s.closedSign);
                                                });
                                    }))),
                            i(this).parent().find("ul:first").is(":visible")
                                ? i(this)
                                      .parent()
                                      .find("ul:first")
                                      .slideUp(s.speed, function () {
                                          i(this)
                                              .parent("li")
                                              .find("a:first")
                                              .next()
                                              .delay(s.speed + 1e3)
                                              .html(s.closedSign)
                                              .removeClass(s.openedSign)
                                              .addClass(s.closedSign);
                                      })
                                : i(this)
                                      .parent()
                                      .find("ul:first")
                                      .slideDown(s.speed, function () {
                                          i(this)
                                              .parent("li")
                                              .find("a:first")
                                              .next()
                                              .delay(s.speed + 1e3)
                                              .html(s.openedSign)
                                              .removeClass(s.closedSign)
                                              .addClass(s.openedSign);
                                      }));
                    });
        },
    });
})(jQuery);
/*CountDown*/
!(function (a) {
    (a.fn.countdown = function (b) {
        var c = 36e5,
            d = 31557600,
            e = 2629800,
            f = 604800,
            g = 86400,
            h = 3600,
            i = 60,
            j = 1,
            k = /%y|%m|%w|%d|%h|%i|%s|%ty|%tm|%tw|%td|%th|%ti|%ts/g,
            l = /\d/g,
            m = function (b, c) {
                var d = b.toString().match(l),
                    e = "";
                return (
                    a.each(d, function (a, b) {
                        (b = Number(b)), (e += "" + c.digits[b] || "" + b);
                    }),
                    e
                );
            },
            n = function (a) {
                var b = new Date(),
                    c = a.data("jcdData");
                return c ? (null !== c.offset && (b = o(c.offset)), b.setMilliseconds(0), b) : new Date();
            },
            o = function (a) {
                var b,
                    d,
                    e,
                    f = new Date();
                return null !== a && ((b = a * c), (e = f.getTime() - (-f.getTimezoneOffset() / 60) * c + b), (d = f.setTime(e))), new Date(d);
            },
            p = function (a, b) {
                b.onStart && a.on("start.jcdevt", b.onStart),
                    b.onChange && a.on("change.jcdevt", b.onChange),
                    b.onComplete && a.on("complete.jcdevt", b.onComplete),
                    b.onPause && a.on("pause.jcdevt", b.onPause),
                    b.onResume && a.on("resume.jcdevt", b.onResume),
                    b.onLocaleChange && a.on("locale.jcdevt", b.onLocaleChange);
            },
            q = function (a) {
                var b = a.template,
                    c = a.yearsLeft,
                    d = a.monthsLeft,
                    e = a.weeksLeft,
                    f = a.daysLeft,
                    g = a.hrsLeft,
                    h = a.minsLeft,
                    i = a.secLeft,
                    j = !1,
                    l = !1,
                    n = !1,
                    o = !1,
                    p = !1,
                    q = !1;
                return (
                    a.isRTL && (b = a.rtlTemplate),
                    a.omitZero &&
                        (a.yearsAndMonths && (a.yearsLeft || (j = !0), a.monthsLeft || (l = !0)),
                        a.weeks && ((a.yearsAndMonths && l && !a.weeksLeft) || (!a.yearsAndMonths && !a.weeksLeft)) && (n = !0),
                        n && !f && (o = !0),
                        o && !g && (p = !0),
                        p && !h && (q = !0)),
                    a.leadingZero && (10 > c && (c = "0" + c), 10 > d && (d = "0" + d), 10 > e && (e = "0" + e), 10 > f && (f = "0" + f), 10 > g && (g = "0" + g), 10 > h && (h = "0" + h), 10 > i && (i = "0" + i)),
                    (c = m(c, a)),
                    (d = m(d, a)),
                    (e = m(e, a)),
                    (f = m(f, a)),
                    (g = m(g, a)),
                    (h = m(h, a)),
                    (i = m(i, a)),
                    a.yearsAndMonths &&
                        ((a.omitZero && j) || ((b = b.replace("%y", c)), (b = b.replace("%ty", 1 == c && a.yearSingularText ? a.yearSingularText : a.yearText))),
                        (!a.omitZero || (!j && d) || (!j && !l)) && ((b = b.replace("%m", d)), (b = b.replace("%tm", 1 == d && a.monthSingularText ? a.monthSingularText : a.monthText)))),
                    a.weeks && !n && ((b = b.replace("%w", e)), (b = b.replace("%tw", 1 == e && a.weekSingularText ? a.weekSingularText : a.weekText))),
                    o || ((b = b.replace("%d", f)), (b = b.replace("%td", 1 == f && a.daySingularText ? a.daySingularText : a.dayText))),
                    p || ((b = b.replace("%h", g)), (b = b.replace("%th", 1 == g && a.hourSingularText ? a.hourSingularText : a.hourText))),
                    q || ((b = b.replace("%i", h)), (b = b.replace("%ti", 1 == h && a.minSingularText ? a.minSingularText : a.minText))),
                    (b = b.replace("%s", i)),
                    (b = b.replace("%ts", 1 == i && a.secSingularText ? a.secSingularText : a.secText)),
                    (b = b.replace(k, ""))
                );
            },
            r = function () {
                var a,
                    b,
                    c,
                    k,
                    l,
                    m,
                    o,
                    p,
                    r = this,
                    s = 0,
                    t = 0,
                    u = 0,
                    v = "",
                    w = function (a) {
                        var b;
                        return (b = Math.floor(p / a)), (p -= b * a), b;
                    },
                    x = r.data("jcdData");
                return x
                    ? ((a = n(r)),
                      (b = null !== x.serverDiff ? new Date(x.serverDiff + x.clientdateNow.getTime()) : x.dateObj),
                      b.setMilliseconds(0),
                      (c = "down" === x.direction ? b.getTime() - a.getTime() : a.getTime() - b.getTime()),
                      (p = Math.round(c / 1e3)),
                      (k = w(g)),
                      (l = w(h)),
                      (m = w(i)),
                      (o = w(j)),
                      x.yearsAndMonths && ((p += k * g), (s = w(d)), (t = w(e)), (k = w(g))),
                      x.weeks && ((p += k * g), (u = w(f)), (k = w(g))),
                      (x.hoursOnly || x.minsOnly || x.secsOnly) && (x.yearsAndMonths && ((p += s * d), (p += t * e), (s = t = 0)), x.weeks && ((p += u * f), (u = 0))),
                      x.hoursOnly && ((p += k * g), (p += l * h), (l = w(h))),
                      x.minsOnly && ((p += k * g), (k = 0), (p += l * h), (l = 0), (p += m * i), (m = w(i))),
                      x.secsOnly && ((p += k * g), (k = 0), (p += l * h), (l = 0), (p += m * i), (m = 0), (p += o), (o = w(j))),
                      (x.yearsLeft = s),
                      (x.monthsLeft = t),
                      (x.weeksLeft = u),
                      (x.daysLeft = k),
                      (x.hrsLeft = l),
                      (x.minsLeft = m),
                      (x.secLeft = o),
                      r.data("jcdData", x),
                      ("down" === x.direction && (b > a || x.minus)) || ("up" === x.direction && (a > b || x.minus))
                          ? (v = q(x))
                          : ((x.yearsLeft = x.monthsLeft = x.weeksLeft = x.daysLeft = x.hrsLeft = x.minsLeft = x.secLeft = 0), (v = q(x)), (x.hasCompleted = !0)),
                      r.html(v).triggerMulti("change.jcdevt,countChange", [x]),
                      void (x.hasCompleted && (r.triggerMulti("complete.jcdevt,countComplete"), clearInterval(x.timer))))
                    : !1;
            },
            s = {
                init: function (b) {
                    var c,
                        d,
                        e = a.extend({}, a.fn.countdown.defaults, b),
                        f = {};
                    return this.each(function () {
                        var g,
                            h = a(this);
                        return (
                            h.data("jcdData") && (h.countdown("changeSettings", b, !0), (e = h.data("jcdData"))),
                            null === e.date && null === e.dataAttr
                                ? (a.error("No Date passed to jCountdown. date option is required."), !0)
                                : ((d = e.date ? e.date : h.attr("data-" + e.dataAttr)),
                                  (c = new Date(d)),
                                  "Invalid Date" === c.toString() && a.error("Invalid Date passed to jCountdown: " + d),
                                  p(h, b),
                                  (f = a.extend({}, e)),
                                  (f.dom = {}),
                                  (f.dom.$time = a("<" + f.timeWrapElement + ">").addClass(f.timeWrapClass)),
                                  (f.dom.$text = a("<" + f.textWrapElement + ">").addClass(f.textWrapClass)),
                                  (f.clientdateNow = new Date()),
                                  f.clientdateNow.setMilliseconds(0),
                                  (f.originalHTML = h.html()),
                                  (f.dateObj = new Date(d)),
                                  f.dateObj.setMilliseconds(0),
                                  (f.hasCompleted = !1),
                                  (f.timer = 0),
                                  (f.yearsLeft = f.monthsLeft = f.weeksLeft = f.daysLeft = f.hrsLeft = f.minsLeft = f.secLeft = 0),
                                  (f.difference = null),
                                  (g = a.proxy(r, h)),
                                  (f.timer = setInterval(g, f.updateTime)),
                                  h.data("jcdData", f).triggerMulti("start.jcdevt,countStart", [f]),
                                  void g())
                        );
                    });
                },
                changeSettings: function (b, c) {
                    return this.each(function () {
                        var d,
                            e,
                            f = a(this),
                            g = a.proxy(r, f);
                        return f.data("jcdData")
                            ? ((d = a.extend({}, f.data("jcdData"), b)),
                              b.hasOwnProperty("date") && ((e = new Date(b.date)), "Invalid Date" === e.toString() && a.error("Invalid Date passed to jCountdown: " + b.date)),
                              (d.completed = !1),
                              (d.dateObj = new Date(b.date)),
                              clearInterval(d.timer),
                              f.off(".jcdevt").data("jcdData", d),
                              c || (p(f, d), (d.timer = setInterval(g, d.updateTime)), f.data("jcdData", d), g()),
                              void (d = null))
                            : !0;
                    });
                },
                resume: function () {
                    return this.each(function () {
                        var b = a(this),
                            c = b.data("jcdData"),
                            d = a.proxy(r, b);
                        if (!c) return !0;
                        if ((b.data("jcdData", c).triggerMulti("resume.jcdevt,countResume", [c]), !c.hasCompleted)) {
                            if (((c.timer = setInterval(d, c.updateTime)), c.stopwatch && "up" === c.direction)) {
                                var e = n(b).getTime() - c.pausedAt.getTime(),
                                    f = new Date();
                                f.setTime(c.dateObj.getTime() + e), (c.dateObj = f);
                            }
                            d();
                        }
                    });
                },
                pause: function () {
                    return this.each(function () {
                        var b = a(this),
                            c = b.data("jcdData");
                        return c ? (c.stopwatch && (c.pausedAt = n(b)), clearInterval(c.timer), void b.data("jcdData", c).triggerMulti("pause.jcdevt,countPause", [c])) : !0;
                    });
                },
                complete: function () {
                    return this.each(function () {
                        var b = a(this),
                            c = b.data("jcdData");
                        return c ? (clearInterval(c.timer), (c.hasCompleted = !0), void b.data("jcdData", c).triggerMulti("complete.jcdevt,countComplete", [c])) : !0;
                    });
                },
                destroy: function () {
                    return this.each(function () {
                        var b = a(this),
                            c = b.data("jcdData");
                        return c ? (clearInterval(c.timer), void b.off(".jcdevt").removeData("jcdData").html(c.originalHTML)) : !0;
                    });
                },
                getSettings: function (b) {
                    var c = a(this),
                        d = c.data("jcdData");
                    return b && d ? (d.hasOwnProperty(b) ? d[b] : void 0) : d;
                },
                changeLocale: function (b) {
                    var c = a(this),
                        d = c.data("jcdData");
                    return a.fn.countdown.locale[b] ? (a.extend(d, a.fn.countdown.locale[b]), c.data("jcdData", d).triggerMulti("locale.jcdevt,localeChange", [d]), !0) : (a.error("Locale '" + b + "' does not exist"), !1);
                },
            };
        return s[b] ? s[b].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" != typeof b && b ? void a.error("Method " + b + " does not exist in the jCountdown Plugin") : s.init.apply(this, arguments);
    }),
        (a.fn.countdown.defaults = {
            date: null,
            dataAttr: null,
            updateTime: 1e3,
            yearText: "years",
            monthText: "months",
            weekText: "weeks",
            dayText: "days",
            hourText: "hours",
            minText: "mins",
            secText: "sec",
            yearSingularText: "year",
            monthSingularText: "month",
            weekSingularText: "week",
            daySingularText: "day",
            hourSingularText: "hour",
            minSingularText: "min",
            secSingularText: "sec",
            digits: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            isRTL: !1,
            minus: !1,
            onStart: null,
            onChange: null,
            onComplete: null,
            onResume: null,
            onPause: null,
            onLocaleChange: null,
            leadingZero: !1,
            offset: null,
            serverDiff: null,
            hoursOnly: !1,
            minsOnly: !1,
            secsOnly: !1,
            weeks: !1,
            hours: !1,
            yearsAndMonths: !1,
            direction: "down",
            stopwatch: !1,
            omitZero: !1,
            rtlTemplate: "%ts %s : %ti %i : %th %h : %tm %m : %ty %y",
            template: "%y %ty : %m %tm : %h %th : %i %ti : %s %ts",
        }),
        (a.fn.countdown.locale = []),
        (a.fn.countdown.locale.en = {
            yearText: "years",
            monthText: "months",
            weekText: "weeks",
            dayText: "days",
            hourText: "hours",
            minText: "mins",
            secText: "sec",
            yearSingularText: "year",
            monthSingularText: "month",
            weekSingularText: "week",
            daySingularText: "day",
            hourSingularText: "hour",
            minSingularText: "min",
            secSingularText: "sec",
            isRTL: !1,
        }),
        (a.fn.triggerMulti = function (b, c) {
            var d = b.split(",");
            return this.each(function () {
                for (var b = a(this), e = 0; e < d.length; e++) b.trigger(d[e], c);
            });
        });
})(jQuery);
//countTo
!(function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? t(require("jquery")) : t(jQuery);
})(function (t) {
    var e = function (o, i) {
        (this.$element = t(o)), (this.options = t.extend({}, e.DEFAULTS, this.dataOptions(), i)), this.init();
    };
    (e.DEFAULTS = {
        from: 0,
        to: 0,
        speed: 1e3,
        refreshInterval: 100,
        decimals: 0,
        formatter: function (t, e) {
            return t.toFixed(e.decimals);
        },
        onUpdate: null,
        onComplete: null,
    }),
        (e.prototype.init = function () {
            (this.value = this.options.from), (this.loops = Math.ceil(this.options.speed / this.options.refreshInterval)), (this.loopCount = 0), (this.increment = (this.options.to - this.options.from) / this.loops);
        }),
        (e.prototype.dataOptions = function () {
            var t = { from: this.$element.data("from"), to: this.$element.data("to"), speed: this.$element.data("speed"), refreshInterval: this.$element.data("refresh-interval"), decimals: this.$element.data("decimals") },
                e = Object.keys(t);
            for (var o in e) {
                var i = e[o];
                void 0 === t[i] && delete t[i];
            }
            return t;
        }),
        (e.prototype.update = function () {
            (this.value += this.increment),
                this.loopCount++,
                this.render(),
                "function" == typeof this.options.onUpdate && this.options.onUpdate.call(this.$element, this.value),
                this.loopCount >= this.loops && (clearInterval(this.interval), (this.value = this.options.to), "function" == typeof this.options.onComplete && this.options.onComplete.call(this.$element, this.value));
        }),
        (e.prototype.render = function () {
            var t = this.options.formatter.call(this.$element, this.value, this.options);
            this.$element.text(t);
        }),
        (e.prototype.restart = function () {
            this.stop(), this.init(), this.start();
        }),
        (e.prototype.start = function () {
            this.stop(), this.render(), (this.interval = setInterval(this.update.bind(this), this.options.refreshInterval));
        }),
        (e.prototype.stop = function () {
            this.interval && clearInterval(this.interval);
        }),
        (e.prototype.toggle = function () {
            this.interval ? this.stop() : this.start();
        }),
        (t.fn.countTo = function (o) {
            return this.each(function () {
                var i = t(this),
                    n = i.data("countTo"),
                    s = "object" == typeof o ? o : {},
                    r = "string" == typeof o ? o : "start";
                (!n || "object" == typeof o) && (n && n.stop(), i.data("countTo", (n = new e(this, s)))), n[r].call(n);
            });
        });
});
// waypoint 4.01
!(function () {
    "use strict";
    function t(o) {
        if (!o) throw new Error("No options passed to Waypoint constructor");
        if (!o.element) throw new Error("No element option passed to Waypoint constructor");
        if (!o.handler) throw new Error("No handler option passed to Waypoint constructor");
        (this.key = "waypoint-" + e),
            (this.options = t.Adapter.extend({}, t.defaults, o)),
            (this.element = this.options.element),
            (this.adapter = new t.Adapter(this.element)),
            (this.callback = o.handler),
            (this.axis = this.options.horizontal ? "horizontal" : "vertical"),
            (this.enabled = this.options.enabled),
            (this.triggerPoint = null),
            (this.group = t.Group.findOrCreate({ name: this.options.group, axis: this.axis })),
            (this.context = t.Context.findOrCreateByElement(this.options.context)),
            t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]),
            this.group.add(this),
            this.context.add(this),
            (i[this.key] = this),
            (e += 1);
    }
    var e = 0,
        i = {};
    (t.prototype.queueTrigger = function (t) {
        this.group.queueTrigger(this, t);
    }),
        (t.prototype.trigger = function (t) {
            this.enabled && this.callback && this.callback.apply(this, t);
        }),
        (t.prototype.destroy = function () {
            this.context.remove(this), this.group.remove(this), delete i[this.key];
        }),
        (t.prototype.disable = function () {
            return (this.enabled = !1), this;
        }),
        (t.prototype.enable = function () {
            return this.context.refresh(), (this.enabled = !0), this;
        }),
        (t.prototype.next = function () {
            return this.group.next(this);
        }),
        (t.prototype.previous = function () {
            return this.group.previous(this);
        }),
        (t.invokeAll = function (t) {
            var e = [];
            for (var o in i) e.push(i[o]);
            for (var n = 0, r = e.length; r > n; n++) e[n][t]();
        }),
        (t.destroyAll = function () {
            t.invokeAll("destroy");
        }),
        (t.disableAll = function () {
            t.invokeAll("disable");
        }),
        (t.enableAll = function () {
            t.Context.refreshAll();
            for (var e in i) i[e].enabled = !0;
            return this;
        }),
        (t.refreshAll = function () {
            t.Context.refreshAll();
        }),
        (t.viewportHeight = function () {
            return window.innerHeight || document.documentElement.clientHeight;
        }),
        (t.viewportWidth = function () {
            return document.documentElement.clientWidth;
        }),
        (t.adapters = []),
        (t.defaults = { context: window, continuous: !0, enabled: !0, group: "default", horizontal: !1, offset: 0 }),
        (t.offsetAliases = {
            "bottom-in-view": function () {
                return this.context.innerHeight() - this.adapter.outerHeight();
            },
            "right-in-view": function () {
                return this.context.innerWidth() - this.adapter.outerWidth();
            },
        }),
        (window.Waypoint = t);
})(),
    (function () {
        "use strict";
        function t(t) {
            window.setTimeout(t, 1e3 / 60);
        }
        function e(t) {
            (this.element = t),
                (this.Adapter = n.Adapter),
                (this.adapter = new this.Adapter(t)),
                (this.key = "waypoint-context-" + i),
                (this.didScroll = !1),
                (this.didResize = !1),
                (this.oldScroll = { x: this.adapter.scrollLeft(), y: this.adapter.scrollTop() }),
                (this.waypoints = { vertical: {}, horizontal: {} }),
                (t.waypointContextKey = this.key),
                (o[t.waypointContextKey] = this),
                (i += 1),
                n.windowContext || ((n.windowContext = !0), (n.windowContext = new e(window))),
                this.createThrottledScrollHandler(),
                this.createThrottledResizeHandler();
        }
        var i = 0,
            o = {},
            n = window.Waypoint,
            r = window.onload;
        (e.prototype.add = function (t) {
            var e = t.options.horizontal ? "horizontal" : "vertical";
            (this.waypoints[e][t.key] = t), this.refresh();
        }),
            (e.prototype.checkEmpty = function () {
                var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
                    e = this.Adapter.isEmptyObject(this.waypoints.vertical),
                    i = this.element == this.element.window;
                t && e && !i && (this.adapter.off(".waypoints"), delete o[this.key]);
            }),
            (e.prototype.createThrottledResizeHandler = function () {
                function t() {
                    e.handleResize(), (e.didResize = !1);
                }
                var e = this;
                this.adapter.on("resize.waypoints", function () {
                    e.didResize || ((e.didResize = !0), n.requestAnimationFrame(t));
                });
            }),
            (e.prototype.createThrottledScrollHandler = function () {
                function t() {
                    e.handleScroll(), (e.didScroll = !1);
                }
                var e = this;
                this.adapter.on("scroll.waypoints", function () {
                    (!e.didScroll || n.isTouch) && ((e.didScroll = !0), n.requestAnimationFrame(t));
                });
            }),
            (e.prototype.handleResize = function () {
                n.Context.refreshAll();
            }),
            (e.prototype.handleScroll = function () {
                var t = {},
                    e = {
                        horizontal: { newScroll: this.adapter.scrollLeft(), oldScroll: this.oldScroll.x, forward: "right", backward: "left" },
                        vertical: { newScroll: this.adapter.scrollTop(), oldScroll: this.oldScroll.y, forward: "down", backward: "up" },
                    };
                for (var i in e) {
                    var o = e[i],
                        n = o.newScroll > o.oldScroll,
                        r = n ? o.forward : o.backward;
                    for (var s in this.waypoints[i]) {
                        var a = this.waypoints[i][s];
                        if (null !== a.triggerPoint) {
                            var l = o.oldScroll < a.triggerPoint,
                                h = o.newScroll >= a.triggerPoint,
                                p = l && h,
                                u = !l && !h;
                            (p || u) && (a.queueTrigger(r), (t[a.group.id] = a.group));
                        }
                    }
                }
                for (var c in t) t[c].flushTriggers();
                this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll };
            }),
            (e.prototype.innerHeight = function () {
                return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight();
            }),
            (e.prototype.remove = function (t) {
                delete this.waypoints[t.axis][t.key], this.checkEmpty();
            }),
            (e.prototype.innerWidth = function () {
                return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth();
            }),
            (e.prototype.destroy = function () {
                var t = [];
                for (var e in this.waypoints) for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]);
                for (var o = 0, n = t.length; n > o; o++) t[o].destroy();
            }),
            (e.prototype.refresh = function () {
                var t,
                    e = this.element == this.element.window,
                    i = e ? void 0 : this.adapter.offset(),
                    o = {};
                this.handleScroll(),
                    (t = {
                        horizontal: { contextOffset: e ? 0 : i.left, contextScroll: e ? 0 : this.oldScroll.x, contextDimension: this.innerWidth(), oldScroll: this.oldScroll.x, forward: "right", backward: "left", offsetProp: "left" },
                        vertical: { contextOffset: e ? 0 : i.top, contextScroll: e ? 0 : this.oldScroll.y, contextDimension: this.innerHeight(), oldScroll: this.oldScroll.y, forward: "down", backward: "up", offsetProp: "top" },
                    });
                for (var r in t) {
                    var s = t[r];
                    for (var a in this.waypoints[r]) {
                        var l,
                            h,
                            p,
                            u,
                            c,
                            d = this.waypoints[r][a],
                            f = d.options.offset,
                            w = d.triggerPoint,
                            y = 0,
                            g = null == w;
                        d.element !== d.element.window && (y = d.adapter.offset()[s.offsetProp]),
                            "function" == typeof f ? (f = f.apply(d)) : "string" == typeof f && ((f = parseFloat(f)), d.options.offset.indexOf("%") > -1 && (f = Math.ceil((s.contextDimension * f) / 100))),
                            (l = s.contextScroll - s.contextOffset),
                            (d.triggerPoint = Math.floor(y + l - f)),
                            (h = w < s.oldScroll),
                            (p = d.triggerPoint >= s.oldScroll),
                            (u = h && p),
                            (c = !h && !p),
                            !g && u
                                ? (d.queueTrigger(s.backward), (o[d.group.id] = d.group))
                                : !g && c
                                ? (d.queueTrigger(s.forward), (o[d.group.id] = d.group))
                                : g && s.oldScroll >= d.triggerPoint && (d.queueTrigger(s.forward), (o[d.group.id] = d.group));
                    }
                }
                return (
                    n.requestAnimationFrame(function () {
                        for (var t in o) o[t].flushTriggers();
                    }),
                    this
                );
            }),
            (e.findOrCreateByElement = function (t) {
                return e.findByElement(t) || new e(t);
            }),
            (e.refreshAll = function () {
                for (var t in o) o[t].refresh();
            }),
            (e.findByElement = function (t) {
                return o[t.waypointContextKey];
            }),
            (window.onload = function () {
                r && r(), e.refreshAll();
            }),
            (n.requestAnimationFrame = function (e) {
                var i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;
                i.call(window, e);
            }),
            (n.Context = e);
    })(),
    (function () {
        "use strict";
        function t(t, e) {
            return t.triggerPoint - e.triggerPoint;
        }
        function e(t, e) {
            return e.triggerPoint - t.triggerPoint;
        }
        function i(t) {
            (this.name = t.name), (this.axis = t.axis), (this.id = this.name + "-" + this.axis), (this.waypoints = []), this.clearTriggerQueues(), (o[this.axis][this.name] = this);
        }
        var o = { vertical: {}, horizontal: {} },
            n = window.Waypoint;
        (i.prototype.add = function (t) {
            this.waypoints.push(t);
        }),
            (i.prototype.clearTriggerQueues = function () {
                this.triggerQueues = { up: [], down: [], left: [], right: [] };
            }),
            (i.prototype.flushTriggers = function () {
                for (var i in this.triggerQueues) {
                    var o = this.triggerQueues[i],
                        n = "up" === i || "left" === i;
                    o.sort(n ? e : t);
                    for (var r = 0, s = o.length; s > r; r += 1) {
                        var a = o[r];
                        (a.options.continuous || r === o.length - 1) && a.trigger([i]);
                    }
                }
                this.clearTriggerQueues();
            }),
            (i.prototype.next = function (e) {
                this.waypoints.sort(t);
                var i = n.Adapter.inArray(e, this.waypoints),
                    o = i === this.waypoints.length - 1;
                return o ? null : this.waypoints[i + 1];
            }),
            (i.prototype.previous = function (e) {
                this.waypoints.sort(t);
                var i = n.Adapter.inArray(e, this.waypoints);
                return i ? this.waypoints[i - 1] : null;
            }),
            (i.prototype.queueTrigger = function (t, e) {
                this.triggerQueues[e].push(t);
            }),
            (i.prototype.remove = function (t) {
                var e = n.Adapter.inArray(t, this.waypoints);
                e > -1 && this.waypoints.splice(e, 1);
            }),
            (i.prototype.first = function () {
                return this.waypoints[0];
            }),
            (i.prototype.last = function () {
                return this.waypoints[this.waypoints.length - 1];
            }),
            (i.findOrCreate = function (t) {
                return o[t.axis][t.name] || new i(t);
            }),
            (n.Group = i);
    })(),
    (function () {
        "use strict";
        function t(t) {
            this.$element = e(t);
        }
        var e = window.jQuery,
            i = window.Waypoint;
        e.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function (e, i) {
            t.prototype[i] = function () {
                var t = Array.prototype.slice.call(arguments);
                return this.$element[i].apply(this.$element, t);
            };
        }),
            e.each(["extend", "inArray", "isEmptyObject"], function (i, o) {
                t[o] = e[o];
            }),
            i.adapters.push({ name: "jquery", Adapter: t }),
            (i.Adapter = t);
    })(),
    (function () {
        "use strict";
        function t(t) {
            return function () {
                var i = [],
                    o = arguments[0];
                return (
                    t.isFunction(arguments[0]) && ((o = t.extend({}, arguments[1])), (o.handler = arguments[0])),
                    this.each(function () {
                        var n = t.extend({}, o, { element: this });
                        "string" == typeof n.context && (n.context = t(this).closest(n.context)[0]), i.push(new e(n));
                    }),
                    i
                );
            };
        }
        var e = window.Waypoint;
        window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto));
    })();
// timeago
!(function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : t(jQuery);
})(function (t) {
    function e() {
        var e = a(this),
            o = n.settings;
        return isNaN(e.datetime) || ((0 == o.cutoff || r(e.datetime) < o.cutoff) && t(this).text(i(e.datetime))), this;
    }
    function a(e) {
        if (((e = t(e)), !e.data("timeago"))) {
            e.data("timeago", { datetime: n.datetime(e) });
            var a = t.trim(e.text());
            n.settings.localeTitle ? e.attr("title", e.data("timeago").datetime.toLocaleString()) : !(a.length > 0) || (n.isTime(e) && e.attr("title")) || e.attr("title", a);
        }
        return e.data("timeago");
    }
    function i(t) {
        return n.inWords(r(t));
    }
    function r(t) {
        return new Date().getTime() - t.getTime();
    }
    t.timeago = function (e) {
        return i(e instanceof Date ? e : "string" == typeof e ? t.timeago.parse(e) : "number" == typeof e ? new Date(e) : t.timeago.datetime(e));
    };
    var n = t.timeago;
    t.extend(t.timeago, {
        settings: {
            refreshMillis: 6e4,
            allowFuture: !1,
            localeTitle: !1,
            cutoff: 0,
            strings: {
                prefixAgo: null,
                prefixFromNow: null,
                suffixAgo: "ago",
                suffixFromNow: "from now",
                seconds: "less than a minute",
                minute: "about a minute",
                minutes: "%d minutes",
                hour: "about an hour",
                hours: "about %d hours",
                day: "a day",
                days: "%d days",
                month: "about a month",
                months: "%d months",
                year: "about a year",
                years: "%d years",
                wordSeparator: " ",
                numbers: [],
            },
        },
        inWords: function (e) {
            function a(a, r) {
                var n = t.isFunction(a) ? a(r, e) : a,
                    o = (i.numbers && i.numbers[r]) || r;
                return n.replace(/%d/i, o);
            }
            var i = this.settings.strings,
                r = i.prefixAgo,
                n = i.suffixAgo;
            this.settings.allowFuture && 0 > e && ((r = i.prefixFromNow), (n = i.suffixFromNow));
            var o = Math.abs(e) / 1e3,
                s = o / 60,
                u = s / 60,
                m = u / 24,
                d = m / 365,
                l =
                    (45 > o && a(i.seconds, Math.round(o))) ||
                    (90 > o && a(i.minute, 1)) ||
                    (45 > s && a(i.minutes, Math.round(s))) ||
                    (90 > s && a(i.hour, 1)) ||
                    (24 > u && a(i.hours, Math.round(u))) ||
                    (42 > u && a(i.day, 1)) ||
                    (30 > m && a(i.days, Math.round(m))) ||
                    (45 > m && a(i.month, 1)) ||
                    (365 > m && a(i.months, Math.round(m / 30))) ||
                    (1.5 > d && a(i.year, 1)) ||
                    a(i.years, Math.round(d)),
                f = i.wordSeparator || "";
            return void 0 === i.wordSeparator && (f = " "), t.trim([r, l, n].join(f));
        },
        parse: function (e) {
            var a = t.trim(e);
            return (
                (a = a.replace(/\.\d+/, "")),
                (a = a.replace(/-/, "/").replace(/-/, "/")),
                (a = a.replace(/T/, " ").replace(/Z/, " UTC")),
                (a = a.replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2")),
                (a = a.replace(/([\+\-]\d\d)$/, " $100")),
                new Date(1e3 * a || a)
            );
        },
        datetime: function (e) {
            var a = t(e).attr(n.isTime(e) ? "datetime" : "title");
            return n.parse(a);
        },
        isTime: function (e) {
            return "time" === t(e).get(0).tagName.toLowerCase();
        },
    });
    var o = {
        init: function () {
            var a = t.proxy(e, this);
            a();
            var i = n.settings;
            i.refreshMillis > 0 && (this._timeagoInterval = setInterval(a, i.refreshMillis));
        },
        update: function (a) {
            var i = n.parse(a);
            t(this).data("timeago", { datetime: i }), n.settings.localeTitle && t(this).attr("title", i.toLocaleString()), e.apply(this);
        },
        updateFromDOM: function () {
            t(this).data("timeago", { datetime: n.parse(t(this).attr(n.isTime(this) ? "datetime" : "title")) }), e.apply(this);
        },
        dispose: function () {
            this._timeagoInterval && (window.clearInterval(this._timeagoInterval), (this._timeagoInterval = null));
        },
    };
    (t.fn.timeago = function (t, e) {
        var a = t ? o[t] : o.init;
        if (!a) throw new Error("Unknown function name '" + t + "' for timeago");
        return (
            this.each(function () {
                a.call(this, e);
            }),
            this
        );
    }),
        document.createElement("abbr"),
        document.createElement("time");
});
/*! lazysizes - v4.1.5 */
!(function (t, e) {
    var i = (function (t, e) {
        "use strict";
        if (!e.getElementsByClassName) return;
        var i,
            n,
            a = e.documentElement,
            r = t.Date,
            s = t.HTMLPictureElement,
            o = t.addEventListener,
            l = t.setTimeout,
            d = t.requestAnimationFrame || l,
            u = t.requestIdleCallback,
            c = /^picture$/i,
            f = ["load", "error", "lazyincluded", "_lazyloaded"],
            g = {},
            m = Array.prototype.forEach,
            v = function (t, e) {
                return g[e] || (g[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), g[e].test(t.getAttribute("class") || "") && g[e];
            },
            z = function (t, e) {
                v(t, e) || t.setAttribute("class", (t.getAttribute("class") || "").trim() + " " + e);
            },
            y = function (t, e) {
                var i;
                (i = v(t, e)) && t.setAttribute("class", (t.getAttribute("class") || "").replace(i, " "));
            },
            h = function (t, e, i) {
                var n = i ? "addEventListener" : "removeEventListener";
                i && h(t, e),
                    f.forEach(function (i) {
                        t[n](i, e);
                    });
            },
            b = function (t, n, a, r, s) {
                var o = e.createEvent("Event");
                return a || (a = {}), (a.instance = i), o.initEvent(n, !r, !s), (o.detail = a), t.dispatchEvent(o), o;
            },
            p = function (e, i) {
                var a;
                !s && (a = t.picturefill || n.pf) ? (i && i.src && !e.getAttribute("srcset") && e.setAttribute("srcset", i.src), a({ reevaluate: !0, elements: [e] })) : i && i.src && (e.src = i.src);
            },
            A = function (t, e) {
                return (getComputedStyle(t, null) || {})[e];
            },
            C = function (t, e, i) {
                for (i = i || t.offsetWidth; i < n.minSize && e && !t._lazysizesWidth; ) (i = e.offsetWidth), (e = e.parentNode);
                return i;
            },
            E = (function () {
                var t,
                    i,
                    n = [],
                    a = [],
                    r = n,
                    s = function () {
                        var e = r;
                        for (r = n.length ? a : n, t = !0, i = !1; e.length; ) e.shift()();
                        t = !1;
                    },
                    o = function (n, a) {
                        t && !a ? n.apply(this, arguments) : (r.push(n), i || ((i = !0), (e.hidden ? l : d)(s)));
                    };
                return (o._lsFlush = s), o;
            })(),
            w = function (t, e) {
                return e
                    ? function () {
                          E(t);
                      }
                    : function () {
                          var e = this,
                              i = arguments;
                          E(function () {
                              t.apply(e, i);
                          });
                      };
            },
            M = function (t) {
                var e,
                    i,
                    n = function () {
                        (e = null), t();
                    },
                    a = function () {
                        var t = r.now() - i;
                        t < 99 ? l(a, 99 - t) : (u || n)(n);
                    };
                return function () {
                    (i = r.now()), e || (e = l(a, 99));
                };
            };
        !(function () {
            var e,
                i = {
                    lazyClass: "lazyload",
                    loadedClass: "lazyloaded",
                    loadingClass: "lazyloading",
                    preloadClass: "lazypreload",
                    errorClass: "lazyerror",
                    autosizesClass: "lazyautosizes",
                    srcAttr: "data-src",
                    srcsetAttr: "data-srcset",
                    sizesAttr: "data-sizes",
                    minSize: 40,
                    customMedia: {},
                    init: !0,
                    expFactor: 1.5,
                    hFac: 0.8,
                    loadMode: 2,
                    loadHidden: !0,
                    ricTimeout: 0,
                    throttleDelay: 125,
                };
            n = t.lazySizesConfig || t.lazysizesConfig || {};
            for (e in i) e in n || (n[e] = i[e]);
            (t.lazySizesConfig = n),
                l(function () {
                    n.init && L();
                });
        })();
        var N = (function () {
                var s,
                    d,
                    f,
                    g,
                    C,
                    N,
                    L,
                    W,
                    x,
                    T,
                    B,
                    F,
                    S,
                    R,
                    k = /^img$/i,
                    D = /^iframe$/i,
                    H = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
                    O = 0,
                    P = 0,
                    I = -1,
                    q = function (t) {
                        P--, t && t.target && h(t.target, q), (!t || P < 0 || !t.target) && (P = 0);
                    },
                    j = function (t, i) {
                        var n,
                            r = t,
                            s = "hidden" == A(e.body, "visibility") || ("hidden" != A(t.parentNode, "visibility") && "hidden" != A(t, "visibility"));
                        for (W -= i, B += i, x -= i, T += i; s && (r = r.offsetParent) && r != e.body && r != a; )
                            (s = (A(r, "opacity") || 1) > 0) && "visible" != A(r, "overflow") && ((n = r.getBoundingClientRect()), (s = T > n.left && x < n.right && B > n.top - 1 && W < n.bottom + 1));
                        return s;
                    },
                    G = function () {
                        var t,
                            r,
                            o,
                            l,
                            u,
                            c,
                            f,
                            m,
                            v,
                            z = i.elements;
                        if ((g = n.loadMode) && P < 8 && (t = z.length)) {
                            (r = 0),
                                I++,
                                null == S && ("expand" in n || (n.expand = a.clientHeight > 500 && a.clientWidth > 500 ? 500 : 370), (F = n.expand), (S = F * n.expFactor)),
                                O < S && P < 1 && I > 2 && g > 2 && !e.hidden ? ((O = S), (I = 0)) : (O = g > 1 && I > 1 && P < 6 ? F : 0);
                            for (; r < t; r++)
                                if (z[r] && !z[r]._lazyRace)
                                    if (H)
                                        if (
                                            (((m = z[r].getAttribute("data-expand")) && (c = 1 * m)) || (c = O),
                                            v !== c && ((N = innerWidth + c * R), (L = innerHeight + c), (f = -1 * c), (v = c)),
                                            (o = z[r].getBoundingClientRect()),
                                            (B = o.bottom) >= f &&
                                                (W = o.top) <= L &&
                                                (T = o.right) >= f * R &&
                                                (x = o.left) <= N &&
                                                (B || T || x || W) &&
                                                (n.loadHidden || "hidden" != A(z[r], "visibility")) &&
                                                ((d && P < 3 && !m && (g < 3 || I < 4)) || j(z[r], c)))
                                        ) {
                                            if ((Y(z[r]), (u = !0), P > 9)) break;
                                        } else !u && d && !l && P < 4 && I < 4 && g > 2 && (s[0] || n.preloadAfterLoad) && (s[0] || (!m && (B || T || x || W || "auto" != z[r].getAttribute(n.sizesAttr)))) && (l = s[0] || z[r]);
                                    else Y(z[r]);
                            l && !u && Y(l);
                        }
                    },
                    J = (function (t) {
                        var e,
                            i = 0,
                            a = n.throttleDelay,
                            s = n.ricTimeout,
                            o = function () {
                                (e = !1), (i = r.now()), t();
                            },
                            d =
                                u && s > 49
                                    ? function () {
                                          u(o, { timeout: s }), s !== n.ricTimeout && (s = n.ricTimeout);
                                      }
                                    : w(function () {
                                          l(o);
                                      }, !0);
                        return function (t) {
                            var n;
                            (t = !0 === t) && (s = 33), e || ((e = !0), (n = a - (r.now() - i)) < 0 && (n = 0), t || n < 9 ? d() : l(d, n));
                        };
                    })(G),
                    K = function (t) {
                        z(t.target, n.loadedClass), y(t.target, n.loadingClass), h(t.target, U), b(t.target, "lazyloaded");
                    },
                    Q = w(K),
                    U = function (t) {
                        Q({ target: t.target });
                    },
                    V = function (t) {
                        var e,
                            i = t.getAttribute(n.srcsetAttr);
                        (e = n.customMedia[t.getAttribute("data-media") || t.getAttribute("media")]) && t.setAttribute("media", e), i && t.setAttribute("srcset", i);
                    },
                    X = w(function (t, e, i, a, r) {
                        var s, o, d, u, g, v;
                        (g = b(t, "lazybeforeunveil", e)).defaultPrevented ||
                            (a && (i ? z(t, n.autosizesClass) : t.setAttribute("sizes", a)),
                            (o = t.getAttribute(n.srcsetAttr)),
                            (s = t.getAttribute(n.srcAttr)),
                            r && ((d = t.parentNode), (u = d && c.test(d.nodeName || ""))),
                            (v = e.firesLoad || ("src" in t && (o || s || u))),
                            (g = { target: t }),
                            v && (h(t, q, !0), clearTimeout(f), (f = l(q, 2500)), z(t, n.loadingClass), h(t, U, !0)),
                            u && m.call(d.getElementsByTagName("source"), V),
                            o
                                ? t.setAttribute("srcset", o)
                                : s &&
                                  !u &&
                                  (D.test(t.nodeName)
                                      ? (function (t, e) {
                                            try {
                                                t.contentWindow.location.replace(e);
                                            } catch (i) {
                                                t.src = e;
                                            }
                                        })(t, s)
                                      : $("<img />")
                                            .bind("load", function () {
                                                $(t).css("padding-top", ""), (t.src = s);
                                            })
                                            .attr("src", s)),
                            r && (o || u) && p(t, { src: s })),
                            t._lazyRace && delete t._lazyRace,
                            y(t, n.lazyClass),
                            E(function () {
                                (!v || (t.complete && t.naturalWidth > 1)) && (v ? q(g) : P--, K(g));
                            }, !0);
                    }),
                    Y = function (t) {
                        var e,
                            i = k.test(t.nodeName),
                            a = i && (t.getAttribute(n.sizesAttr) || t.getAttribute("sizes")),
                            r = "auto" == a;
                        ((!r && d) || !i || (!t.getAttribute("src") && !t.srcset) || t.complete || v(t, n.errorClass) || !v(t, n.lazyClass)) &&
                            ((e = b(t, "lazyunveilread").detail), r && _.updateElem(t, !0, t.offsetWidth), (t._lazyRace = !0), P++, X(t, e, r, a, i));
                    },
                    Z = function () {
                        if (!d)
                            if (r.now() - C < 999) l(Z, 999);
                            else {
                                var t = M(function () {
                                    (n.loadMode = 3), J();
                                });
                                (d = !0),
                                    (n.loadMode = 3),
                                    J(),
                                    o(
                                        "scroll",
                                        function () {
                                            3 == n.loadMode && (n.loadMode = 2), t();
                                        },
                                        !0
                                    );
                            }
                    };
                return {
                    _: function () {
                        (C = r.now()),
                            (i.elements = e.getElementsByClassName(n.lazyClass)),
                            (s = e.getElementsByClassName(n.lazyClass + " " + n.preloadClass)),
                            (R = n.hFac),
                            o("scroll", J, !0),
                            o("resize", J, !0),
                            t.MutationObserver
                                ? new MutationObserver(J).observe(a, { childList: !0, subtree: !0, attributes: !0 })
                                : (a.addEventListener("DOMNodeInserted", J, !0), a.addEventListener("DOMAttrModified", J, !0), setInterval(J, 999)),
                            o("hashchange", J, !0),
                            ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (t) {
                                e.addEventListener(t, J, !0);
                            }),
                            /d$|^c/.test(e.readyState) ? Z() : (o("load", Z), e.addEventListener("DOMContentLoaded", J), l(Z, 2e4)),
                            i.elements.length ? (G(), E._lsFlush()) : J();
                    },
                    checkElems: J,
                    unveil: Y,
                };
            })(),
            _ = (function () {
                var t,
                    i = w(function (t, e, i, n) {
                        var a, r, s;
                        if (((t._lazysizesWidth = n), (n += "px"), t.setAttribute("sizes", n), c.test(e.nodeName || ""))) for (a = e.getElementsByTagName("source"), r = 0, s = a.length; r < s; r++) a[r].setAttribute("sizes", n);
                        i.detail.dataAttr || p(t, i.detail);
                    }),
                    a = function (t, e, n) {
                        var a,
                            r = t.parentNode;
                        r && ((n = C(t, r, n)), (a = b(t, "lazybeforesizes", { width: n, dataAttr: !!e })).defaultPrevented || ((n = a.detail.width) && n !== t._lazysizesWidth && i(t, r, a, n)));
                    },
                    r = M(function () {
                        var e,
                            i = t.length;
                        if (i) for (e = 0; e < i; e++) a(t[e]);
                    });
                return {
                    _: function () {
                        (t = e.getElementsByClassName(n.autosizesClass)), o("resize", r);
                    },
                    checkElems: r,
                    updateElem: a,
                };
            })(),
            L = function () {
                L.i || ((L.i = !0), _._(), N._());
            };
        return (i = { cfg: n, autoSizer: _, loader: N, init: L, uP: p, aC: z, rC: y, hC: v, fire: b, gW: C, rAF: E });
    })(t, t.document);
    (t.lazySizes = i), "object" == typeof module && module.exports && (module.exports = i);
})(window);
/** Thumbs Plugin */
!(function (a, b, c, d) {
    "use strict";
    var e = function (b) {
        (this.owl = b),
            (this._thumbcontent = []),
            (this._identifier = 0),
            (this.owl_currentitem = this.owl.options.startPosition),
            (this.$element = this.owl.$element),
            (this._handlers = {
                "prepared.owl.carousel": a.proxy(function (b) {
                    if (!b.namespace || !this.owl.options.thumbs || this.owl.options.thumbImage || this.owl.options.thumbsPrerendered || this.owl.options.thumbImage) {
                        if (b.namespace && this.owl.options.thumbs && this.owl.options.thumbImage) {
                            var c = a(b.content).find("img");
                            this._thumbcontent.push(c);
                        }
                    } else a(b.content).find("[data-thumb]").attr("data-thumb") !== d && this._thumbcontent.push(a(b.content).find("[data-thumb]").attr("data-thumb"));
                }, this),
                "initialized.owl.carousel": a.proxy(function (a) {
                    a.namespace && this.owl.options.thumbs && (this.render(), this.listen(), (this._identifier = this.owl.$element.data("slider-id")), this.setActive());
                }, this),
                "changed.owl.carousel": a.proxy(function (a) {
                    a.namespace && "position" === a.property.name && this.owl.options.thumbs && ((this._identifier = this.owl.$element.data("slider-id")), this.setActive());
                }, this),
            }),
            (this.owl.options = a.extend({}, e.Defaults, this.owl.options)),
            this.owl.$element.on(this._handlers);
    };
    (e.Defaults = { thumbs: !0, thumbImage: !1, thumbContainerClass: "owl-thumbs", thumbItemClass: "owl-thumb-item", moveThumbsInside: !1 }),
        (e.prototype.listen = function () {
            var b = this.owl.options;
            b.thumbsPrerendered && (this._thumbcontent._thumbcontainer = a("." + b.thumbContainerClass)),
                a(this._thumbcontent._thumbcontainer).on(
                    "click",
                    this._thumbcontent._thumbcontainer.children(),
                    a.proxy(function (c) {
                        this._identifier = a(c.target)
                            .closest("." + b.thumbContainerClass)
                            .data("slider-id");
                        var d = a(c.target).parent().is(this._thumbcontent._thumbcontainer)
                            ? a(c.target).index()
                            : a(c.target)
                                  .closest("." + b.thumbItemClass)
                                  .index();
                        b.thumbsPrerendered ? a("[data-slider-id=" + this._identifier + "]").trigger("to.owl.carousel", [d, b.dotsSpeed, !0]) : this.owl.to(d, b.dotsSpeed), c.preventDefault();
                    }, this)
                );
        }),
        (e.prototype.render = function () {
            var b = this.owl.options;
            b.thumbsPrerendered
                ? ((this._thumbcontent._thumbcontainer = a("." + b.thumbContainerClass)), b.moveThumbsInside && this._thumbcontent._thumbcontainer.appendTo(this.$element))
                : (this._thumbcontent._thumbcontainer = a("<div>").addClass(b.thumbContainerClass).appendTo(this.$element));
            var c;
            if (b.thumbImage)
                for (c = 0; c < this._thumbcontent.length; ++c)
                    this._thumbcontent._thumbcontainer.append("<button class=" + b.thumbItemClass + '><img src="' + this._thumbcontent[c].attr("src") + '" alt="' + this._thumbcontent[c].attr("alt") + '" /></button>');
            else for (c = 0; c < this._thumbcontent.length; ++c) this._thumbcontent._thumbcontainer.append("<button class=" + b.thumbItemClass + ">" + this._thumbcontent[c] + "</button>");
        }),
        (e.prototype.setActive = function () {
            (this.owl_currentitem = this.owl._current - this.owl._clones.length / 2), this.owl_currentitem === this.owl._items.length && (this.owl_currentitem = 0);
            var b = this.owl.options,
                c = b.thumbsPrerendered ? a("." + b.thumbContainerClass + '[data-slider-id="' + this._identifier + '"]') : this._thumbcontent._thumbcontainer;
            c.children().filter(".active").removeClass("active"), c.children().eq(this.owl_currentitem).addClass("active");
        }),
        (e.prototype.destroy = function () {
            var a, b;
            for (a in this._handlers) this.owl.$element.off(a, this._handlers[a]);
            for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Thumbs = e);
})(window.Zepto || window.jQuery, window, document);
/*! Stellar.js v0.6.2 | Copyright 2014, Mark Dalgleish | http://markdalgleish.com/projects/stellar.js | http://markdalgleish.mit-license.org */
!(function (a, b, c, d) {
    function e(b, c) {
        (this.element = b), (this.options = a.extend({}, g, c)), (this._defaults = g), (this._name = f), this.init();
    }
    var f = "stellar",
        g = {
            scrollProperty: "scroll",
            positionProperty: "position",
            horizontalScrolling: !0,
            verticalScrolling: !0,
            horizontalOffset: 0,
            verticalOffset: 0,
            responsive: !1,
            parallaxBackgrounds: !0,
            parallaxElements: !0,
            hideDistantElements: !0,
            hideElement: function (a) {
                a.hide();
            },
            showElement: function (a) {
                a.show();
            },
        },
        h = {
            scroll: {
                getLeft: function (a) {
                    return a.scrollLeft();
                },
                setLeft: function (a, b) {
                    a.scrollLeft(b);
                },
                getTop: function (a) {
                    return a.scrollTop();
                },
                setTop: function (a, b) {
                    a.scrollTop(b);
                },
            },
            position: {
                getLeft: function (a) {
                    return -1 * parseInt(a.css("left"), 10);
                },
                getTop: function (a) {
                    return -1 * parseInt(a.css("top"), 10);
                },
            },
            margin: {
                getLeft: function (a) {
                    return -1 * parseInt(a.css("margin-left"), 10);
                },
                getTop: function (a) {
                    return -1 * parseInt(a.css("margin-top"), 10);
                },
            },
            transform: {
                getLeft: function (a) {
                    var b = getComputedStyle(a[0])[k];
                    return "none" !== b ? -1 * parseInt(b.match(/(-?[0-9]+)/g)[4], 10) : 0;
                },
                getTop: function (a) {
                    var b = getComputedStyle(a[0])[k];
                    return "none" !== b ? -1 * parseInt(b.match(/(-?[0-9]+)/g)[5], 10) : 0;
                },
            },
        },
        i = {
            position: {
                setLeft: function (a, b) {
                    a.css("left", b);
                },
                setTop: function (a, b) {
                    a.css("top", b);
                },
            },
            transform: {
                setPosition: function (a, b, c, d, e) {
                    a[0].style[k] = "translate3d(" + (b - c) + "px, " + (d - e) + "px, 0)";
                },
            },
        },
        j = (function () {
            var b,
                c = /^(Moz|Webkit|Khtml|O|ms|Icab)(?=[A-Z])/,
                d = a("script")[0].style,
                e = "";
            for (b in d)
                if (c.test(b)) {
                    e = b.match(c)[0];
                    break;
                }
            return (
                "WebkitOpacity" in d && (e = "Webkit"),
                "KhtmlOpacity" in d && (e = "Khtml"),
                function (a) {
                    return e + (e.length > 0 ? a.charAt(0).toUpperCase() + a.slice(1) : a);
                }
            );
        })(),
        k = j("transform"),
        l = a("<div />", { style: "background:#fff" }).css("background-position-x") !== d,
        m = l
            ? function (a, b, c) {
                  a.css({ "background-position-x": b, "background-position-y": c });
              }
            : function (a, b, c) {
                  a.css("background-position", b + " " + c);
              },
        n = l
            ? function (a) {
                  return [a.css("background-position-x"), a.css("background-position-y")];
              }
            : function (a) {
                  return a.css("background-position").split(" ");
              },
        o =
            b.requestAnimationFrame ||
            b.webkitRequestAnimationFrame ||
            b.mozRequestAnimationFrame ||
            b.oRequestAnimationFrame ||
            b.msRequestAnimationFrame ||
            function (a) {
                setTimeout(a, 1e3 / 60);
            };
    (e.prototype = {
        init: function () {
            (this.options.name = f + "_" + Math.floor(1e9 * Math.random())),
                this._defineElements(),
                this._defineGetters(),
                this._defineSetters(),
                this._handleWindowLoadAndResize(),
                this._detectViewport(),
                this.refresh({ firstLoad: !0 }),
                "scroll" === this.options.scrollProperty ? this._handleScrollEvent() : this._startAnimationLoop();
        },
        _defineElements: function () {
            this.element === c.body && (this.element = b),
                (this.$scrollElement = a(this.element)),
                (this.$element = this.element === b ? a("body") : this.$scrollElement),
                (this.$viewportElement = this.options.viewportElement !== d ? a(this.options.viewportElement) : this.$scrollElement[0] === b || "scroll" === this.options.scrollProperty ? this.$scrollElement : this.$scrollElement.parent());
        },
        _defineGetters: function () {
            var a = this,
                b = h[a.options.scrollProperty];
            (this._getScrollLeft = function () {
                return b.getLeft(a.$scrollElement);
            }),
                (this._getScrollTop = function () {
                    return b.getTop(a.$scrollElement);
                });
        },
        _defineSetters: function () {
            var b = this,
                c = h[b.options.scrollProperty],
                d = i[b.options.positionProperty],
                e = c.setLeft,
                f = c.setTop;
            (this._setScrollLeft =
                "function" == typeof e
                    ? function (a) {
                          e(b.$scrollElement, a);
                      }
                    : a.noop),
                (this._setScrollTop =
                    "function" == typeof f
                        ? function (a) {
                              f(b.$scrollElement, a);
                          }
                        : a.noop),
                (this._setPosition =
                    d.setPosition ||
                    function (a, c, e, f, g) {
                        b.options.horizontalScrolling && d.setLeft(a, c, e), b.options.verticalScrolling && d.setTop(a, f, g);
                    });
        },
        _handleWindowLoadAndResize: function () {
            var c = this,
                d = a(b);
            c.options.responsive &&
                d.bind("load." + this.name, function () {
                    c.refresh();
                }),
                d.bind("resize." + this.name, function () {
                    c._detectViewport(), c.options.responsive && c.refresh();
                });
        },
        refresh: function (c) {
            var d = this,
                e = d._getScrollLeft(),
                f = d._getScrollTop();
            (c && c.firstLoad) || this._reset(),
                this._setScrollLeft(0),
                this._setScrollTop(0),
                this._setOffsets(),
                this._findParticles(),
                this._findBackgrounds(),
                c &&
                    c.firstLoad &&
                    /WebKit/.test(navigator.userAgent) &&
                    a(b).load(function () {
                        var a = d._getScrollLeft(),
                            b = d._getScrollTop();
                        d._setScrollLeft(a + 1), d._setScrollTop(b + 1), d._setScrollLeft(a), d._setScrollTop(b);
                    }),
                this._setScrollLeft(e),
                this._setScrollTop(f);
        },
        _detectViewport: function () {
            var a = this.$viewportElement.offset(),
                b = null !== a && a !== d;
            (this.viewportWidth = this.$viewportElement.width()), (this.viewportHeight = this.$viewportElement.height()), (this.viewportOffsetTop = b ? a.top : 0), (this.viewportOffsetLeft = b ? a.left : 0);
        },
        _findParticles: function () {
            {
                var b = this;
                this._getScrollLeft(), this._getScrollTop();
            }
            if (this.particles !== d) for (var c = this.particles.length - 1; c >= 0; c--) this.particles[c].$element.data("stellar-elementIsActive", d);
            (this.particles = []),
                this.options.parallaxElements &&
                    this.$element.find("[data-stellar-ratio]").each(function () {
                        var c,
                            e,
                            f,
                            g,
                            h,
                            i,
                            j,
                            k,
                            l,
                            m = a(this),
                            n = 0,
                            o = 0,
                            p = 0,
                            q = 0;
                        if (m.data("stellar-elementIsActive")) {
                            if (m.data("stellar-elementIsActive") !== this) return;
                        } else m.data("stellar-elementIsActive", this);
                        b.options.showElement(m),
                            m.data("stellar-startingLeft")
                                ? (m.css("left", m.data("stellar-startingLeft")), m.css("top", m.data("stellar-startingTop")))
                                : (m.data("stellar-startingLeft", m.css("left")), m.data("stellar-startingTop", m.css("top"))),
                            (f = m.position().left),
                            (g = m.position().top),
                            (h = "auto" === m.css("margin-left") ? 0 : parseInt(m.css("margin-left"), 10)),
                            (i = "auto" === m.css("margin-top") ? 0 : parseInt(m.css("margin-top"), 10)),
                            (k = m.offset().left - h),
                            (l = m.offset().top - i),
                            m.parents().each(function () {
                                var b = a(this);
                                return b.data("stellar-offset-parent") === !0 ? ((n = p), (o = q), (j = b), !1) : ((p += b.position().left), void (q += b.position().top));
                            }),
                            (c = m.data("stellar-horizontal-offset") !== d ? m.data("stellar-horizontal-offset") : j !== d && j.data("stellar-horizontal-offset") !== d ? j.data("stellar-horizontal-offset") : b.horizontalOffset),
                            (e = m.data("stellar-vertical-offset") !== d ? m.data("stellar-vertical-offset") : j !== d && j.data("stellar-vertical-offset") !== d ? j.data("stellar-vertical-offset") : b.verticalOffset),
                            b.particles.push({
                                $element: m,
                                $offsetParent: j,
                                isFixed: "fixed" === m.css("position"),
                                horizontalOffset: c,
                                verticalOffset: e,
                                startingPositionLeft: f,
                                startingPositionTop: g,
                                startingOffsetLeft: k,
                                startingOffsetTop: l,
                                parentOffsetLeft: n,
                                parentOffsetTop: o,
                                stellarRatio: m.data("stellar-ratio") !== d ? m.data("stellar-ratio") : 1,
                                width: m.outerWidth(!0),
                                height: m.outerHeight(!0),
                                isHidden: !1,
                            });
                    });
        },
        _findBackgrounds: function () {
            var b,
                c = this,
                e = this._getScrollLeft(),
                f = this._getScrollTop();
            (this.backgrounds = []),
                this.options.parallaxBackgrounds &&
                    ((b = this.$element.find("[data-stellar-background-ratio]")),
                    this.$element.data("stellar-background-ratio") && (b = b.add(this.$element)),
                    b.each(function () {
                        var b,
                            g,
                            h,
                            i,
                            j,
                            k,
                            l,
                            o = a(this),
                            p = n(o),
                            q = 0,
                            r = 0,
                            s = 0,
                            t = 0;
                        if (o.data("stellar-backgroundIsActive")) {
                            if (o.data("stellar-backgroundIsActive") !== this) return;
                        } else o.data("stellar-backgroundIsActive", this);
                        o.data("stellar-backgroundStartingLeft")
                            ? m(o, o.data("stellar-backgroundStartingLeft"), o.data("stellar-backgroundStartingTop"))
                            : (o.data("stellar-backgroundStartingLeft", p[0]), o.data("stellar-backgroundStartingTop", p[1])),
                            (h = "auto" === o.css("margin-left") ? 0 : parseInt(o.css("margin-left"), 10)),
                            (i = "auto" === o.css("margin-top") ? 0 : parseInt(o.css("margin-top"), 10)),
                            (j = o.offset().left - h - e),
                            (k = o.offset().top - i - f),
                            o.parents().each(function () {
                                var b = a(this);
                                return b.data("stellar-offset-parent") === !0 ? ((q = s), (r = t), (l = b), !1) : ((s += b.position().left), void (t += b.position().top));
                            }),
                            (b = o.data("stellar-horizontal-offset") !== d ? o.data("stellar-horizontal-offset") : l !== d && l.data("stellar-horizontal-offset") !== d ? l.data("stellar-horizontal-offset") : c.horizontalOffset),
                            (g = o.data("stellar-vertical-offset") !== d ? o.data("stellar-vertical-offset") : l !== d && l.data("stellar-vertical-offset") !== d ? l.data("stellar-vertical-offset") : c.verticalOffset),
                            c.backgrounds.push({
                                $element: o,
                                $offsetParent: l,
                                isFixed: "fixed" === o.css("background-attachment"),
                                horizontalOffset: b,
                                verticalOffset: g,
                                startingValueLeft: p[0],
                                startingValueTop: p[1],
                                startingBackgroundPositionLeft: isNaN(parseInt(p[0], 10)) ? 0 : parseInt(p[0], 10),
                                startingBackgroundPositionTop: isNaN(parseInt(p[1], 10)) ? 0 : parseInt(p[1], 10),
                                startingPositionLeft: o.position().left,
                                startingPositionTop: o.position().top,
                                startingOffsetLeft: j,
                                startingOffsetTop: k,
                                parentOffsetLeft: q,
                                parentOffsetTop: r,
                                stellarRatio: o.data("stellar-background-ratio") === d ? 1 : o.data("stellar-background-ratio"),
                            });
                    }));
        },
        _reset: function () {
            var a, b, c, d, e;
            for (e = this.particles.length - 1; e >= 0; e--)
                (a = this.particles[e]),
                    (b = a.$element.data("stellar-startingLeft")),
                    (c = a.$element.data("stellar-startingTop")),
                    this._setPosition(a.$element, b, b, c, c),
                    this.options.showElement(a.$element),
                    a.$element.data("stellar-startingLeft", null).data("stellar-elementIsActive", null).data("stellar-backgroundIsActive", null);
            for (e = this.backgrounds.length - 1; e >= 0; e--)
                (d = this.backgrounds[e]), d.$element.data("stellar-backgroundStartingLeft", null).data("stellar-backgroundStartingTop", null), m(d.$element, d.startingValueLeft, d.startingValueTop);
        },
        destroy: function () {
            this._reset(),
                this.$scrollElement.unbind("resize." + this.name).unbind("scroll." + this.name),
                (this._animationLoop = a.noop),
                a(b)
                    .unbind("load." + this.name)
                    .unbind("resize." + this.name);
        },
        _setOffsets: function () {
            var c = this,
                d = a(b);
            d.unbind("resize.horizontal-" + this.name).unbind("resize.vertical-" + this.name),
                "function" == typeof this.options.horizontalOffset
                    ? ((this.horizontalOffset = this.options.horizontalOffset()),
                      d.bind("resize.horizontal-" + this.name, function () {
                          c.horizontalOffset = c.options.horizontalOffset();
                      }))
                    : (this.horizontalOffset = this.options.horizontalOffset),
                "function" == typeof this.options.verticalOffset
                    ? ((this.verticalOffset = this.options.verticalOffset()),
                      d.bind("resize.vertical-" + this.name, function () {
                          c.verticalOffset = c.options.verticalOffset();
                      }))
                    : (this.verticalOffset = this.options.verticalOffset);
        },
        _repositionElements: function () {
            var a,
                b,
                c,
                d,
                e,
                f,
                g,
                h,
                i,
                j,
                k = this._getScrollLeft(),
                l = this._getScrollTop(),
                n = !0,
                o = !0;
            if (this.currentScrollLeft !== k || this.currentScrollTop !== l || this.currentWidth !== this.viewportWidth || this.currentHeight !== this.viewportHeight) {
                for (this.currentScrollLeft = k, this.currentScrollTop = l, this.currentWidth = this.viewportWidth, this.currentHeight = this.viewportHeight, j = this.particles.length - 1; j >= 0; j--)
                    (a = this.particles[j]),
                        (b = a.isFixed ? 1 : 0),
                        this.options.horizontalScrolling
                            ? ((f = (k + a.horizontalOffset + this.viewportOffsetLeft + a.startingPositionLeft - a.startingOffsetLeft + a.parentOffsetLeft) * -(a.stellarRatio + b - 1) + a.startingPositionLeft),
                              (h = f - a.startingPositionLeft + a.startingOffsetLeft))
                            : ((f = a.startingPositionLeft), (h = a.startingOffsetLeft)),
                        this.options.verticalScrolling
                            ? ((g = (l + a.verticalOffset + this.viewportOffsetTop + a.startingPositionTop - a.startingOffsetTop + a.parentOffsetTop) * -(a.stellarRatio + b - 1) + a.startingPositionTop),
                              (i = g - a.startingPositionTop + a.startingOffsetTop))
                            : ((g = a.startingPositionTop), (i = a.startingOffsetTop)),
                        this.options.hideDistantElements &&
                            ((o = !this.options.horizontalScrolling || (h + a.width > (a.isFixed ? 0 : k) && h < (a.isFixed ? 0 : k) + this.viewportWidth + this.viewportOffsetLeft)),
                            (n = !this.options.verticalScrolling || (i + a.height > (a.isFixed ? 0 : l) && i < (a.isFixed ? 0 : l) + this.viewportHeight + this.viewportOffsetTop))),
                        o && n
                            ? (a.isHidden && (this.options.showElement(a.$element), (a.isHidden = !1)), this._setPosition(a.$element, f, a.startingPositionLeft, g, a.startingPositionTop))
                            : a.isHidden || (this.options.hideElement(a.$element), (a.isHidden = !0));
                for (j = this.backgrounds.length - 1; j >= 0; j--)
                    (c = this.backgrounds[j]),
                        (b = c.isFixed ? 0 : 1),
                        (d = this.options.horizontalScrolling
                            ? (k + c.horizontalOffset - this.viewportOffsetLeft - c.startingOffsetLeft + c.parentOffsetLeft - c.startingBackgroundPositionLeft) * (b - c.stellarRatio) + "px"
                            : c.startingValueLeft),
                        (e = this.options.verticalScrolling ? (l + c.verticalOffset - this.viewportOffsetTop - c.startingOffsetTop + c.parentOffsetTop - c.startingBackgroundPositionTop) * (b - c.stellarRatio) + "px" : c.startingValueTop),
                        m(c.$element, d, e);
            }
        },
        _handleScrollEvent: function () {
            var a = this,
                b = !1,
                c = function () {
                    a._repositionElements(), (b = !1);
                },
                d = function () {
                    b || (o(c), (b = !0));
                };
            this.$scrollElement.bind("scroll." + this.name, d), d();
        },
        _startAnimationLoop: function () {
            var a = this;
            (this._animationLoop = function () {
                o(a._animationLoop), a._repositionElements();
            }),
                this._animationLoop();
        },
    }),
        (a.fn[f] = function (b) {
            var c = arguments;
            return b === d || "object" == typeof b
                ? this.each(function () {
                      a.data(this, "plugin_" + f) || a.data(this, "plugin_" + f, new e(this, b));
                  })
                : "string" == typeof b && "_" !== b[0] && "init" !== b
                ? this.each(function () {
                      var d = a.data(this, "plugin_" + f);
                      d instanceof e && "function" == typeof d[b] && d[b].apply(d, Array.prototype.slice.call(c, 1)), "destroy" === b && a.data(this, "plugin_" + f, null);
                  })
                : void 0;
        }),
        (a[f] = function () {
            var c = a(b);
            return c.stellar.apply(c, Array.prototype.slice.call(arguments, 0));
        }),
        (a[f].scrollProperty = h),
        (a[f].positionProperty = i),
        (b.Stellar = e);
})(jQuery, this, document);
/*paralax*/
!(function (a) {
    var b = a(window),
        c = b.height();
    b.resize(function () {
        c = b.height();
    }),
        (a.fn.parallax = function (d, e, f, g) {
            function k() {
                var g = b.scrollTop();
                h.each(function () {
                    var b = a(this),
                        j = b.offset().top,
                        k = i(b);
                    j + k < g || j > g + c || h.css("backgroundPosition", d + " " + Math.round((f - g) * e) + "px");
                });
            }
            var i,
                h = a(this);
            null == f &&
                h.each(function () {
                    f = h.offset().top;
                }),
                (i = g
                    ? function (a) {
                          return a.outerHeight(!0);
                      }
                    : function (a) {
                          return a.height();
                      }),
                (arguments.length < 1 || null === d) && (d = "50%"),
                (arguments.length < 2 || null === e) && (e = 0.1),
                (arguments.length < 3 || null === g) && (g = !0),
                b.bind("scroll", k).resize(k),
                k();
        });
})(jQuery);
//parallax2
!(function (a, b, c, d) {
    "use strict";
    function h(b, c) {
        (this.element = b), (this.$context = a(b).data("api", this)), (this.$layers = this.$context.find(".layer"));
        var d = {
            calibrateX: this.$context.data("calibrate-x") || null,
            calibrateY: this.$context.data("calibrate-y") || null,
            invertX: this.$context.data("invert-x") || null,
            invertY: this.$context.data("invert-y") || null,
            limitX: parseFloat(this.$context.data("limit-x")) || null,
            limitY: parseFloat(this.$context.data("limit-y")) || null,
            scalarX: parseFloat(this.$context.data("scalar-x")) || null,
            scalarY: parseFloat(this.$context.data("scalar-y")) || null,
            frictionX: parseFloat(this.$context.data("friction-x")) || null,
            frictionY: parseFloat(this.$context.data("friction-y")) || null,
            originX: parseFloat(this.$context.data("origin-x")) || null,
            originY: parseFloat(this.$context.data("origin-y")) || null,
        };
        for (var e in d) null === d[e] && delete d[e];
        a.extend(this, g, c, d),
            (this.calibrationTimer = null),
            (this.calibrationFlag = !0),
            (this.enabled = !1),
            (this.depths = []),
            (this.raf = null),
            (this.bounds = null),
            (this.ex = 0),
            (this.ey = 0),
            (this.ew = 0),
            (this.eh = 0),
            (this.ecx = 0),
            (this.ecy = 0),
            (this.erx = 0),
            (this.ery = 0),
            (this.cx = 0),
            (this.cy = 0),
            (this.ix = 0),
            (this.iy = 0),
            (this.mx = 0),
            (this.my = 0),
            (this.vx = 0),
            (this.vy = 0),
            (this.onMouseMove = this.onMouseMove.bind(this)),
            (this.onDeviceOrientation = this.onDeviceOrientation.bind(this)),
            (this.onOrientationTimer = this.onOrientationTimer.bind(this)),
            (this.onCalibrationTimer = this.onCalibrationTimer.bind(this)),
            (this.onAnimationFrame = this.onAnimationFrame.bind(this)),
            (this.onWindowResize = this.onWindowResize.bind(this)),
            this.initialise();
    }
    var e = "parallax",
        f = 30,
        g = {
            relativeInput: !1,
            clipRelativeInput: !1,
            calibrationThreshold: 100,
            calibrationDelay: 500,
            supportDelay: 500,
            calibrateX: !1,
            calibrateY: !0,
            invertX: !0,
            invertY: !0,
            limitX: !1,
            limitY: !1,
            scalarX: 10,
            scalarY: 10,
            frictionX: 0.1,
            frictionY: 0.1,
            originX: 0.5,
            originY: 0.5,
        };
    (h.prototype.transformSupport = function (a) {
        for (var e = c.createElement("div"), f = !1, g = null, h = !1, i = null, j = null, k = 0, l = this.vendors.length; k < l; k++)
            if ((null !== this.vendors[k] ? ((i = this.vendors[k][0] + "transform"), (j = this.vendors[k][1] + "Transform")) : ((i = "transform"), (j = "transform")), e.style[j] !== d)) {
                f = !0;
                break;
            }
        switch (a) {
            case "2D":
                h = f;
                break;
            case "3D":
                if (f) {
                    var m = c.body || c.createElement("body"),
                        n = c.documentElement,
                        o = n.style.overflow;
                    c.body || n.appendChild(m),
                        m.appendChild(e),
                        (e.style[j] = "translate3d(1px,1px,1px)"),
                        (g = b.getComputedStyle(e).getPropertyValue(i)),
                        (h = g !== d && g.length > 0 && "none" !== g),
                        (n.style.overflow = o),
                        m.removeChild(e);
                }
        }
        return h;
    }),
        (h.prototype.ww = null),
        (h.prototype.wh = null),
        (h.prototype.wcx = null),
        (h.prototype.wcy = null),
        (h.prototype.wrx = null),
        (h.prototype.wry = null),
        (h.prototype.portrait = null),
        (h.prototype.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i)),
        (h.prototype.vendors = [null, ["-webkit-", "webkit"], ["-moz-", "Moz"], ["-o-", "O"], ["-ms-", "ms"]]),
        (h.prototype.motionSupport = !!b.DeviceMotionEvent),
        (h.prototype.orientationSupport = !!b.DeviceOrientationEvent),
        (h.prototype.orientationStatus = 0),
        (h.prototype.transform2DSupport = h.prototype.transformSupport("2D")),
        (h.prototype.transform3DSupport = h.prototype.transformSupport("3D")),
        (h.prototype.propertyCache = {}),
        (h.prototype.initialise = function () {
            "static" === this.$context.css("position") && this.$context.css({ position: "relative" }),
                this.accelerate(this.$context),
                this.updateLayers(),
                this.updateDimensions(),
                this.enable(),
                this.queueCalibration(this.calibrationDelay);
        }),
        (h.prototype.updateLayers = function () {
            (this.$layers = this.$context.find(".layer")),
                (this.depths = []),
                this.$layers.css({ position: "absolute", display: "block", left: 0, top: 0 }),
                this.$layers.first().css({ position: "relative" }),
                this.accelerate(this.$layers),
                this.$layers.each(
                    a.proxy(function (b, c) {
                        this.depths.push(a(c).data("depth") || 0);
                    }, this)
                );
        }),
        (h.prototype.updateDimensions = function () {
            (this.ww = b.innerWidth),
                (this.wh = b.innerHeight),
                (this.wcx = this.ww * this.originX),
                (this.wcy = this.wh * this.originY),
                (this.wrx = Math.max(this.wcx, this.ww - this.wcx)),
                (this.wry = Math.max(this.wcy, this.wh - this.wcy));
        }),
        (h.prototype.updateBounds = function () {
            (this.bounds = this.element.getBoundingClientRect()),
                (this.ex = this.bounds.left),
                (this.ey = this.bounds.top),
                (this.ew = this.bounds.width),
                (this.eh = this.bounds.height),
                (this.ecx = this.ew * this.originX),
                (this.ecy = this.eh * this.originY),
                (this.erx = Math.max(this.ecx, this.ew - this.ecx)),
                (this.ery = Math.max(this.ecy, this.eh - this.ecy));
        }),
        (h.prototype.queueCalibration = function (a) {
            clearTimeout(this.calibrationTimer), (this.calibrationTimer = setTimeout(this.onCalibrationTimer, a));
        }),
        (h.prototype.enable = function () {
            this.enabled ||
                ((this.enabled = !0),
                this.orientationSupport
                    ? ((this.portrait = null), b.addEventListener("deviceorientation", this.onDeviceOrientation), setTimeout(this.onOrientationTimer, this.supportDelay))
                    : ((this.cx = 0), (this.cy = 0), (this.portrait = !1), b.addEventListener("mousemove", this.onMouseMove)),
                b.addEventListener("resize", this.onWindowResize),
                (this.raf = requestAnimationFrame(this.onAnimationFrame)));
        }),
        (h.prototype.disable = function () {
            this.enabled &&
                ((this.enabled = !1),
                this.orientationSupport ? b.removeEventListener("deviceorientation", this.onDeviceOrientation) : b.removeEventListener("mousemove", this.onMouseMove),
                b.removeEventListener("resize", this.onWindowResize),
                cancelAnimationFrame(this.raf));
        }),
        (h.prototype.calibrate = function (a, b) {
            (this.calibrateX = a === d ? this.calibrateX : a), (this.calibrateY = b === d ? this.calibrateY : b);
        }),
        (h.prototype.invert = function (a, b) {
            (this.invertX = a === d ? this.invertX : a), (this.invertY = b === d ? this.invertY : b);
        }),
        (h.prototype.friction = function (a, b) {
            (this.frictionX = a === d ? this.frictionX : a), (this.frictionY = b === d ? this.frictionY : b);
        }),
        (h.prototype.scalar = function (a, b) {
            (this.scalarX = a === d ? this.scalarX : a), (this.scalarY = b === d ? this.scalarY : b);
        }),
        (h.prototype.limit = function (a, b) {
            (this.limitX = a === d ? this.limitX : a), (this.limitY = b === d ? this.limitY : b);
        }),
        (h.prototype.origin = function (a, b) {
            (this.originX = a === d ? this.originX : a), (this.originY = b === d ? this.originY : b);
        }),
        (h.prototype.clamp = function (a, b, c) {
            return (a = Math.max(a, b)), (a = Math.min(a, c));
        }),
        (h.prototype.css = function (b, c, e) {
            var f = this.propertyCache[c];
            if (!f)
                for (var g = 0, h = this.vendors.length; g < h; g++)
                    if (((f = null !== this.vendors[g] ? a.camelCase(this.vendors[g][1] + "-" + c) : c), b.style[f] !== d)) {
                        this.propertyCache[c] = f;
                        break;
                    }
            b.style[f] = e;
        }),
        (h.prototype.accelerate = function (a) {
            for (var b = 0, c = a.length; b < c; b++) {
                var d = a[b];
                this.css(d, "transform", "translate3d(0,0,0)"), this.css(d, "transform-style", "preserve-3d"), this.css(d, "backface-visibility", "hidden");
            }
        }),
        (h.prototype.setPosition = function (a, b, c) {
            (b += "px"),
                (c += "px"),
                this.transform3DSupport ? this.css(a, "transform", "translate3d(" + b + "," + c + ",0)") : this.transform2DSupport ? this.css(a, "transform", "translate(" + b + "," + c + ")") : ((a.style.left = b), (a.style.top = c));
        }),
        (h.prototype.onOrientationTimer = function (a) {
            this.orientationSupport && 0 === this.orientationStatus && (this.disable(), (this.orientationSupport = !1), this.enable());
        }),
        (h.prototype.onCalibrationTimer = function (a) {
            this.calibrationFlag = !0;
        }),
        (h.prototype.onWindowResize = function (a) {
            this.updateDimensions();
        }),
        (h.prototype.onAnimationFrame = function () {
            this.updateBounds();
            var a = this.ix - this.cx,
                b = this.iy - this.cy;
            (Math.abs(a) > this.calibrationThreshold || Math.abs(b) > this.calibrationThreshold) && this.queueCalibration(0),
                this.portrait ? ((this.mx = this.calibrateX ? b : this.iy), (this.my = this.calibrateY ? a : this.ix)) : ((this.mx = this.calibrateX ? a : this.ix), (this.my = this.calibrateY ? b : this.iy)),
                (this.mx *= this.ew * (this.scalarX / 100)),
                (this.my *= this.eh * (this.scalarY / 100)),
                isNaN(parseFloat(this.limitX)) || (this.mx = this.clamp(this.mx, -this.limitX, this.limitX)),
                isNaN(parseFloat(this.limitY)) || (this.my = this.clamp(this.my, -this.limitY, this.limitY)),
                (this.vx += (this.mx - this.vx) * this.frictionX),
                (this.vy += (this.my - this.vy) * this.frictionY);
            for (var c = 0, d = this.$layers.length; c < d; c++) {
                var e = this.depths[c],
                    f = this.$layers[c],
                    g = this.vx * e * (this.invertX ? -1 : 1),
                    h = this.vy * e * (this.invertY ? -1 : 1);
                this.setPosition(f, g, h);
            }
            this.raf = requestAnimationFrame(this.onAnimationFrame);
        }),
        (h.prototype.onDeviceOrientation = function (a) {
            if (!this.desktop && null !== a.beta && null !== a.gamma) {
                this.orientationStatus = 1;
                var c = (a.beta || 0) / f,
                    d = (a.gamma || 0) / f,
                    e = b.innerHeight > b.innerWidth;
                this.portrait !== e && ((this.portrait = e), (this.calibrationFlag = !0)), this.calibrationFlag && ((this.calibrationFlag = !1), (this.cx = c), (this.cy = d)), (this.ix = c), (this.iy = d);
            }
        }),
        (h.prototype.onMouseMove = function (a) {
            var b = a.clientX,
                c = a.clientY;
            !this.orientationSupport && this.relativeInput
                ? (this.clipRelativeInput && ((b = Math.max(b, this.ex)), (b = Math.min(b, this.ex + this.ew)), (c = Math.max(c, this.ey)), (c = Math.min(c, this.ey + this.eh))),
                  (this.ix = (b - this.ex - this.ecx) / this.erx),
                  (this.iy = (c - this.ey - this.ecy) / this.ery))
                : ((this.ix = (b - this.wcx) / this.wrx), (this.iy = (c - this.wcy) / this.wry));
        });
    var i = {
        enable: h.prototype.enable,
        disable: h.prototype.disable,
        updateLayers: h.prototype.updateLayers,
        calibrate: h.prototype.calibrate,
        friction: h.prototype.friction,
        invert: h.prototype.invert,
        scalar: h.prototype.scalar,
        limit: h.prototype.limit,
        origin: h.prototype.origin,
    };
    a.fn[e] = function (b) {
        var c = arguments;
        return this.each(function () {
            var d = a(this),
                f = d.data(e);
            f || ((f = new h(this, b)), d.data(e, f)), i[b] && f[b].apply(f, Array.prototype.slice.call(c, 1));
        });
    };
})(window.jQuery || window.Zepto, window, document),
    (function () {
        for (var a = 0, b = ["ms", "moz", "webkit", "o"], c = 0; c < b.length && !window.requestAnimationFrame; ++c)
            (window.requestAnimationFrame = window[b[c] + "RequestAnimationFrame"]), (window.cancelAnimationFrame = window[b[c] + "CancelAnimationFrame"] || window[b[c] + "CancelRequestAnimationFrame"]);
        window.requestAnimationFrame ||
            (window.requestAnimationFrame = function (b, c) {
                var d = new Date().getTime(),
                    e = Math.max(0, 16 - (d - a)),
                    f = window.setTimeout(function () {
                        b(d + e);
                    }, e);
                return (a = d + e), f;
            }),
            window.cancelAnimationFrame ||
                (window.cancelAnimationFrame = function (a) {
                    clearTimeout(a);
                });
    })();
//Sticky
(function (t, s) {
    (s.fn.themePin = function (t) {
        var o = 0,
            e = 0,
            i = [],
            a = !1,
            n = s(window),
            p = [],
            r = [];
        t = t || {};
        var c = function () {
                for (var o = 0, e = i.length; o < e; o++) {
                    var p = i[o];
                    if (t.minWidth && n.width() <= t.minWidth)
                        p.parent().is(".pin-wrapper") && p.unwrap(),
                            p.css({ width: "", left: "", top: "", position: "" }),
                            t.activeClass && p.removeClass(t.activeClass),
                            p.removeClass("sticky-transition"),
                            p.removeClass("sticky-absolute"),
                            (a = !0);
                    else {
                        a = !1;
                        var r = t.containerSelector ? (p.closest(t.containerSelector).length ? p.closest(t.containerSelector) : s(t.containerSelector)) : s(document.body),
                            c = p.offset(),
                            d = r.offset();
                        if (void 0 !== d) {
                            var l = p.parent().offset();
                            p.parent().is(".pin-wrapper") || p.wrap("<div class='pin-wrapper'>");
                            var f = s.extend({ top: 0, bottom: 0 }, t.padding || {}),
                                h = parseInt(p.parent().parent().css("padding-top")),
                                u = parseInt(p.parent().parent().css("padding-bottom"));
                            t.autoInit &&
                                (s("#header").hasClass("header-side") ? ((f.top = 0), s(".page-top.fixed-pos").length && (f.top += s(".page-top.fixed-pos").height())) : (f.top = 0),
                                void 0 !== t.paddingOffsetTop ? (f.top += parseInt(t.paddingOffsetTop, 10)) : (f.top += 0),
                                void 0 !== t.paddingOffsetBottom ? (f.bottom = parseInt(t.paddingOffsetBottom, 10)) : (f.bottom = 0));
                            var m = p.css("border-bottom"),
                                v = p.outerHeight();
                            p.css("border-bottom", "1px solid transparent");
                            var C = p.outerHeight() - v - 1;
                            p.css("border-bottom", m),
                                p.css({ width: p.outerWidth() <= p.parent().width() ? p.outerWidth() : p.parent().width() }),
                                p.parent().css("height", p.outerHeight() + C),
                                (!t.autoFit && !t.fitToBottom) || p.outerHeight() <= n.height()
                                    ? p.data("themePin", { pad: f, from: (t.containerSelector ? d.top : c.top) - f.top + h, pb: u, parentTop: l.top - h, offset: C })
                                    : p.data("themePin", {
                                          pad: f,
                                          fromFitTop: (t.containerSelector ? d.top : c.top) - f.top + h,
                                          from: (t.containerSelector ? d.top : c.top) + p.outerHeight() - s(window).height() + h,
                                          pb: u,
                                          parentTop: l.top - h,
                                          offset: C,
                                      });
                        }
                    }
                }
            },
            d = function () {
                if (!a) {
                    o = n.scrollTop();
                    for (var c = window.innerHeight || n.height(), d = 0, l = i.length; d < l; d++) {
                        var f,
                            h = s(i[d]),
                            u = h.data("themePin"),
                            m = u.to;
                        if (u) {
                            var v = t.containerSelector ? (h.closest(t.containerSelector).length ? h.closest(t.containerSelector) : s(t.containerSelector)) : s(document.body),
                                C = h.outerHeight() + u.pad.top <= c;
                            if (
                                ((u.end = v.offset().top + v.height()),
                                C ? (u.to = v.offset().top + v.height() - h.outerHeight() - u.pad.bottom - u.pb) : ((u.to = v.offset().top + v.height() - c - u.pb), (u.to2 = v.height() - h.outerHeight() - u.pad.bottom - u.pb)),
                                C)
                            ) {
                                var b = u.from - u.pad.bottom,
                                    g = u.to - u.pad.top - u.offset;
                                if ((void 0 !== u.fromFitTop && u.fromFitTop && (b = u.fromFitTop - u.pad.bottom), b + h.outerHeight() > u.end || b >= g)) {
                                    h.css({ position: "", top: "", left: "" }), t.activeClass && h.removeClass(t.activeClass), h.removeClass("sticky-transition"), h.removeClass("sticky-absolute");
                                    continue;
                                }
                                o > b && o < g
                                    ? (!("fixed" == h.css("position")) && h.css({ left: h.offset().left, top: u.pad.top }).css("position", "fixed"),
                                      t.activeClass && h.addClass(t.activeClass),
                                      h.removeClass("sticky-transition"),
                                      h.removeClass("sticky-absolute"))
                                    : o >= g
                                    ? (h.css({ left: "", top: g - u.parentTop + u.pad.top }).css("position", "absolute"),
                                      t.activeClass && h.addClass(t.activeClass),
                                      h.hasClass("sticky-absolute") && h.addClass("sticky-transition"),
                                      h.addClass("sticky-absolute"))
                                    : (h.css({ position: "", top: "", left: "" }), t.activeClass && h.removeClass(t.activeClass), h.removeClass("sticky-transition"), h.removeClass("sticky-absolute"));
                            } else if ((m != u.to && (p[d] = r[d] = !1), h.height() + u.pad.top + u.pad.bottom > c || p[d] || r[d])) {
                                var y = parseInt(h.parent().parent().css("padding-top"));
                                o + u.pad.top - y <= u.parentTop
                                    ? (h.css({ position: "", top: "", bottom: "", left: "" }), (p[d] = r[d] = !1))
                                    : o >= u.to
                                    ? (h.css({ left: "", top: u.to2, bottom: "" }).css("position", "absolute"),
                                      t.activeClass && h.addClass(t.activeClass),
                                      h.hasClass("sticky-absolute") && h.addClass("sticky-transition"),
                                      h.addClass("sticky-absolute"))
                                    : o >= e
                                    ? p[d]
                                        ? ((p[d] = !1),
                                          (f = h.offset().top - u.parentTop),
                                          h.css({ left: "", top: f, bottom: "" }).css("position", "absolute"),
                                          t.activeClass && h.addClass(t.activeClass),
                                          h.hasClass("sticky-absolute") && h.addClass("sticky-transition"),
                                          h.addClass("sticky-absolute"))
                                        : !r[d] &&
                                          h.height() + h.offset().top + u.pad.bottom < o + c &&
                                          ((r[d] = !0),
                                          !("fixed" == h.css("position")) && h.css({ left: h.offset().left, bottom: u.pad.bottom, top: "" }).css("position", "fixed"),
                                          t.activeClass && h.addClass(t.activeClass),
                                          h.removeClass("sticky-transition"),
                                          h.removeClass("sticky-absolute"))
                                    : o < e &&
                                      (r[d]
                                          ? ((r[d] = !1),
                                            (f = h.offset().top - u.parentTop),
                                            h.css({ left: "", top: f, bottom: "" }).css("position", "absolute"),
                                            t.activeClass && h.addClass(t.activeClass),
                                            h.hasClass("sticky-absolute") && h.addClass("sticky-transition"),
                                            h.addClass("sticky-absolute"))
                                          : !p[d] &&
                                            h.offset().top >= o + u.pad.top &&
                                            ((p[d] = !0),
                                            !("fixed" == h.css("position")) && h.css({ left: h.offset().left, top: u.pad.top, bottom: "" }).css("position", "fixed"),
                                            t.activeClass && h.addClass(t.activeClass),
                                            h.removeClass("sticky-transition"),
                                            h.removeClass("sticky-absolute")));
                            } else o >= u.parentTop - u.pad.top ? h.css({ position: "fixed", top: u.pad.top }) : h.css({ position: "", top: "", bottom: "", left: "" }), (p[d] = r[d] = !1);
                        }
                    }
                    e = o;
                }
            },
            l = function () {
                c(), d();
            };
        return (
            this.each(function () {
                var t = s(this),
                    o = s(this).data("themePin") || {};
                (o && o.update) || (i.push(t), s("img", this).one("load", c), (o.update = l), s(this).data("themePin", o), p.push(!1), r.push(!1));
            }),
            s(window).on("smartresize", function () {
                c(), d();
            }),
            s(window).on("touchmove scroll", d),
            c(),
            s(this).bind("recalc.pin", function () {
                c(), d();
            }),
            this
        );
    }),
        (t = t || {});
    var o = function (t, s) {
        return this.initialize(t, s);
    };
    (o.defaults = { autoInit: !1, minWidth: 992, activeClass: "sticky-active", padding: { top: 0, bottom: 0 }, offsetTop: 0, offsetBottom: 0, autoFit: !1, fitToBottom: !1 }),
        (o.prototype = {
            initialize: function (t, s) {
                return t.data("__sticky") ? this : ((this.$el = t), this.setData().setOptions(s).build(), this);
            },
            setData: function () {
                return this.$el.data("__sticky", this), this;
            },
            setOptions: function (t) {
                return (this.options = s.extend(!0, {}, o.defaults, t, { wrapper: this.$el })), this;
            },
            build: function () {
                if (!s.isFunction(s.fn.themePin)) return this;
                var t = this.options.wrapper;
                return (
                    t.themePin(this.options),
                    s(window).on("resize", function () {
                        if (
                            (setTimeout(function () {
                                t.trigger("recalc.pin");
                            }, 800),
                            s(window).width() > 991)
                        ) {
                            var o = t.parent();
                            t.outerWidth(o.width()), "fixed" == t.css("position") && t.css("left", o.offset().left);
                        }
                    }),
                    this
                );
            },
        }),
        s.extend(t, { Sticky: o }),
        (s.fn.themeSticky = function (o) {
            return this.map(function () {
                var e = s(this);
                return e.data("__sticky")
                    ? (e.trigger("recalc.pin"),
                      setTimeout(function () {
                          e.trigger("recalc.pin");
                      }, 800),
                      e.data("__sticky"))
                    : new t.Sticky(e, o);
            });
        });
}.apply(this, [window.theme, jQuery]));
//float element
!(function (t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : t(window.jQuery);
})(function (t) {
    "use strict";
    t(window);
    t.fn.themePluginFloatElement = function (n) {
        var e,
            o,
            s = { startPos: "top", speed: 3, horizontal: !1, transition: !1 };
        function r(n) {
            var e = t(o.wrapper),
                s = t(window),
                r = s.scrollTop(),
                a = (100 * (e.offset().top - r)) / s.height();
            o.horizontal ? e.css({ transform: "translate3d(" + n + a / o.speed + "%, " + n + a / o.speed + "%, 0)" }) : e.css({ transform: "translate3d(0, " + n + a / o.speed + "%, 0)" });
        }
        return (
            (function (n, a) {
                n.data("__floatElement") ||
                    ((e = n).data("__floatElement"),
                    (function (n) {
                        o = t.extend(!0, {}, s, n, { wrapper: e });
                    })(a),
                    (function () {
                        var n,
                            e = o.wrapper,
                            s = t(window);
                        o.style && e.attr("style", o.style),
                            s.width() > 767 &&
                                ("none" == o.startPos ? (n = "") : "top" == o.startPos ? (e.css({ top: 0 }), (n = "")) : (e.css({ bottom: 0 }), (n = "-")),
                                o.transition && e.css({ transition: "ease transform 500ms" }),
                                r(n),
                                s.on("scroll", function () {
                                    r(n);
                                }));
                    })());
            })(this, n),
            this
        );
    };
});
